// LEVA Configurator â€” Library Data + FitoutManager

window._LEVA_LIB = {
  openingLibrary: {
    win: [
      { id:'OWR04001', name:'Single-Leaf 400×600',   width:400,  height:600  },
      { id:'OWR05001', name:'Single-Leaf 500×700',   width:500,  height:700  },
      { id:'OWR07501', name:'Single-Leaf 750×900',   width:750,  height:900  },
      { id:'OWR07001', name:'Single-Leaf 700×1150',  width:700,  height:1150 },
      { id:'OWR08001', name:'Single-Leaf 800×1150',  width:800,  height:1150 },
      { id:'OWR09002', name:'Single-Leaf 900×500',   width:900,  height:500  },
      { id:'OWR09001', name:'Single-Leaf 900×1350',  width:900,  height:1350 },
      { id:'OWG06001', name:'French Door 600×2590',  width:600,  height:2590 },
      { id:'OWG10001', name:'French Door 1000×2590', width:1000, height:2590 },
      { id:'OWR12001', name:'Single-Leaf 1200×1500', width:1200, height:1500 },
      { id:'OWR12002', name:'Single-Leaf 1200×2000', width:1200, height:2000 },
      { id:'OWR15001', name:'Single-Leaf 1500×1650', width:1500, height:1650 },
      { id:'OWR15002', name:'HS Sliding 1500×2590',  width:1500, height:2590 },
      { id:'OWR17001', name:'HS Sliding 1700×2590',  width:1700, height:2590 },
      { id:'OWR20001', name:'HS Sliding 2000×2590',  width:2000, height:2590 },
      { id:'OWR25001', name:'HS Sliding 2500×2590',  width:2500, height:2590 },
      { id:'OWR30001', name:'HS Sliding 3000×2590',  width:3000, height:2590 },
      { id:'OWR40001', name:'HS Sliding 4000×2590',  width:4000, height:2590 },
      { id:'OWR50001', name:'HS Sliding 5000×3390',  width:5000, height:3390 },
      { id:'OWR_FULL', name:'Full Wall',             width:0,    height:0,    fullWall:true },
      { id:'OWR78118', name:'Roof Window 780×1180',  width:780,  height:1180 },
      { id:'OWR78140', name:'Roof Window 780×1400',  width:780,  height:1400 },
      { id:'OWR11118', name:'Roof Window 1140×1180', width:1140, height:1180 },
      { id:'OWR55118', name:'Roof Window 550×1180',  width:550,  height:1180 }
    ],
    edr: [
      { id:'ODE08001', name:'Ext Door 800',     width:800,  height:2000, orient:'L' },
      { id:'ODE09001', name:'Ext Door 900',     width:900,  height:2080, orient:'L' },
      { id:'ODE18002', name:'Double Wing 1500', width:1500, height:2080, orient:'R' },
      { id:'ODA48001', name:'Garage Door 4800', width:4800, height:2080, orient:''  },
      { id:'OBD50035', name:'Barn Door 5x3.5m',  width:5000, height:3500, orient:'', barn:true }
    ],
    idr: [
      { id:'ODI06001', name:'Int Door 600',         width:600, height:1970 },
      { id:'ODI08001', name:'Int Door 800',         width:800, height:1970 },
      { id:'ODI09001', name:'Int Door 900',         width:900, height:1970 },
      { id:'ODS75002', name:'Sauna Door 750x1970',  width:750, height:1970, glazed:true }
    ]
  },
  // footprintM = shorter side in metres
  outdoor: [
    {
      id: 'GARDEN_SWING',
      name: 'Garden Swing',
      glb: 'https://cdn.shopify.com/3d/models/21748501bbf6cf83/GARDEN_SWING_GLB.glb',
      scale: 1.0,
      footprintM: 1.5,
      paper: true
    },
    {
      id: 'HUMAN',
      name: 'Human',
      glb: 'https://cdn.shopify.com/3d/models/6f65298858103b14/guy.glb',
      scale: 1.0,
      footprintM: 0.5,
      paper: true
    }
  ],
  fitouts: [
    // ── Kitchen ──
    { id:'KIT_XS',   name:'Kitchen XS',    category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_XS.png?v=1775508266',    shortSideM:1, widthM:1.8,  depthM:0.6 },
    { id:'KIT_S',    name:'Kitchen S',     category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_S.png?v=1775507719',     shortSideM:1, widthM:2.2,  depthM:0.6 },
    { id:'KIT_M',    name:'Kitchen M',     category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_M.png?v=1775507711',     shortSideM:1.2, widthM:2.8,  depthM:0.6 },
    { id:'KIT_L',    name:'Kitchen L',     category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_L.png?v=1775506850',     shortSideM:2.8, widthM:3.9,  depthM:1.9 },
    { id:'KIT_L2',   name:'Kitchen L2',    category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_L2.png?v=1775506652',    shortSideM:3.8, widthM:3.6,  depthM:3 },
    { id:'KIT_L3',   name:'Kitchen L3',    category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_L3.png?v=1775507315',    shortSideM:3.1, widthM:3.6,  depthM:2.7 },
    { id:'KIT_L4',   name:'Kitchen L4',    category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_L4.png?v=1775507418',    shortSideM:3.1, widthM:3.6,  depthM:2.7 },
    { id:'KIT_L5',   name:'Kitchen L5',    category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_L5.png?v=1775506192',    shortSideM:4.1, widthM:3.2,  depthM:3 },
    { id:'KIT_U',    name:'Kitchen U',     category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_U.png?v=1775505384',     shortSideM:3.9, widthM:3.4,  depthM:3.4 },
    { id:'KIT_U2',   name:'Kitchen U2',    category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_U2.png?v=1775505598',    shortSideM:3.7, widthM:4,  depthM:3 },
    { id:'KIT_XXL',  name:'Kitchen XXL',   category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_XXL.png?v=1775507071',   shortSideM:4.5, widthM:3.7,  depthM:2.5 },
    { id:'KIT_II',   name:'Kitchen II',    category:'kitchen',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_II.png?v=1775506368',    shortSideM:3, widthM:3.4,  depthM:2.5 },
    { id:'KIT_ISLAND',name:'Kitchen Island',category:'kitchen',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Kitchen_island.png?v=1775505851',shortSideM:1.8, widthM:1.4,  depthM:1 },
    // ── Living Room ──
    { id:'SOFA_S',   name:'Sofa S',        category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Sofa_S.png?v=1775514864',        shortSideM:1.4, widthM:2.2,  depthM:0.9 },
    { id:'SOFA_M',   name:'Sofa M',        category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Sofa_M_2.png?v=1775514877',      shortSideM:1.6, widthM:2.5,  depthM:0.9 },
    { id:'SOFA_L',   name:'Sofa L',        category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Sofa_L_1.png?v=1775514871',      shortSideM:2.1, widthM:2.5,  depthM:1.6 },
    { id:'SOFA_XL',  name:'Sofa XL',       category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Sofa_XL.png?v=1775514858',       shortSideM:3.8, widthM:3.5,  depthM:2.7 },
    { id:'SOFA_U',   name:'Sofa U',        category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Sofa_U.png?v=1775514796',        shortSideM:3.9, widthM:3.8,  depthM:3.8 },
    { id:'TEA_I',    name:'Tea Table I',   category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Coffee_table_1.png?v=1775554803', shortSideM:0.8, widthM:0.8,  depthM:0.6 },
    { id:'TEA_II',   name:'Tea Table II',  category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Coffee_table_round.png?v=1775554825',shortSideM:0.6,widthM:0.5, depthM:0.5 },
    { id:'TEA_III',  name:'Tea Table III', category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/2148329189.jpg?v=1775555264',     shortSideM:0.7, widthM:1.2,  depthM:0.7 },
    { id:'TV_I',     name:'TV Cabinet I',  category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/TV_cabinet_1.png?v=1775556755',   shortSideM:0.4, widthM:1.5,  depthM:0.35 },
    { id:'TV_II',    name:'TV Cabinet II', category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/TV_cabinet_1.png?v=1775556755',   shortSideM:0.6, widthM:2.5,  depthM:0.55 },
    { id:'TV_III',   name:'TV Cabinet III',category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/TV_cabinet_2.png?v=1775556760',   shortSideM:0.8, widthM:4.2,  depthM:0.7 },
    { id:'CHAIR_I',  name:'Chair I',       category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Sofa_chair_1.png?v=1775514789',   shortSideM:1.5, widthM:0.8,  depthM:0.8 },
    { id:'CHAIR_II', name:'Chair II',      category:'living',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Sofa_chair_2_1.png?v=1775514803', shortSideM:1, widthM:0.75, depthM:0.75 },
    // ── Dining Room ──
    { id:'DIN_T2',   name:'Table & 2',     category:'dining',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Table_2.png?v=1775559801',        shortSideM:1, widthM:1.5,  depthM:0.8 },
    { id:'DIN_T4',   name:'Table & 4',     category:'dining',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Table_4.png?v=1775559420',        shortSideM:2.3, widthM:1.5,  depthM:1.5 },
    { id:'DIN_T6',   name:'Table & 6',     category:'dining',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Table_6.png?v=1775559715',        shortSideM:2.2, widthM:2.8,  depthM:1.7 },
    { id:'DIN_T8',   name:'Table & 8',     category:'dining',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Table_8.png?v=1775559221',        shortSideM:2.1, widthM:3,  depthM:1.7 },
    { id:'DIN_R4',   name:'Round Table & 4',category:'dining',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Round_table_4.png?v=1775559719',  shortSideM:2.3, widthM:1.5,  depthM:1.5 },
    // ── Bedroom ──
    { id:'BED_S',    name:'Bed S',         category:'bedroom',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Bed_S.png?v=1775546214',          shortSideM:1.4, widthM:0.9,  depthM:2 },
    { id:'BED_M',    name:'Bed M',         category:'bedroom',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Bed_M_2.png?v=1775546464',        shortSideM:1.8, widthM:1.4,  depthM:2 },
    { id:'BED_L',    name:'Bed L',         category:'bedroom',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Bed_L_1.png?v=1775546464',        shortSideM:2, widthM:1.6,  depthM:2.1 },
    { id:'BED_XL',   name:'Bed XL',        category:'bedroom',   sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Bed_XL_1.png?v=1775546464',       shortSideM:2.2, widthM:1.8,  depthM:2.2 },
    // ── Workspace ──
    { id:'DESK_S',   name:'Workspace S',   category:'workspace', sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Workspace_S.png?v=1772523602',    shortSideM:1, widthM:1.2,  depthM:0.6 },
    { id:'DESK_M',   name:'Workspace M',   category:'workspace', sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Workspace_M.png?v=1772523607',    shortSideM:1.2, widthM:1.1,  depthM:0.9 },
    { id:'DESK_L',   name:'Workspace L',   category:'workspace', sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Workspace_L.png?v=1772522797',    shortSideM:1.2, widthM:1.25,  depthM:1.1 },
    // ── Appliances ──
    { id:'WASH',     name:'Washing Machine',category:'appliances',sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Washing_machine.png?v=1775631870',shortSideM:0.6, widthM:0.6,  depthM:0.6 },
    { id:'DRYER',    name:'Dryer',          category:'appliances',sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Dryer.png?v=1775631985',          shortSideM:0.6, widthM:0.6,  depthM:0.6 },
    // ── Wardrobe ──
    { id:'WRD_S',    name:'Wardrobe S',    category:'wardrobe',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Wardrobe_S.png?v=1775560692',     shortSideM:0.7, widthM:0.8,  depthM:0.5 },
    { id:'WRD_M',    name:'Wardrobe M',    category:'wardrobe',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Wardrobe_M.png?v=1775560696',     shortSideM:0.7, widthM:0.1,  depthM:0.5 },
    { id:'WRD_L',    name:'Wardrobe L',    category:'wardrobe',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Wardrobe_L.png?v=1775560696',     shortSideM:0.7, widthM:1.4,  depthM:0.5 },
    { id:'WRD_XL',   name:'Wardrobe XL',   category:'wardrobe',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Wardrobe_L.png?v=1775560696',     shortSideM:0.8, widthM:1.6,  depthM:0.6 },
    // ── Carpet ──
    { id:'CRP_S',    name:'Carpet S',      category:'carpet',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Carpet.png?v=1775543836',         shortSideM:1, widthM:1.4,  depthM:0.9 },
    { id:'CRP_M',    name:'Carpet M',      category:'carpet',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Carpet.png?v=1775543836',         shortSideM:1.5, widthM:2.1,  depthM:1.4 },
    { id:'CRP_L',    name:'Carpet L',      category:'carpet',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Carpet.png?v=1775543836',         shortSideM:2, widthM:2.8,  depthM:1.8 },
    { id:'CRP_XL',   name:'Carpet XL',     category:'carpet',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Carpet.png?v=1775543836',         shortSideM:2.5, widthM:3.5,  depthM:2.3 },
    { id:'CRP_RND',  name:'Carpet Round',  category:'carpet',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Carpet_round.png?v=1775544100',   shortSideM:1.5, widthM:1.5,  depthM:1.5 },
    // ── Bathroom ──
    { id:'BATH_S',   name:'Bath S',        category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Bath_tube.png?v=1775632424',      shortSideM:0.8, widthM:0.7,  depthM:1.5 },
    { id:'BATH_M',   name:'Bath M',        category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Bath_tube.png?v=1775632424',      shortSideM:0.9,widthM:0.75, depthM:1.6 },
    { id:'BATH_L',   name:'Bath L',        category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Bath_tube_round.png?v=1775632658',shortSideM:1, widthM:0.8,  depthM:1.7 },
    { id:'SHOWER_S', name:'Shower S',      category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Shower_S.png?v=1775632956',       shortSideM:0.8, widthM:0.8,  depthM:0.8 },
    { id:'SHOWER_M', name:'Shower M',      category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Shower_M.jpg?v=1775632958',       shortSideM:0.9, widthM:0.9,  depthM:0.9 },
    { id:'SHOWER_L', name:'Shower L',      category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Shower_L.jpg?v=1775632958',       shortSideM:0.9, widthM:1.6,  depthM:0.8 },
    { id:'TOILET',   name:'Toilet',        category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Toilet.png?v=1775633325',         shortSideM:0.4, widthM:0.37, depthM:0.6 },
    { id:'BIDET',    name:'Bidet',         category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Bidet.png?v=1775633323',          shortSideM:0.4, widthM:0.37, depthM:0.55 },
    { id:'SINK_S',   name:'Sink S',        category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Sink.png?v=1775633454',           shortSideM:0.4,widthM:0.45, depthM:0.55 },
    { id:'SINK_M',   name:'Sink M',        category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Sink.png?v=1775633454',           shortSideM:0.5,widthM:0.55, depthM:0.6 },
    { id:'SINK_D',   name:'Double Sink',   category:'bathroom',  sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Double_sink.png?v=1775633576',    shortSideM:0.5, widthM:1.5,  depthM:0.55 },
    // ── Cars / Others ──
    { id:'CAR_S',    name:'Car S',         category:'others',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Car_S.png?v=1772524128',          shortSideM:2.2, widthM:1.7,  depthM:3.5 },
    { id:'CAR_M',    name:'Car M',         category:'others',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Car_M.png?v=1772448679',          shortSideM:2.5, widthM:1.9,  depthM:4.1 },
    { id:'CAR_L',    name:'Car L',         category:'others',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Car_L.png?v=1772525485',          shortSideM:2.8, widthM:2.1,  depthM:4.7 },
    { id:'CAR_XL',   name:'Car XL',        category:'others',    sprite2d:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Car_XL.png?v=1772490269',         shortSideM:3, widthM:2.4,  depthM:5.4 }
  ]
};

// â”€â”€â”€ FitoutManager â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
window.FitoutManager = {
  _items: [],
  _dragging: null,
  _isDraggingFitout: false,
  init() { this._isDraggingFitout=false; this._bindEX(); this._bindDrag(); document.getElementById('cv5-fo-close')?.addEventListener('click',()=>{this._activeEntry=null;this._closeFitoutModal();}); },
  _bindEX() {
    document.getElementById('cv5-ins-ex')?.addEventListener('click', () => {
      const car=document.getElementById('cv5-ins-carousel'),head=document.getElementById('cv5-ins-car-head'),list=document.getElementById('cv5-ins-car-list');
      if(!car||!head||!list)return;
      head.textContent='EXTERIOR'; list.innerHTML='';
      (window._LEVA_LIB?.outdoor||[]).forEach(item=>{
        const el=document.createElement('div'); el.className='cv5-ins-item';
        el.innerHTML=`<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><rect x="4" y="4" width="20" height="20" rx="3" stroke="#6a9" stroke-width="1.5" fill="#e8f5ec"/><path d="M14 8v12M8 14h12" stroke="#6a9" stroke-width="1.2"/></svg><div class="cv5-ins-item-info"><div class="cv5-ins-item-name">${item.name}</div><div class="cv5-ins-item-dims">outdoor</div></div>`;
        el.addEventListener('click',()=>this._placeItem(item)); list.appendChild(el);
      });
      car.classList.add('open'); car.style.display='flex';
    });
  },
  _placeItem(item) {
    const lm=window.LandManager,cx=(lm.xMin+lm.xMax)/2,cz=(lm.zMin+lm.zMax)/2;
    const loader=new window.GLTFLoader(),draco=new window.DRACOLoader();
    draco.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.4.1/');
    loader.setDRACOLoader(draco);
    const scale=(item.scale||1)*window.CONFIG.importScale;
    loader.load(item.glb,gltf=>{
      const root=gltf.scene;
      root.scale.setScalar(scale); root.position.set(cx,lm.baseY,cz);
      window.Engine.scene.add(root); root.updateMatrixWorld(true);
      if(item.footprintM){
        const sz=new THREE.Box3().setFromObject(root).getSize(new THREE.Vector3());
        const sh=Math.min(sz.x,sz.z);
        if(sh>0.001)root.scale.multiplyScalar(item.footprintM/sh);
        root.updateMatrixWorld(true);
      }
      root.userData={isFitout:true,fitoutId:item.id,fitoutName:item.name};
      root.traverse(o=>{
        if(!o.isMesh)return; o.userData.isFitout=true; o.castShadow=true; o.receiveShadow=true;
        if(item.paper){
          o.material=new THREE.MeshStandardMaterial({color:0xfaf9f7,roughness:0.85,metalness:0});
          o.add(new THREE.LineSegments(new THREE.EdgesGeometry(o.geometry,window.CONFIG.edgeThreshold||15),new THREE.LineBasicMaterial({color:0xcccccc})));
        }
      });
      // Enable shadow casting only in 3D
      const E=window.Engine,S3=window.STATE;
      if(E._sun&&window.CONFIG.shadowOpacity>0&&S3?.view!=='2d-top'){
        E._sun.castShadow=true;
        E.renderer.shadowMap.enabled=true;
      }
      // Make floor meshes opaque so they receive shadows, same color as background
      E.scene.traverse(o=>{
        if(o.isMesh&&o.userData.isFloorGenerated&&o.material){
          o.receiveShadow=true;
          o.material.transparent=false;
          o.material.opacity=1;
          o.material.shadowSide=THREE.FrontSide;
          o.material.needsUpdate=true;
        }
      });
      this._items.push({obj:root,item});
      this._buildPlanMesh(root,item,cx,cz,lm.baseY);
      if(window.SectionCut?.enabled)window.SectionCut._apply();
      window.Engine.fitCamera();
    },undefined,err=>{
      const d=document.createElement('div');
      d.style.cssText='position:fixed;top:10px;left:50%;transform:translateX(-50%);background:#900;color:#fff;padding:8px 16px;border-radius:6px;z-index:99999;font:12px monospace;';
      d.textContent='GLB: '+err.message; document.body.appendChild(d); setTimeout(()=>d.remove(),6000);
    });
    const car=document.getElementById('cv5-ins-carousel');
    if(car){car.style.display='none';car.classList.remove('open');}
  },
  _activeEntry: null,
  _buildPlanMesh(root,item,cx,cz,baseY){
    const entry=this._items.find(i=>i.obj===root)||this._items[this._items.length-1];
    entry.rotY=0;
    this._setActiveEntry(entry);
  },
  _setActiveEntry(entry){
    this._activeEntry=entry;
    if(entry) this._openFitoutModal(entry);
    else this._closeFitoutModal();
  },
  _hideAllControls(){
    this._activeEntry=null;
    this._closeFitoutModal();
  },
  _reprojectFitoutLabels(){
    if(this._activeEntry) this._updateFitoutDims();
  },
  _bindDrag(){
    if(this._dragBound)return; this._dragBound=true;
    const cv=document.getElementById('cv5-canvas'),rc=new THREE.Raycaster();
    if(!cv){setTimeout(()=>{this._dragBound=false;this._bindDrag();},300);return;}
    const plane=new THREE.Plane(new THREE.Vector3(0,1,0),0);
    let dragging=null,offset=new THREE.Vector3();
    const gm=e=>{const r=cv.getBoundingClientRect();return new THREE.Vector2(((e.clientX-r.left)/r.width)*2-1,-((e.clientY-r.top)/r.height)*2+1);};
    let downEntry=null,downX=0,downY=0,moved=false;
    cv.addEventListener('pointerdown',e=>{
      if(window.STATE?.view!=='2d-top')return;
      if(document.getElementById('v4-modal-fitout')?.contains(e.target))return;
      rc.setFromCamera(gm(e),window.Engine.orthoCamera);
      const hits=rc.intersectObjects(this._items.map(i=>i.obj).filter(Boolean),true);
      if(!hits.length)return;
      const entry=this._items.find(i=>i.obj&&(i.obj===hits[0].object||i.obj.getObjectById?.(hits[0].object.id)));
      if(!entry)return;
      e.stopPropagation();
      downEntry=entry; moved=false; downX=e.clientX; downY=e.clientY;
      dragging=entry.obj;
      plane.constant=-dragging.position.y;
      const pt=new THREE.Vector3(); rc.ray.intersectPlane(plane,pt);
      offset.copy(dragging.position).sub(pt);
      this._openFitoutModal(entry);
      this._isDraggingFitout=true;
      window.Engine.orthoControls.enabled=false; cv.setPointerCapture(e.pointerId);
    },true);
    cv.addEventListener('pointermove',e=>{
      if(!dragging)return;
      const dx=e.clientX-downX,dy=e.clientY-downY;
      if(!moved&&Math.sqrt(dx*dx+dy*dy)>5)moved=true;
      if(!moved)return;
      rc.setFromCamera(gm(e),window.Engine.orthoCamera);
      const pt=new THREE.Vector3(); if(!rc.ray.intersectPlane(plane,pt))return;
      dragging.position.set(pt.x+offset.x,dragging.position.y,pt.z+offset.z);
      cv.style.cursor='grabbing';
    });
    cv.addEventListener('pointerup',()=>{
      if(!dragging)return;
      dragging=null;
      this._isDraggingFitout=false;
      this._justDroppedFitout=true;
      window.Engine.orthoControls.enabled=true; cv.style.cursor='';
      downEntry=null;
    });
  },
  _fmtDim(m){
    if(window.STATE?.isMetric!==false) return m.toFixed(2)+' m';
    return (m*3.28084).toFixed(1)+"'";
  },
  _openFitoutModal(entry){
    this._activeEntry=entry;
    const item=entry.item;
    const title=document.getElementById('cv5-fo-title');
    const dims=document.getElementById('cv5-fo-dims');
    if(title) title.textContent=(item.name||item.id||'').toUpperCase();
    this._updateFitoutDims();
    const ro=document.getElementById('cv5-fo-rotate');
    const mi=document.getElementById('cv5-fo-mirror');
    const del=document.getElementById('cv5-fo-delete');
    if(ro){ro.onclick=null;ro.onclick=e=>{e.stopPropagation();entry.rotY=((entry.rotY||0)+Math.PI/2)%(Math.PI*2);entry.obj.rotation.y=entry.rotY;};}
    if(mi){mi.onclick=null;mi.onclick=e=>{e.stopPropagation();entry.obj.scale.x*=-1;};}
    if(del){del.onclick=null;del.onclick=e=>{
      e.stopPropagation();
      window.Engine.scene.remove(entry.obj);
      const idx=this._items.indexOf(entry);if(idx>=0)this._items.splice(idx,1);
      if(this._activeEntry===entry)this._activeEntry=null;
      this._closeFitoutModal();
    };}
    this._openFitoutModalNow();
  },
  _openFitoutModalNow(){
    const modal=document.getElementById('v4-modal-fitout');
    if(!modal)return;
    try{const p=JSON.parse(sessionStorage.getItem('leva_modal_v4-modal-fitout')||'null');if(p){modal.style.left=p.left;modal.style.top=p.top;modal.style.right='auto';modal.style.bottom='auto';}}catch(e){}
    modal.classList.add('open');
  },
  _closeFitoutModal(){
    document.getElementById('v4-modal-fitout')?.classList.remove('open');
  },
  _updateFitoutDims(){
    if(!this._activeEntry)return;
    const dims=document.getElementById('cv5-fo-dims');
    if(!dims)return;
    const item=this._activeEntry.item;
    const _id=item.id||'';
    if(_id.indexOf('sauna_')===0){
      dims.textContent='';
      dims.style.display='none';
      return;
    }
    dims.style.display='';
    const wM=item.widthM||item.shortSideM||1;
    const dM=item.depthM||item.shortSideM||1;
    dims.textContent=this._fmtDim(wM)+' × '+this._fmtDim(dM);
  },
  _pendingFloorMesh: null,
  openFitoutMode(floorMesh){
    this._pendingFloorMesh=floorMesh||null;
    const assetTabs=document.querySelector('#v4-modal-assets .v4-asset-tabs');
    const wPanel=document.getElementById('v4-assets-windows');
    const dPanel=document.getElementById('v4-assets-doors');
    const fPanel=document.getElementById('v4-fitout-panel');
    if(assetTabs)assetTabs.style.display='none';
    if(wPanel)wPanel.style.display='none';
    if(dPanel)dPanel.style.display='none';
    if(fPanel){fPanel.style.display='flex';this._populateFitoutGrid('all');}
  },
  _resetAssetModal(){
    const assetTabs=document.querySelector('#v4-modal-assets .v4-asset-tabs');
    const wPanel=document.getElementById('v4-assets-windows');
    const dPanel=document.getElementById('v4-assets-doors');
    const fPanel=document.getElementById('v4-fitout-panel');
    if(assetTabs)assetTabs.style.display='';
    if(wPanel)wPanel.style.display='';
    if(fPanel)fPanel.style.display='none';
    this._pendingFloorMesh=null;
  },
  _populateFitoutGrid(cat){
    const pills=document.getElementById('v4-fitout-pills');
    const grid=document.getElementById('v4-fitout-grid');
    if(!pills||!grid)return;
    const cats=['all','kitchen','living','dining','bedroom','bathroom','workspace','appliances','wardrobe','carpet','others'];
    const labels={all:'ALL',kitchen:'KITCHEN',living:'LIVING ROOM',dining:'DINING',bedroom:'BEDROOM',bathroom:'BATHROOM',workspace:'WORKSPACE',appliances:'APPLIANCES',wardrobe:'WARDROBE',carpet:'CARPET',others:'OTHERS'};
    pills.innerHTML='';
    cats.forEach(c=>{
      const btn=document.createElement('button');
      btn.className='v4-fitout-pill'+(c===cat?' active':'');
      btn.textContent=labels[c];
      btn.addEventListener('click',()=>this._populateFitoutGrid(c));
      pills.appendChild(btn);
    });
    const items=(window._LEVA_LIB?.fitouts||[]).filter(i=>cat==='all'||i.category===cat);
    grid.innerHTML='';
    if(!items.length){grid.innerHTML='<div style="grid-column:1/-1;font-size:10px;color:#aaa;text-align:center;padding:16px 0">No items</div>';return;}
    items.forEach(item=>{
      const card=document.createElement('div');
      card.className='v4-fitout-card';
      const img=document.createElement('img');
      img.className='v4-fitout-thumb';
      img.src=item.sprite2d||'';
      img.alt=item.name;
      img.loading='lazy';
      const lbl=document.createElement('span');
      lbl.textContent=item.name;
      card.appendChild(img);
      card.appendChild(lbl);
      card.addEventListener('click',()=>this._placeSprite(item));
      grid.appendChild(card);
    });
  },
  _placeSprite(item){
    const lm=window.LandManager;
    let cx=(lm.xMin+lm.xMax)/2,cz=(lm.zMin+lm.zMax)/2,baseY=lm.baseY;
    if(this._pendingFloorMesh){
      const box=new THREE.Box3().setFromObject(this._pendingFloorMesh);
      const c=box.getCenter(new THREE.Vector3());
      cx=c.x;cz=c.z;baseY=box.min.y;
    }
    new THREE.TextureLoader().load(item.sprite2d,tex=>{
      tex.colorSpace=THREE.SRGBColorSpace;
      const aspect=tex.image.width/tex.image.height,shortM=item.shortSideM||1.0;
      const planeW=aspect>=1?shortM*aspect:shortM,planeD=aspect>=1?shortM:shortM/aspect;
      const geo=new THREE.PlaneGeometry(planeW,planeD);geo.rotateX(-Math.PI/2);
      const mat=new THREE.MeshBasicMaterial({map:tex,transparent:true,alphaTest:0.05,depthWrite:false,side:THREE.DoubleSide});
      const mesh=new THREE.Mesh(geo,mat);
      mesh.position.set(cx,baseY+0.025,cz);
      mesh.renderOrder=5;
      mesh.visible=(window.STATE?.view==='2d-top');
      mesh.userData={isFitout:true,isSprite2D:true,fitoutId:item.id,fitoutName:item.name};
      window.Engine.scene.add(mesh);
      this._items.push({obj:mesh,item});
      this._buildPlanMesh(mesh,item,cx,cz,baseY);
    });
    document.getElementById('v4-modal-assets')?.classList.remove('open');
    this._resetAssetModal();
  },
  onViewChange(){
    const is2D=window.STATE?.view==='2d-top';
    this._items.forEach(i=>{
      if(!i.obj)return;
      const isOutdoor=!!(window._LEVA_LIB?.outdoor||[]).find(o=>o.id===i.item?.id);
      i.obj.visible=isOutdoor?true:is2D;
    });
    if(!is2D) this._closeFitoutModal();
  }
};
// Inject insert button tooltip CSS (right-side tooltips for left-panel buttons)
(function(){
  const s=document.createElement('style');
  s.textContent='#cv5-ins-win[data-tip]::after,#cv5-ins-edr[data-tip]::after,#cv5-ins-idr[data-tip]::after,#cv5-ins-ex[data-tip]::after,#v4-btn-layout[data-tip]::after{content:attr(data-tip)!important;display:none;position:absolute;left:calc(100% + 8px)!important;right:auto!important;top:50%!important;transform:translateY(-50%)!important;background:#111;color:#fff;font-size:11px;font-weight:600;padding:4px 8px;border-radius:6px;white-space:nowrap;pointer-events:none;z-index:9999;}#cv5-ins-win[data-tip]:hover::after,#cv5-ins-edr[data-tip]:hover::after,#cv5-ins-idr[data-tip]:hover::after,#cv5-ins-ex[data-tip]:hover::after,#v4-btn-layout[data-tip]:hover::after{display:block;}';
  document.head.appendChild(s);
})();
(function(){
  const s=document.createElement('style');
  s.textContent='.v4-fitout-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;overflow-y:auto;max-height:320px;padding-right:2px;}.v4-fitout-card{display:flex;flex-direction:column;align-items:center;gap:4px;padding:6px 4px 5px;border-radius:8px;border:1.5px solid transparent;background:#f4f4f4;cursor:pointer;text-align:center;transition:border-color 0.15s,background 0.15s;}.v4-fitout-card:hover{border-color:var(--accent,#D3212D);background:#fff;}.v4-fitout-thumb{width:56px;height:56px;object-fit:contain;border-radius:4px;background:#fff;display:block;}.v4-fitout-card span{font-size:9px;font-weight:600;color:#555;line-height:1.2;word-break:break-word;}';
  document.head.appendChild(s);
})();

// Hide any tooltip on + insert button
(function(){
  const s=document.createElement('style');
  s.textContent='#cv5-insert-btn::before,#cv5-insert-btn::after{display:none!important;}';
  document.head.appendChild(s);
})();

// â”€â”€â”€ OpeningInsert â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
window.OpeningInsert = {
  _activeType: null,
  _wallType: null,

  _allowedFor(wallType) {
    if (wallType === 'ext') return ['win','edr','barn'];
    if (wallType === 'int') return ['idr'];
    if (wallType === 'iw')  return ['idr'];
    return [];
  },

  _sillHeight(item, t) {
    if (t === 'edr' || t === 'idr' || t === 'barn') return 0;
    if (item.fullWall) return 0;
    const name = (item.name || '').toLowerCase();
    if (name.includes('french') || name.includes('sliding') || name.includes('hs ') || name.includes('full')) return 0;
    return 0.9;
  },

  init() {
    const btn   = document.getElementById('cv5-insert-btn');
    const panel = document.getElementById('cv5-insert-panel');
    const car   = document.getElementById('cv5-ins-carousel');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const open = panel.classList.toggle('open');
      btn.classList.toggle('open', open);
      if (!open) { car.style.display='none'; this._activeType = null; }
    });
    ['win','edr','idr','barn'].forEach(t => {
      document.getElementById('cv5-ins-' + t)?.addEventListener('click', () => {
        if (document.getElementById('cv5-ins-' + t)?.style.pointerEvents === 'none') return;
        this._activeType = t;
        this._renderCarousel(t);
        car.classList.add('open'); car.style.display='flex';
      });
    });
    document.addEventListener('pointerdown', e => {
      if (car.style.display !== 'flex') return;
      const wrap = document.getElementById('cv5-insert-wrap');
      if (wrap && !wrap.contains(e.target)) {
        panel.style.maxHeight='0'; panel.style.opacity='0'; panel.style.pointerEvents='none';
        btn.classList.remove('open');
        car.style.display='none';
        this._activeType = null;
      }
    }, true);
  },

  _updateButtons() {
    const allowed = this._allowedFor(this._wallType);
    ['win','edr','idr','barn'].forEach(t => {
      const el = document.getElementById('cv5-ins-' + t); if (!el) return;
      const on = allowed.includes(t);
      el.style.opacity = on ? '1' : '0.3';
      el.style.pointerEvents = on ? '' : 'none';
      if (!on && this._activeType === t) {
        document.getElementById('cv5-ins-carousel').style.display='none';
        this._activeType = null;
      }
    });
    const ex = document.getElementById('cv5-ins-ex');
    if (ex) { ex.style.opacity='1'; ex.style.pointerEvents=''; }
  },

  _renderCarousel(t) {
    const head = document.getElementById('cv5-ins-car-head');
    const list = document.getElementById('cv5-ins-car-list');
    if (!head || !list) return;
    head.textContent = { win:'WINDOWS', edr:'EXT DOORS', idr:'INT DOORS' }[t] || t;
    const _lib = (window._LEVA_LIB?.openingLibrary) || {};
    const items = _lib[t] || [];
    list.innerHTML = '';
    items.forEach(item => {
      const el = document.createElement('div');
      el.className = 'cv5-ins-item';
      const svg = t === 'win'
        ? `<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><rect x="2" y="2" width="24" height="24" rx="2" stroke="#ccc" stroke-width="1.5" fill="#e8f4ff"/><line x1="14" y1="2" x2="14" y2="26" stroke="#ccc" stroke-width="1"/><line x1="2" y1="14" x2="26" y2="14" stroke="#ccc" stroke-width="1"/></svg>`
        : `<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><rect x="5" y="2" width="18" height="24" rx="2" stroke="#ccc" stroke-width="1.5" fill="#fff5e0"/><circle cx="20" cy="15" r="1.5" fill="#ccc"/></svg>`;
      const _dimText = item.fullWall ? 'Auto-size to wall' : `${item.width}×${item.height} mm`;
      el.innerHTML = `${svg}<div class="cv5-ins-item-info"><div class="cv5-ins-item-name">${item.name}</div><div class="cv5-ins-item-dims">${_dimText}</div></div>`;
      el.addEventListener('click', () => this._insert(item, t));
      list.appendChild(el);
    });
  },

  _insert(item, t) {
    const S = window.STATE, w = S?.selectedWall;
    if (!w) return;
    const allowed = this._allowedFor(w.type);
    if (!allowed.includes(t)) return;
    const id = 'vop_' + Date.now();
    if (item.barn) t = 'barn';
    // Full wall window: auto-size to selected wall span (full width, no margin)
    if (item.fullWall) {
      const _r = (S.extFloorRanges||{})[w.fl];
      const _wallH = _r ? Math.max(0.5, _r.max - _r.min) : 2.59;
      const _dx = w.B.x - w.A.x, _dz = w.B.z - w.A.z;
      const _wallLen = Math.sqrt(_dx*_dx + _dz*_dz);
      item = Object.assign({}, item, {
        width: Math.max(500, Math.round(_wallLen * 1000)),
        height: Math.round(_wallH * 1000)
      });
    }
    if (w.type === 'iw') {
      const part = w.iwPartRef; if (!part) return;
      S.virtualOpenings.push({
        id, type: t, wallType:'iw', iwPartRef:part,
        A:{x:part.wallA.x,z:part.wallA.z}, B:{x:part.wallB.x,z:part.wallB.z},
        fl:w.fl, tFrac:0.5, width:item.width/1000, height:item.height/1000, sillHeight:0,
        glazed: !!item.glazed
      });
      window.IntWallParser?._rebuildHolesForPart(part);
      if(window._applyWindowSplits) window._applyWindowSplits();
      if(window.OpeningMeshBuilder) window.OpeningMeshBuilder.build();
} else {
    // For full wall window: height = global eave (rectangular part), glass fill covers gable triangle above
    let _winHeight = item.height/1000;
    if (item.fullWall) {
      const _baseY = (S.extFloorRanges||{})[w.fl]?.min ?? 0;
      const RB = window.RoofBuilder;
      const _eaveY = (RB && RB._currentEaveY !== undefined) ? RB._currentEaveY : ((S.extFloorRanges||{})[w.fl]?.max ?? 3);
      _winHeight = Math.max(0.5, _eaveY - _baseY);
    }
    const _newVo = {
      id, type: t, wallType: w.type,
      A: {x:w.A.x,z:w.A.z}, B: {x:w.B.x,z:w.B.z},
      fl: w.fl, tFrac: 0.5, wallIdx: w.wallIdx, partRef: w.partRef,
      width: item.width/1000, height: _winHeight,
      sillHeight: this._sillHeight(item, t),
      _isGew: !!item.fullWall,
      glazed: !!item.glazed
    };
    S.virtualOpenings.push(_newVo);
    if (w.type==='ext' && window.ExtWallParser) window.ExtWallParser.rebuildFloor(w.fl);
    else if (w.type==='int' && window.IntPartitionParser) window.IntPartitionParser._rebuildGLB();
    if (window._applyWindowSplits) window._applyWindowSplits();
    if (window.OpeningMeshBuilder) window.OpeningMeshBuilder.build();
  }
    const _p=document.getElementById('cv5-insert-panel');
    if(_p){_p.style.maxHeight='0';_p.style.opacity='0';_p.style.pointerEvents='none';}
    document.getElementById('cv5-insert-btn')?.classList.remove('open');
    const _c=document.getElementById('cv5-ins-carousel'); if(_c)_c.style.display='none';
    this._activeType = null;
  },

  setSelectedWall(wallData) {
    const S = window.STATE; if(S) S.selectedWall = wallData;
    this._wallType = wallData ? wallData.type : null;
    const btn = document.getElementById('cv5-insert-btn');
    if (btn) btn.classList.toggle('ready', !!wallData);
    this._updateButtons();
    if (wallData) {
      const panel = document.getElementById('cv5-insert-panel');
      const car   = document.getElementById('cv5-ins-carousel');
      if (panel) { panel.classList.add('open'); btn?.classList.add('open'); }
      if (car) { car.style.display='none'; car.classList.remove('open'); }
      this._activeType = null;
    }
  }
};

// â”€â”€â”€ OpeningDrag â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
window.CornerDrag = {
  _handles:[],_dragging:null,_cornerIdx:-1,_dragFloor:null,_wallAxis:null,_origNodes:null,_startPt:null,
  build(){this._handles=[];if(!STATE.extCorners||!Object.keys(STATE.extCorners).length)return;const floors=Object.keys(STATE.extCorners).map(Number).sort((a,b)=>a-b);floors.forEach(fl=>{const corners=STATE.extCorners[fl]||[],n=corners.length;corners.forEach((_,idx)=>{this._handles.push({floorNum:fl,wallIdx:idx,cornerIdxA:idx,cornerIdxB:(idx+1)%n});});});},
  setVisibility(){},
  _reprojectHandles(){if(STATE.view!=='2d-top')return;if(typeof UI!=='undefined')UI.refreshDimLabels();},
  _activeFloor(){if(!SectionCut.enabled)return STATE.guiderFloor;const worldY=STATE.modelMinY+(SectionCut.heightCm/100),ranges=STATE.extFloorRanges||{},floors=Object.keys(ranges).map(Number).sort((a,b)=>a-b);for(const fl of floors){const r=ranges[fl];if(worldY>=r.min-0.05&&worldY<=r.max+0.05)return fl;}return worldY>(ranges[floors[floors.length-1]]?.max??0)?floors[floors.length-1]:STATE.guiderFloor;},
  bindDrag(){
    const cv=document.getElementById('cv5-canvas'),rc=new THREE.Raycaster(),floorPlane=new THREE.Plane(new THREE.Vector3(0,1,0),0);
    const getMouse=e=>{const r=cv.getBoundingClientRect();return new THREE.Vector2(((e.clientX-r.left)/r.width)*2-1,-((e.clientY-r.top)/r.height)*2+1);};
    cv.addEventListener('pointerdown',e=>{
      if(STATE.view!=='2d-top')return;
      if(typeof FloorRadial!=='undefined')FloorRadial.close();
      if(typeof FitoutManager!=='undefined')FitoutManager._closeFitoutModal();
      rc.setFromCamera(getMouse(e),Engine.orthoCamera);
      const hits=rc.intersectObjects(Engine.scene.children,true).filter(h=>h.object.userData.isExtGenerated&&!h.object.userData.isCornerBlock);
      if(!hits.length)return;
      const mesh=hits[0].object,fl=mesh.userData.floorNum,wIdx=mesh.userData.wallIdx;
      if(fl===undefined||wIdx===undefined)return;
      const _wallAxis=mesh.userData.axis||(()=>{const corners=STATE.extCorners[fl]||[],A=corners[wIdx],B=corners[(wIdx+1)%corners.length];if(!A||!B)return'x';return Math.abs(B.x-A.x)>=Math.abs(B.z-A.z)?'x':'z';})();
      this._wallAxis=_wallAxis;this._dragging={floorNum:fl,wallIdx:wIdx,cornerIdxA:wIdx};this._cornerIdx=wIdx;this._dragFloor=fl;
      Engine.orthoControls.enabled=false;Engine.controls.enabled=false;e.preventDefault();e.stopPropagation();
      const yW=(STATE.extFloorRanges?.[fl]?.min??0);floorPlane.constant=-yW;
      rc.setFromCamera(getMouse(e),Engine.orthoCamera);this._startPt=new THREE.Vector3();rc.ray.intersectPlane(floorPlane,this._startPt);
      this._origNodes = {};
      WallGraph.nodes.forEach(n => { this._origNodes[n.id] = {x:n.x, z:n.z}; });
      cv.style.cursor='grabbing'; cv.setPointerCapture(e.pointerId);
      STATE.isDragging = true;
      const _corners = STATE.extCorners[fl]||[];
      const _wA = _corners[wIdx], _wB = _corners[(wIdx+1)%_corners.length];
      if (_wA && _wB && typeof OpeningInsert !== 'undefined') {
        OpeningInsert.setSelectedWall({ type:'ext', A:_wA, B:_wB, fl, axis:_wallAxis, wallIdx: wIdx });
        if (typeof OpeningEditor !== 'undefined') OpeningEditor.close();
      }
    });
    cv.addEventListener('pointermove',e=>{if(this._dragging)return;if(STATE.view!=='2d-top')return;rc.setFromCamera(getMouse(e),Engine.orthoCamera);const hits=rc.intersectObjects(Engine.scene.children,true).filter(h=>h.object.userData.isExtGenerated&&!h.object.userData.isCornerBlock);cv.style.cursor=hits.length?'grab':'';});
    cv.addEventListener('pointermove',e=>{
      if(!this._dragging)return;
      rc.setFromCamera(getMouse(e),Engine.orthoCamera);const pt=new THREE.Vector3();
      const yW=(STATE.extFloorRanges?.[this._dragFloor]?.min??0);floorPlane.constant=-yW;
      if(!rc.ray.intersectPlane(floorPlane,pt))return;
      const rawDX=pt.x-this._startPt.x,rawDZ=pt.z-this._startPt.z;
      const moveX=this._wallAxis==='z',rawD=moveX?rawDX:rawDZ;
      if(!this._origNodes) return;
      const orig = this._origNodes;
      const TOL = 0.002;
      const extSegs = WallGraph.segments.filter(s => s.type==='ext' && s.fl===this._dragFloor);
      const dragSeg = extSegs.find(s => {
        const iA = parseInt(s.nA.id.split('_n')[1]);
        return iA === this._cornerIdx;
      });
      if (!dragSeg) return;
      const _refA = moveX ? orig[dragSeg.nA.id]?.x : orig[dragSeg.nA.id]?.z;
      const _refB = moveX ? orig[dragSeg.nB.id]?.x : orig[dragSeg.nB.id]?.z;
      if (_refA == null) return;
      const snapStep = (moveX ? CONFIG.stepX : CONFIG.stepZ) / 1000;
      let clamped = Math.round(rawD / snapStep) * snapStep;
      (STATE.extWallMeshes[this._dragFloor]||[]).forEach(wm => {
        if(wm.userData.isCornerBlock) return;
        const wmOrigLenMm = STATE.wallOrigLengths[this._dragFloor+'_'+wm.userData.wallIdx];
        const wmDragLimMm = wm.userData.dragLimMm;
        if(!wmOrigLenMm||!wmDragLimMm) return;
        const segW = extSegs.find(s => {
          const iA = parseInt(s.nA.id.split('_n')[1]);
          return iA === wm.userData.cornerIdxA;
        });
        if(!segW) return;
        const wmA = orig[segW.nA.id], wmB = orig[segW.nB.id];
        if(!wmA||!wmB) return;
        const aCoord=moveX?wmA.x:wmA.z, bCoord=moveX?wmB.x:wmB.z;
        const aIn=Math.abs(aCoord-_refA)<TOL||Math.abs(aCoord-_refB)<TOL;
        const bIn=Math.abs(bCoord-_refA)<TOL||Math.abs(bCoord-_refB)<TOL;
        if(!aIn&&!bIn) return;
        if(aIn===bIn) return;
        const nAx=wmA.x+(aIn&&moveX?clamped:0), nAz=wmA.z+(aIn&&!moveX?clamped:0);
        const nBx=wmB.x+(bIn&&moveX?clamped:0), nBz=wmB.z+(bIn&&!moveX?clamped:0);
        const newLenMm=Math.sqrt((nBx-nAx)**2+(nBz-nAz)**2)*1000;
        const minLen=wmOrigLenMm-wmDragLimMm, maxLen=wmOrigLenMm+wmDragLimMm;
        if(newLenMm>=minLen&&newLenMm<=maxLen) return;
        let lo=0, hi=clamped, best=0;
        for(let iter=0;iter<20;iter++){
          const mid=(lo+hi)/2;
          const tAx=wmA.x+(aIn&&moveX?mid:0), tAz=wmA.z+(aIn&&!moveX?mid:0);
          const tBx=wmB.x+(bIn&&moveX?mid:0), tBz=wmB.z+(bIn&&!moveX?mid:0);
          const tLen=Math.sqrt((tBx-tAx)**2+(tBz-tAz)**2)*1000;
          if(tLen>=minLen&&tLen<=maxLen){best=mid;lo=mid;}else hi=mid;
        }
        if(Math.abs(best)<Math.abs(clamped)) clamped=best;
      });

      // Clamp EXT drag so it cannot pass through INT walls parallel to the dragged EXT face
      // moveX=true → EXT face runs along Z → parallel INT have axis='z', their coord is mp.x
      // moveX=false → EXT face runs along X → parallel INT have axis='x', their coord is mp.z
      if(typeof IntWallParser!=='undefined') {
        const _thickExt = (typeof ExtWallParser!=='undefined'&&ExtWallParser._thickW)||0.25;
        const _thickInt = CONFIG.thickIntMm/1000;
        const _minGap = _thickExt/2 + _thickInt/2;
        const _refCoord = moveX ? orig[dragSeg.nA.id]?.x : orig[dragSeg.nA.id]?.z;
        if(_refCoord != null) {
          IntWallParser._parts.forEach(p => {
            if(!p.mesh) return;
            if(p.mesh.userData.floorNum !== this._dragFloor) return;
            // Parallel to dragged EXT face = perpendicular to drag direction
            if(moveX && p.mesh.userData.axis !== 'z') return;
            if(!moveX && p.mesh.userData.axis !== 'x') return;
            // Coord along drag axis
            const _intCoord = moveX ? p.mesh.position.x : p.mesh.position.z;
            if(clamped > 0 && _intCoord > _refCoord) {
              const _maxDelta = _intCoord - _refCoord - _minGap;
              if(_maxDelta < clamped) clamped = Math.max(0, _maxDelta);
            } else if(clamped < 0 && _intCoord < _refCoord) {
              const _maxDelta = _intCoord - _refCoord + _minGap;
              if(_maxDelta > clamped) clamped = Math.min(0, _maxDelta);
            }
          });
        }
      }

      const movedExt = new Set();
      Object.keys(STATE.extCorners).forEach(flStr => {
        const flN = parseInt(flStr);
        const flSegs = WallGraph.segments.filter(s => s.type==='ext' && s.fl===flN);
        [dragSeg.nA, dragSeg.nB].forEach(refNode => {
          const refCoord = moveX ? orig[refNode.id]?.x : orig[refNode.id]?.z;
          if(refCoord == null) return;
          WallGraph.nodes
            .filter(n => n.type==='ext' && n.fl===flN && !movedExt.has(n.id))
            .forEach(n => {
              const o = orig[n.id]; if(!o) return;
              const c = moveX ? o.x : o.z;
              if(Math.abs(c - refCoord) < TOL) {
                n.x = o.x + (moveX?clamped:0);
                n.z = o.z + (moveX?0:clamped);
                movedExt.add(n.id);
              }
            });
        });
        ExtWallParser.rebuildFloor(flN);
      });

      if(typeof IntPartitionParser!=='undefined' && IntPartitionParser._partitions?.length) {
        IntPartitionParser._partitions.forEach(q => {
          let changed = false;
          [q.nA, q.nB].forEach(node => {
            if(!node || !node.parent || node.parent.type !== 'ext') return;
            const o = orig[node.id]; if(!o) return;
            const seg = node.parent.seg;
            // Only update if the parent segment's endpoints were actually moved by this drag
            if(!movedExt.has(seg.nA.id) && !movedExt.has(seg.nB.id)) return;
            const oA = orig[seg.nA.id], oB = orig[seg.nB.id];
            if(!oA || !oB) return;
            const wAxis = node.parent.axis;
            if(wAxis === 'x') {
              const origZ = (oA.z + oB.z) / 2;
              const curZ  = (seg.nA.z + seg.nB.z) / 2;
              const dz = curZ - origZ;
              if(Math.abs(dz) > 0.0001) { node.z = o.z + dz; changed = true; }
            } else {
              const origX = (oA.x + oB.x) / 2;
              const curX  = (seg.nA.x + seg.nB.x) / 2;
              const dx = curX - origX;
              if(Math.abs(dx) > 0.0001) { node.x = o.x + dx; changed = true; }
            }
          });
          if(changed) {
            IntPartitionParser._syncFromNodes(q);
              }
        });
      }
      if(typeof IntPartitionParser!=='undefined' && IntPartitionParser._partitions?.length){
        const nodeMargin = CONFIG.thickIntMm/1000 * 0.5;
        IntPartitionParser._partitions.forEach(q=>{
          let changed = false;
          [q.nA, q.nB].forEach(node=>{
            const par = node.parent; if(!par) return;
            const range = par.getRange();
            const lo = range.lo + nodeMargin, hi = range.hi - nodeMargin;
            if(par.axis === 'x'){
              const d = node.x < lo ? lo - node.x : node.x > hi ? hi - node.x : 0;
              if(Math.abs(d) > 0.0001){ node.x += d; changed = true; }
            } else {
              const d = node.z < lo ? lo - node.z : node.z > hi ? hi - node.z : 0;
              if(Math.abs(d) > 0.0001){ node.z += d; changed = true; }
            }
          });
          if(changed){
            IntPartitionParser._syncFromNodes(q);
                [q.nA, q.nB].forEach(sharedNode=>{
              IntPartitionParser._partitions.forEach(other=>{
                if(other === q) return;
                if(other.nA !== sharedNode && other.nB !== sharedNode) return;
                IntPartitionParser._syncFromNodes(other);
                
              });
            });
          }
        });
      }
      RoofBuilder.rebuildForWalls();
      if(typeof IntWallParser!=='undefined'&&IntWallParser._parts.length){
        IntWallParser._enforceIntJoints(null, true);
        IntWallParser._enforceIntJoints(null, true);
        IntWallParser._enforceIntJoints(null, true);
      }
      if(typeof FloorParser!=='undefined'){FloorParser.rebuild();FloorParser._reprojectRoomLabels();if(typeof FloorParser._showRoomDims==='function')FloorParser._showRoomDims(dragSeg);}if(typeof UI!=='undefined')UI.refreshDimLabels();
    });
    cv.addEventListener('pointerup',()=>{
      if(!this._dragging)return;
      STATE.isDragging = false;
      this._dragging=null;this._cornerIdx=-1;this._dragFloor=null;this._startPt=null;
      this._origNodes = null;
      Engine.orthoControls.enabled=true;Engine.controls.enabled=false;cv.style.cursor='';
      document.getElementById('cv5-root')?.querySelectorAll('.v4-drag-dim').forEach(el=>el.remove());
      if(typeof FloorParser!=='undefined'&&typeof FloorParser._hideRoomDims==='function')FloorParser._hideRoomDims();
      window._ilog&&window._ilog('=== EXT drag END ===');
      if(typeof IntWallParser!=='undefined' && IntWallParser._parts.length){
        IntWallParser._parts.forEach((p,i)=>{
          if(!p.mesh)return;
          const ud=p.mesh.userData, mp=p.mesh.position;
          const fl=ud.floorNum;
          const thick=CONFIG.thickIntMm/1000;
          const dPos=IntWallParser._raycastWall(mp.x,mp.z,ud.axis==='x'?1:0,ud.axis==='x'?0:1,fl,p.mesh);
          const dNeg=IntWallParser._raycastWall(mp.x,mp.z,ud.axis==='x'?-1:0,ud.axis==='x'?0:-1,fl,p.mesh);
          window._ilog&&window._ilog('P'+i+' ax='+ud.axis+' pos=('+mp.x.toFixed(3)+','+mp.z.toFixed(3)+') dPos='+dPos.toFixed(3)+' dNeg='+dNeg.toFixed(3)+' w='+ud.w.toFixed(3)+' d='+ud.d.toFixed(3));
          IntWallParser._stretchToWalls(p.mesh, fl);
          window._ilog&&window._ilog('  -> after stretch: pos=('+mp.x.toFixed(3)+','+mp.z.toFixed(3)+') w='+ud.w.toFixed(3)+' d='+ud.d.toFixed(3));
        });
        IntWallParser._detectIntJoints();
        window._ilog&&window._ilog('joints after EXT drop: '+IntWallParser._intJoints.length);
      }
      if(typeof IntPartitionParser!=='undefined'){
        IntPartitionParser._partitions.forEach(p=>{
          [p.nA,p.nB].forEach(node=>{
            if(!node||!node.parent||node.parent.type!=='ext')return;
            const seg=node.parent.seg;
            const wAxis=node.parent.axis;
            const wCoord=wAxis==='x'?(seg.nA.z+seg.nB.z)/2:(seg.nA.x+seg.nB.x)/2;
            if(wAxis==='x')node.z=wCoord;else node.x=wCoord;
          });
          IntPartitionParser._syncFromNodes(p);
        });
        IntPartitionParser._buildJunctions();
      }
    });
  },
  _showExtDragDims(dragSeg, moveX, fl) {
    const root = document.getElementById('cv5-root');
    if (!root) return;
    root.querySelectorAll('.v4-drag-dim').forEach(el=>el.remove());
    const yW = (STATE.extFloorRanges?.[fl]?.min ?? 0) + 0.05;
    const snapMm = moveX ? CONFIG.stepX : CONFIG.stepZ;
    const fmt = mm => {
      const snapped = Math.round(mm / snapMm) * snapMm;
      return STATE.isMetric ? snapped + '' : (snapped/25.4).toFixed(1) + '"';
    };
    const corners = STATE.extCorners[fl];
    if (!corners || corners.length < 2) return;
    const makeLbl = (txt, wx, wz) => {
      const sp = Engine.toScreen(new THREE.Vector3(wx, yW, wz));
      const el = document.createElement('div');
      el.className = 'v4-drag-dim';
      el.style.cssText = 'position:absolute;pointer-events:none;z-index:210;transform:translate(-50%,-50%);'
        +'left:'+Math.round(sp.x)+'px;top:'+Math.round(sp.y)+'px;'
        +'background:#fff;border:1.5px solid var(--accent);color:var(--accent);'
        +'font-weight:700;font-size:10px;padding:4px 10px;border-radius:50px;'
        +'white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,0.12);';
      el.textContent = txt;
      root.appendChild(el);
    };
    const nAx = dragSeg.nA.x, nAz = dragSeg.nA.z;
    const nBx = dragSeg.nB.x, nBz = dragSeg.nB.z;
    const T = 0.020;
    const near = (c, nx, nz) => Math.abs(c.x-nx)<T && Math.abs(c.z-nz)<T;
    const n = corners.length;
    corners.forEach((c, i) => {
      const next = corners[(i+1)%n];
      const shareA = near(c,nAx,nAz) || near(c,nBx,nBz);
      const shareB = near(next,nAx,nAz) || near(next,nBx,nBz);
      if (!shareA && !shareB) return;
      const isDragSeg = (near(c,nAx,nAz)&&near(next,nBx,nBz)) || (near(c,nBx,nBz)&&near(next,nAx,nAz));
      if (isDragSeg) return;
      const dx = next.x-c.x, dz = next.z-c.z;
      const lenM = Math.sqrt(dx*dx+dz*dz);
      if (lenM < 0.05) return;
      makeLbl(fmt(Math.round(lenM*1000)), (c.x+next.x)/2, (c.z+next.z)/2);
    });
  }
};

window.WallSplitter = {
  run() {
    STATE.wallSegments = [];
    const pScale=CONFIG.importScale, all=[...STATE.elements.walls], sc=STATE.modelCenter;
    let idx=0;
    all.forEach(mesh => {
      const box=new THREE.Box3().setFromObject(mesh);
      const sx=(box.max.x-box.min.x)*1000*pScale, sz=(box.max.z-box.min.z)*1000*pScale;
      const axis=sx>=sz?'x':'z', len=axis==='x'?sx:sz;
      const c=box.getCenter(new THREE.Vector3());
      const normal=axis==='x'?(c.z>sc.z?'+z':'-z'):(c.x>sc.x?'+x':'-x');
      mesh.userData.refExtX=box.max.x-box.min.x; mesh.userData.refExtZ=box.max.z-box.min.z;
      mesh.userData.origScaleX=mesh.scale.x; mesh.userData.origScaleZ=mesh.scale.z;
      mesh.userData.axis=axis; mesh.userData.sysName=mesh.name.replace(/&\d+/,'');
      const _wlim=wallChangeLimitMm(len);
      STATE.wallSegments.push({
        id:`ws-${idx}`,axis,normal,type:'ext',floorNums:[floorNum(mesh.name)],meshes:[mesh],bbox:box,
        label:String.fromCharCode(65+idx),refLength:len,minLength:Math.round(len-_wlim),
        maxLength:Math.round(len+_wlim),currentLength:len,connections:[],_wallIdx:idx
      });
      idx++;
    });
    
  }
};

window.OpeningDrag = {
  _dragging: null,
  bindDrag() {
    const cv = document.getElementById('cv5-canvas');
    if (!cv) return;
    const rc = new THREE.Raycaster();
    const S = () => window.STATE;
    const E = () => window.Engine;
    const getMouse = e => { const r=cv.getBoundingClientRect(); return new THREE.Vector2(((e.clientX-r.left)/r.width)*2-1,-((e.clientY-r.top)/r.height)*2+1); };
    const getGroundPt = e => { rc.setFromCamera(getMouse(e),E().orthoCamera); const gp=new THREE.Plane(new THREE.Vector3(0,1,0),-(S().modelMinY||0)); const pt=new THREE.Vector3(); return rc.ray.intersectPlane(gp,pt)?pt:null; };
    cv.addEventListener('pointerdown', e => {
      if (S().view !== '2d-top') return;
      const OMB = window.OpeningMeshBuilder; if (!OMB) return;
      rc.setFromCamera(getMouse(e), E().orthoCamera);
      const hits = rc.intersectObjects(OMB._planMeshes.filter(m=>m.visible), false);
      if (!hits.length) return;
      const ud = hits[0].object.userData;
      if (!ud.isPlanIndicator) return;
      const pt0 = getGroundPt(e); if (!pt0) return;
      e.stopPropagation();
      this._pendingUD = ud;
      cv.setPointerCapture(e.pointerId);
      E().orthoControls.enabled = false;
      window.OpeningEditor?.open(ud, e.clientX, e.clientY);
      if (ud.voId) {
        const vo = (S().virtualOpenings||[]).find(v=>v.id===ud.voId); if (!vo) return;
        const dx=vo.B.x-vo.A.x,dz=vo.B.z-vo.A.z,wlen=Math.sqrt(dx*dx+dz*dz)||1,ux=dx/wlen,uz=dz/wlen;
        this._dragging={type:'virtual',vo,wlen,ux,uz,hw:vo.width/2,t0:vo.tFrac*wlen,pt0T:(pt0.x-vo.A.x)*ux+(pt0.z-vo.A.z)*uz};
      } else if (ud.planScope==='ext' && ud.openingSourceRef) {
        const src=ud.openingSourceRef,wA=ud.wallA,wB=ud.wallB;
        const dx=wB.x-wA.x,dz=wB.z-wA.z,wlen=Math.sqrt(dx*dx+dz*dz)||1,ux=dx/wlen,uz=dz/wlen;
        src.updateMatrixWorld(true);
        const bb=new THREE.Box3().setFromObject(src),c=bb.getCenter(new THREE.Vector3());
        const hw=Math.max((bb.max.x-bb.min.x)*Math.abs(ux)+(bb.max.z-bb.min.z)*Math.abs(uz),0.2)/2;
        this._dragging={type:'ext',src,wlen,ux,uz,hw,fl:ud.floorNum,wA,srcX0:src.matrix.elements[12],srcZ0:src.matrix.elements[14],t0:(c.x-wA.x)*ux+(c.z-wA.z)*uz,pt0T:(pt0.x-wA.x)*ux+(pt0.z-wA.z)*uz};
      } else if (ud.planScope==='int' && ud.partitionRef && ud.fixedOpIdx!==undefined) {
        const p=ud.partitionRef,dx=p.nB.x-p.nA.x,dz=p.nB.z-p.nA.z,wlen=Math.sqrt(dx*dx+dz*dz)||1,ux=dx/wlen,uz=dz/wlen,fo=p.fixedOps[ud.fixedOpIdx];
        this._dragging={type:'int',p,opIdx:ud.fixedOpIdx,wlen,ux,uz,hw:fo.hw,t0:fo.tFrac*p.lenM,pt0T:(pt0.x-p.nA.x)*ux+(pt0.z-p.nA.z)*uz};
      } else return;
      cv.style.cursor='grabbing';
    }, true);
    cv.addEventListener('pointermove', e => {
      const OMB=window.OpeningMeshBuilder;
      if (!this._dragging) {
        if (S().view!=='2d-top'||!OMB) return;
        rc.setFromCamera(getMouse(e),E().orthoCamera);
        cv.style.cursor=rc.intersectObjects(OMB._planMeshes.filter(m=>m.visible),false).length?'grab':'';
        return;
      }
      const pt=getGroundPt(e); if (!pt) return;
      const {wlen,ux,uz,hw,t0,pt0T}=this._dragging;
      if (this._dragging.type==='virtual') {
        const {vo}=this._dragging;
        const ptT=(pt.x-vo.A.x)*ux+(pt.z-vo.A.z)*uz;
        vo.tFrac=Math.max(hw+0.02,Math.min(wlen-hw-0.02,t0+ptT-pt0T))/wlen;
        if(vo.wallType==='ext')window.ExtWallParser?.rebuildFloor(vo.fl);
        else if(vo.wallType==='int')window.IntPartitionParser?._rebuildGLB();
        else if(vo.wallType==='iw')window.IntWallParser?._rebuildHolesForPart(vo.iwPartRef);
        OMB?.build();
      } else if (this._dragging.type==='ext') {
        const {src,wA,srcX0,srcZ0,fl}=this._dragging;
        const ptT=(pt.x-wA.x)*ux+(pt.z-wA.z)*uz,dt=Math.max(hw+0.02,Math.min(wlen-hw-0.02,t0+ptT-pt0T))-t0;
        src.matrix.elements[12]=srcX0+dt*ux; src.matrix.elements[14]=srcZ0+dt*uz;
        this._dragging._tCur = t0 + dt;
        window.ExtWallParser?.rebuildFloor(fl);
      } else {
        const {p,opIdx}=this._dragging,ptT=(pt.x-p.nA.x)*ux+(pt.z-p.nA.z)*uz;
        p.fixedOps[opIdx].tFrac=Math.max(hw+0.02,Math.min(wlen-hw-0.02,t0+ptT-pt0T))/p.lenM;
        window.IntPartitionParser?._rebuildMesh(p);
      }
      // Show dim labels during drag
      this._showOpeningDims();
    }, true);
    cv.addEventListener('pointerup', e => {
      this._pendingUD=null; this._dragging=null;
      this._hideOpeningDims();
      E().orthoControls.enabled=true; cv.style.cursor='';
    }, true);
  },

  _showOpeningDims() {
    const root = document.getElementById('cv5-root');
    if (!root || !this._dragging) return;
    root.querySelectorAll('.v4-op-drag-dim').forEach(el => el.remove());
    const S = window.STATE;
    const {wlen, ux, uz, hw} = this._dragging;
    const snapMm = window.CONFIG?.stepX || 25;
    const fmt = mm => {
      const s = Math.round(Math.abs(mm) / snapMm) * snapMm;
      return S.isMetric ? s + '' : (s/25.4).toFixed(1) + '"';
    };
    const makeLbl = (txt, wx, wz, fl, offNx, offNz) => {
      const yW = (S.extFloorRanges?.[fl]?.min ?? 0) + 0.05;
      const OFF = 0.35;
      const sp = window.Engine.toScreen(new THREE.Vector3(wx + offNx*OFF, yW, wz + offNz*OFF));
      const el = document.createElement('div');
      el.className = 'v4-op-drag-dim';
      el.style.cssText = 'position:absolute;pointer-events:none;z-index:210;transform:translate(-50%,-50%);'
        +'left:'+Math.round(sp.x)+'px;top:'+Math.round(sp.y)+'px;'
        +'background:#fff;border:1.5px solid var(--accent);color:var(--accent);'
        +'font-weight:700;font-size:10px;padding:4px 10px;border-radius:50px;'
        +'white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,0.12);';
      el.textContent = txt;
      root.appendChild(el);
    };
    let tCur, wA, fl;
    let offNx = -uz, offNz = ux;
    if (this._dragging.type === 'ext') {
      const d = this._dragging;
      wA = d.wA; fl = d.fl || 1;
      tCur = d._tCur !== undefined ? d._tCur : d.t0;
      const corners = (S.extCorners||{})[fl]||[];
      const bldCx = corners.reduce((s,c)=>s+c.x,0)/(corners.length||1);
      const bldCz = corners.reduce((s,c)=>s+c.z,0)/(corners.length||1);
      const wallMidX = wA.x + ux*wlen/2, wallMidZ = wA.z + uz*wlen/2;
      const nx = -uz, nz = ux;
      const toCentroid = (bldCx-wallMidX)*nx + (bldCz-wallMidZ)*nz;
      offNx = toCentroid > 0 ? nx : -nx;
      offNz = toCentroid > 0 ? nz : -nz;
    } else if (this._dragging.type === 'virtual') {
      const vo = this._dragging.vo;
      wA = vo.A; fl = vo.fl || 1;
      tCur = vo.tFrac * wlen;
      offNx = -uz; offNz = ux;
    } else {
      const {p, opIdx} = this._dragging;
      wA = p.nA; fl = p.fl || 1;
      tCur = p.fixedOps[opIdx].tFrac * p.lenM;
      offNx = -uz; offNz = ux;
    }
    if (!wA) return;
    const dLeft  = tCur - hw;
    const dRight = wlen - (tCur + hw);
    if (dLeft > 0.01) {
      const midT = dLeft / 2;
      makeLbl(fmt(dLeft*1000), wA.x + ux*midT, wA.z + uz*midT, fl, offNx, offNz);
    }
    if (dRight > 0.01) {
      const midT = tCur + hw + dRight/2;
      makeLbl(fmt(dRight*1000), wA.x + ux*midT, wA.z + uz*midT, fl, offNx, offNz);
    }
  },

  _hideOpeningDims() {
    document.getElementById('cv5-root')?.querySelectorAll('.v4-op-drag-dim').forEach(el => el.remove());
  },
};

// â”€â”€â”€ OpeningEditor â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
window.OpeningEditor = {
  _vo: null, _ud: null,
  open(ud, screenX, screenY) {
    const S=window.STATE; this._vo=null; this._ud=null;
    const root=document.getElementById('cv5-root'); if (!root) return;
    const vo=ud.voId?(S.virtualOpenings||[]).find(v=>v.id===ud.voId):null;
    this._vo=vo; this._ud=ud;
    let wMm=0,hMm=0;
    if(vo){wMm=Math.round(vo.width*1000);hMm=Math.round(vo.height*1000);}
    else if(ud.openingSourceRef){const bb=new THREE.Box3().setFromObject(ud.openingSourceRef),sz=bb.getSize(new THREE.Vector3());wMm=Math.round(Math.max(sz.x,sz.z)*1000);hMm=Math.round(sz.y*1000);}
    else if(ud.partitionRef&&ud.fixedOpIdx!==undefined){const fo=ud.partitionRef.fixedOps?.[ud.fixedOpIdx];if(fo){wMm=Math.round(fo.hw*2*1000);hMm=Math.round((fo.height||2.0)*1000);}}
    let sillH=0;
    if(vo){sillH=vo.sillHeight||0;}
    else if(ud.openingSourceRef){const bb2=new THREE.Box3().setFromObject(ud.openingSourceRef);sillH=Math.max(0,bb2.min.y-(S.modelMinY||0));}
    const fromFloor=sillH<0.10&&hMm>=1900;
    const nPanels=wMm/1000<=1.40?1:wMm/1000<=2.80?2:wMm/1000<=4.20?3:4;
    const lib=(window._LEVA_LIB?.openingLibrary)||{},libArr=lib[ud.openingType]||[];
    const libMatch=libArr.find(i=>i.width===wMm&&i.height===hMm);
    let name=libMatch?libMatch.name:null;
    if(!name){if(ud.openingType==='win'){name=fromFloor?(nPanels>1?'HS Sliding Door':'French Door'):'Window';}else if(ud.openingType==='edr')name='Ext Door';else if(ud.openingType==='idr')name='Int Door';else name='Opening';}
    const t=document.getElementById('cv5-op-title'); if(t)t.textContent=name;
    const d=document.getElementById('cv5-op-dims');
    if(d&&wMm>0){d.textContent=S.isMetric?wMm+' × '+hMm+' mm':((wMm/25.4).toFixed(1)+' × '+(hMm/25.4).toFixed(1)+' in');}else if(d)d.textContent='';
    const showSill=ud.openingType==='win'&&!fromFloor;
    document.getElementById('cv5-op-sill-row').style.display=showSill?'flex':'none';
    document.getElementById('cv5-op-delete-row').style.display='flex';
    if(showSill){const si=document.getElementById('cv5-op-sill-input'),su=document.getElementById('cv5-op-sill-unit');if(si){si.value=S.isMetric?Math.round(sillH*1000):Math.round(sillH*39.3701);si.min=0;si.max=S.isMetric?2000:79;si.step=S.isMetric?50:1;if(su)su.textContent=S.isMetric?'mm':'in';}}
    const modal=document.getElementById('v4-modal-opening');
    if(modal){try{const sv=sessionStorage.getItem('leva_modal_v4-modal-opening');if(sv){const p=JSON.parse(sv);modal.style.left=p.left;modal.style.top=p.top;modal.style.right='auto';modal.style.bottom='auto';}}catch(e){}modal.classList.add('open');}
  },
  close(){document.getElementById('v4-modal-opening')?.classList.remove('open');this._vo=null;this._ud=null;},
  _delete(){
    const S=window.STATE,ud=this._ud,vo=this._vo;
    if(vo){const i=(S.virtualOpenings||[]).indexOf(vo);if(i>=0)S.virtualOpenings.splice(i,1);if(vo.wallType==='ext')window.ExtWallParser?.rebuildFloor(vo.fl);else if(vo.wallType==='int')window.IntPartitionParser?._rebuildGLB();else if(vo.wallType==='iw')window.IntWallParser?._rebuildHolesForPart(vo.iwPartRef);}
    else if(ud?.openingSourceRef){const src=ud.openingSourceRef,i=(S.openingSources||[]).indexOf(src);if(i>=0)S.openingSources.splice(i,1);window.Engine.scene.remove(src);const fl=ud.floorNum;if(fl!==undefined)window.ExtWallParser?.rebuildFloor(fl);else Object.keys(S.extCorners||{}).forEach(f=>window.ExtWallParser?.rebuildFloor(parseInt(f)));}
    else if(ud?.partitionRef&&ud.fixedOpIdx!==undefined){const p=ud.partitionRef;if(p.fixedOps)p.fixedOps.splice(ud.fixedOpIdx,1);window.IntPartitionParser?._rebuildMesh(p);}
    window.OpeningMeshBuilder?.build(); this.close();
  },
  _setSill(val){
    const S=window.STATE,vo=this._vo; if(!vo)return;
    vo.sillHeight=Math.max(0,S.isMetric?val/1000:val/39.3701);
    if(vo.wallType==='ext')window.ExtWallParser?.rebuildFloor(vo.fl);
    else if(vo.wallType==='int')window.IntPartitionParser?._rebuildGLB();
    else if(vo.wallType==='iw')window.IntWallParser?._rebuildHolesForPart(vo.iwPartRef);
    window.OpeningMeshBuilder?.build();
  },
  init(){
    document.getElementById('cv5-op-delete-nosill')?.addEventListener('click',()=>this._delete());
    document.getElementById('cv5-op-sill-input')?.addEventListener('change',function(){window.OpeningEditor._setSill(parseFloat(this.value)||0);});
    document.getElementById('cv5-op-sill-input')?.addEventListener('input',function(){const v=parseFloat(this.value)||0,el=document.getElementById('cv5-op-sill-val');if(el)el.textContent=window.STATE?.isMetric?Math.round(v)+' mm':v.toFixed(1)+' in';});
  }
};
/* â•â•â• RoofBuilder â•â•â• */
const OverhangManager = {
  ROOF_THICK:   0.05,   // 50 mm generated roof thickness
  DEFAULT_OH:   0.200,  // 200 mm default overhang from EXT
  MIN_OH:       0.200,  // minimum allowed overhang
  DECK_MIN_OH:  1.200,  // overhang >= 1200 mm → generate deck
  CLM_MIN_OH:   1.600,  // overhang >= 1600 mm → generate columns
  CLM_SIZE:     0.140,  // 140×140 mm column
  CLM_INSET:    0.200,  // 200 mm inset from roof corner
  DECK_THICK:   0.150,  // 150 mm deck thickness
  DECK_OFFSET:  0.000,  // deck sits at baseY
  HIGHLIGHT_COL:'#F4A62A', // drag highlight colour

  // Internal state
  _poly:       null,   // current overhang polygon [{x,z}] in world coords
  _origPoly:   null,   // polygon at EXT boundary (no overhang)
  _eaveY:      0,      // Y of roof underside
  _baseY:      0,      // ground Y
  _roofMeshes: [],     // generated roof solid meshes
  _deckMeshes: [],     // generated deck meshes
  _clmMeshes:  [],     // generated column meshes
  _planMeshes: [],     // 2D plan outline meshes
  _dragging:   null,   // {edgeIdx, axis, startPt, origPoly}
  _active:     false,

  // ── init ─────────────────────────────────────────────────────────────────
  run() {
    this._clear();
    if (!STATE.elements.roofs.length) return;
    const src = STATE.elements.roofs[0];
    const rn  = src.name.toUpperCase();
    // Skip flat-with-atika
    if (rn.includes('FLAT') && !rn.includes('FLAT2')) return;
    this._active = true;
    src.visible = false;
    src.userData.isOrigRoofGLB = true;

    // Extract eave Y from GLB verts (lowest Y of roof plane mesh)
    src.updateMatrixWorld(true);
    const pos = src.geometry.attributes.position, mw = src.matrixWorld;
    const ys = [];
    for (let i = 0; i < pos.count; i++) {
      const v = new THREE.Vector3().fromBufferAttribute(pos, i).applyMatrix4(mw);
      ys.push(v.y);
    }
    this._eaveY = Math.min(...ys);

    // Build base polygon from EXT corners floor 1 (or guiderFloor)
    const fl = STATE.guiderFloor || 1;
    const corners = STATE.extCorners[fl];
    if (!corners || corners.length < 3) return;
    this._origPoly = corners.map(c => ({ x: c.x, z: c.z }));
    this._baseY    = (STATE.extFloorRanges?.[fl]?.min) ?? 0;

    // Apply default overhang
    this._poly = this._offsetPoly(this._origPoly, this.DEFAULT_OH);
    this._rebuild3D();
    this._rebuild2D();
    this._bindDrag();
  },

  // ── polygon inset/outset ─────────────────────────────────────────────────
  _offsetPoly(poly, d) {
    const n = poly.length;
    let area = 0;
    for (let i = 0; i < n; i++) {
      const j = (i + 1) % n;
      area += poly[i].x * poly[j].z - poly[j].x * poly[i].z;
    }
    const sign = area > 0 ? 1 : -1;
    const lines = [];
    for (let i = 0; i < n; i++) {
      const A = poly[i], B = poly[(i + 1) % n];
      const dx = B.x - A.x, dz = B.z - A.z;
      const len = Math.sqrt(dx * dx + dz * dz);
      if (len < 1e-6) { lines.push(null); continue; }
      const nx = -dz / len * sign, nz = dx / len * sign;
      lines.push({ ox: A.x + nx * d, oz: A.z + nz * d, dx, dz });
    }
    const result = [];
    for (let i = 0; i < n; i++) {
      const L1 = lines[i], L2 = lines[(i + 1) % n];
      if (!L1 || !L2) { result.push(poly[(i + 1) % n]); continue; }
      const denom = L1.dx * L2.dz - L1.dz * L2.dx;
      if (Math.abs(denom) < 1e-9) { result.push({ x: L2.ox, z: L2.oz }); continue; }
      const t = ((L2.ox - L1.ox) * L2.dz - (L2.oz - L1.oz) * L2.dx) / denom;
      result.push({ x: L1.ox + t * L1.dx, z: L1.oz + t * L1.dz });
    }
    return result;
  },

  // overhang of each edge = distance from _origPoly edge to _poly edge
  _edgeOverhangs() {
    const n = this._poly.length;
    const oh = [];
    for (let i = 0; i < n; i++) {
      const oA = this._origPoly[i], oB = this._origPoly[(i + 1) % n];
      const pA = this._poly[i],     pB = this._poly[(i + 1) % n];
      const omx = (oA.x + oB.x) / 2, omz = (oA.z + oB.z) / 2;
      const pmx = (pA.x + pB.x) / 2, pmz = (pA.z + pB.z) / 2;
      oh.push(Math.sqrt((pmx - omx) ** 2 + (pmz - omz) ** 2));
    }
    return oh;
  },

  // ── 3D rebuild ──────────────────────────────────────────────────────────
  _rebuild3D() {
    // remove old
    [...this._roofMeshes, ...this._deckMeshes, ...this._clmMeshes].forEach(m => Engine.scene.remove(m));
    this._roofMeshes = []; this._deckMeshes = []; this._clmMeshes = [];

    const poly = this._poly, n = poly.length;
    const eY = this._eaveY, bY = this._baseY;
    const T = this.ROOF_THICK;

    // ── roof solid (flat plane with thickness) ──
    const roofVerts = [], roofUVs = [];
    const push3 = (a, b, c) => {
      roofVerts.push(a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z);
      roofUVs.push(a.x, a.z, b.x, b.z, c.x, c.z);
    };
    // triangulate top face (fan)
    for (let i = 1; i < n - 1; i++) {
      const A = { x: poly[0].x, y: eY + T, z: poly[0].z };
      const B = { x: poly[i].x, y: eY + T, z: poly[i].z };
      const C = { x: poly[i+1].x, y: eY + T, z: poly[i+1].z };
      push3(A, B, C);
    }
    // bottom face (reversed)
    for (let i = 1; i < n - 1; i++) {
      const A = { x: poly[0].x, y: eY, z: poly[0].z };
      const B = { x: poly[i+1].x, y: eY, z: poly[i+1].z };
      const C = { x: poly[i].x, y: eY, z: poly[i].z };
      push3(A, B, C);
    }
    // side faces
    for (let i = 0; i < n; i++) {
      const A = poly[i], B = poly[(i + 1) % n];
      const yB = eY, yT = eY + T;
      push3({ x:A.x,y:yB,z:A.z }, { x:B.x,y:yB,z:B.z }, { x:B.x,y:yT,z:B.z });
      push3({ x:A.x,y:yB,z:A.z }, { x:B.x,y:yT,z:B.z }, { x:A.x,y:yT,z:A.z });
    }
    const rGeo = new THREE.BufferGeometry();
    rGeo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(roofVerts), 3));
    rGeo.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(roofUVs), 2));
    rGeo.computeVertexNormals();
    const rMat = SceneMaterials._make('roof');
    const rMesh = new THREE.Mesh(rGeo, rMat);
    rMesh.castShadow = rMesh.receiveShadow = true;
    rMesh.userData = { isRoofFace: true, isOverhangRoof: true };
    rMesh.visible = (STATE.view !== '2d-top');
    Engine.scene.add(rMesh);
    this._roofMeshes.push(rMesh);

    // ── deck + columns per edge ──
    const ohs = this._edgeOverhangs();
    for (let i = 0; i < n; i++) {
      if (ohs[i] < this.DECK_MIN_OH) continue;

      const pA = poly[i], pB = poly[(i + 1) % n];
      const oA = this._origPoly[i], oB = this._origPoly[(i + 1) % n];

      // deck quad for this edge strip
      const dY = bY + this.DECK_OFFSET;
      const dVerts = new Float32Array([
        oA.x, dY, oA.z,  pA.x, dY, pA.z,  pB.x, dY, pB.z,
        oA.x, dY, oA.z,  pB.x, dY, pB.z,  oB.x, dY, oB.z,
        // bottom
        oA.x, dY - this.DECK_THICK, oA.z,  pB.x, dY - this.DECK_THICK, pB.z,  pA.x, dY - this.DECK_THICK, pA.z,
        oA.x, dY - this.DECK_THICK, oA.z,  oB.x, dY - this.DECK_THICK, oB.z,  pB.x, dY - this.DECK_THICK, pB.z,
      ]);
      const dGeo = new THREE.BufferGeometry();
      dGeo.setAttribute('position', new THREE.BufferAttribute(dVerts, 3));
      dGeo.computeVertexNormals();
      const dMat = SceneMaterials._make('floor');
      const dMesh = new THREE.Mesh(dGeo, dMat);
      dMesh.castShadow = false; dMesh.receiveShadow = true;
      dMesh.userData = { isOverhangDeck: true };
      dMesh.visible = (STATE.view !== '2d-top');
      Engine.scene.add(dMesh);
      this._deckMeshes.push(dMesh);

      // columns if overhang >= CLM_MIN_OH
      if (ohs[i] >= this.CLM_MIN_OH) {
        const S = this.CLM_SIZE, IN = this.CLM_INSET;
        const dx = pB.x - pA.x, dz = pB.z - pA.z;
        const len = Math.sqrt(dx * dx + dz * dz) || 1;
        const ux = dx / len, uz = dz / len;
        const clmH = eY - bY;
        const positions = [
          { x: pA.x + ux * IN, z: pA.z + uz * IN },
          { x: pB.x - ux * IN, z: pB.z - uz * IN }
        ];
        positions.forEach(p => {
          const cGeo = new THREE.BoxGeometry(S, clmH, S);
          const cMat = SceneMaterials._make('ext');
          const cMesh = new THREE.Mesh(cGeo, cMat);
          cMesh.position.set(p.x, bY + clmH / 2, p.z);
          cMesh.castShadow = cMesh.receiveShadow = true;
          cMesh.userData = { isOverhangColumn: true };
          cMesh.visible = (STATE.view !== '2d-top');
          Engine.scene.add(cMesh);
          this._clmMeshes.push(cMesh);
        });
      }
    }
  },

  // ── 2D plan rebuild ──────────────────────────────────────────────────────
  _rebuild2D() {
    this._planMeshes.forEach(m => Engine.scene.remove(m));
    this._planMeshes = [];
    if (!this._poly) return;

    const poly = this._poly, n = poly.length;
    const planY = (this._eaveY) + 0.03;

    // dashed outline — use LineLoop
    const pts = poly.map(p => new THREE.Vector3(p.x, planY, p.z));
    pts.push(pts[0].clone()); // close
    const lineGeo = new THREE.BufferGeometry().setFromPoints(pts);
    const lineMat = new THREE.LineDashedMaterial({ color: 0x888888, dashSize: 0.15, gapSize: 0.08, linewidth: 1 });
    const line = new THREE.Line(lineGeo, lineMat);
    line.computeLineDistances();
    line.userData = { isOverhangPlan: true };
    line.visible = (STATE.view === '2d-top');
    Engine.scene.add(line);
    this._planMeshes.push(line);

    // thin transparent fill so raycasting works for drag
    const fillVerts = [];
    for (let i = 1; i < n - 1; i++) {
      fillVerts.push(poly[0].x, planY, poly[0].z);
      fillVerts.push(poly[i].x, planY, poly[i].z);
      fillVerts.push(poly[i+1].x, planY, poly[i+1].z);
    }
    const fillGeo = new THREE.BufferGeometry();
    fillGeo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(fillVerts), 3));
    const fillMat = new THREE.MeshBasicMaterial({ transparent: true, opacity: 0.0, side: THREE.DoubleSide, depthWrite: false });
    const fillMesh = new THREE.Mesh(fillGeo, fillMat);
    fillMesh.userData = { isOverhangPlan: true, isOverhangDragTarget: true };
    fillMesh.visible = (STATE.view === '2d-top');
    Engine.scene.add(fillMesh);
    this._planMeshes.push(fillMesh);
  },

  // ── drag binding ─────────────────────────────────────────────────────────
  _bindDrag() {
    const cv = document.getElementById('cv5-canvas');
    if (!cv || cv._overhangDragBound) return;
    cv._overhangDragBound = true;

    const rc = new THREE.Raycaster();
    const floorPlane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
    const getMouse = e => {
      const r = cv.getBoundingClientRect();
      return new THREE.Vector2(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
    };

    cv.addEventListener('pointerdown', e => {
      if (STATE.view !== '2d-top' || !this._active) return;
      rc.setFromCamera(getMouse(e), Engine.orthoCamera);
      // hit test against edge mid-point proximity
      const poly = this._poly, n = poly.length;
      const planY = this._eaveY + 0.03;
      floorPlane.constant = -planY;
      const pt = new THREE.Vector3();
      if (!rc.ray.intersectPlane(floorPlane, pt)) return;
      let bestEdge = -1, bestDist = 0.4; // 400mm snap radius
      for (let i = 0; i < n; i++) {
        const A = poly[i], B = poly[(i + 1) % n];
        const mx = (A.x + B.x) / 2, mz = (A.z + B.z) / 2;
        const d = Math.sqrt((pt.x - mx) ** 2 + (pt.z - mz) ** 2);
        if (d < bestDist) { bestDist = d; bestEdge = i; }
      }
      if (bestEdge < 0) return;

      const A = poly[bestEdge], B = poly[(bestEdge + 1) % n];
      const dx = B.x - A.x, dz = B.z - A.z;
      const axis = Math.abs(dx) > Math.abs(dz) ? 'x' : 'z';

      this._dragging = { edgeIdx: bestEdge, axis, startPt: pt.clone(), origPoly: poly.map(p => ({ ...p })) };
      this._highlightEdge(bestEdge, true);
      cv.setPointerCapture(e.pointerId);
      e.stopPropagation();
    }, true);

    cv.addEventListener('pointermove', e => {
      if (!this._dragging) return;
      rc.setFromCamera(getMouse(e), Engine.orthoCamera);
      const planY = this._eaveY + 0.03;
      floorPlane.constant = -planY;
      const pt = new THREE.Vector3();
      if (!rc.ray.intersectPlane(floorPlane, pt)) return;

      const { edgeIdx, axis, startPt, origPoly } = this._dragging;
      const raw = axis === 'x' ? pt.z - startPt.z : pt.x - startPt.x;
      const snapStep = 0.050; // 50mm snap
      const delta = Math.round(raw / snapStep) * snapStep;

      // Rebuild poly with moved edge
      const newPoly = origPoly.map(p => ({ ...p }));
      const n = newPoly.length;
      const oA = this._origPoly[edgeIdx], oB = this._origPoly[(edgeIdx + 1) % n];

      // normal of this edge (outward)
      const eA = origPoly[edgeIdx], eB = origPoly[(edgeIdx + 1) % n];
      const edx = eB.x - eA.x, edz = eB.z - eA.z;
      const elen = Math.sqrt(edx * edx + edz * edz) || 1;
      const enx = -edz / elen, enz = edx / elen;

      // Move only the two vertices of this edge
      const move = delta;
      newPoly[edgeIdx] = { x: eA.x + enx * move, z: eA.z + enz * move };
      newPoly[(edgeIdx + 1) % n] = { x: eB.x + enx * move, z: eB.z + enz * move };

      // Clamp: overhang must be >= MIN_OH for this edge
      const oMidX = (oA.x + oB.x) / 2, oMidZ = (oA.z + oB.z) / 2;
      const nMidX = (newPoly[edgeIdx].x + newPoly[(edgeIdx + 1) % n].x) / 2;
      const nMidZ = (newPoly[edgeIdx].z + newPoly[(edgeIdx + 1) % n].z) / 2;
      const newOH = Math.sqrt((nMidX - oMidX) ** 2 + (nMidZ - oMidZ) ** 2);
      if (newOH < this.MIN_OH) return;

      this._poly = newPoly;
      this._rebuild3D();
      this._rebuild2D();
    });

    cv.addEventListener('pointerup', e => {
      if (!this._dragging) return;
      this._highlightEdge(this._dragging.edgeIdx, false);
      this._dragging = null;
    });
  },

  _highlightEdge(edgeIdx, on) {
    const col = on ? this.HIGHLIGHT_COL : null;
    [...this._roofMeshes, ...this._deckMeshes, ...this._clmMeshes].forEach(m => {
      if (!m.material) return;
      if (on) {
        m.material._origColor = m.material.color.getHex();
        m.material.color.set(col);
      } else if (m.material._origColor !== undefined) {
        m.material.color.setHex(m.material._origColor);
        delete m.material._origColor;
      }
      m.material.needsUpdate = true;
    });
  },

  // called by RoofBuilder.rebuildForWalls and ExtWallParser.rebuildFloor
  onExtChanged() {
    if (!this._active) return;
    const fl = STATE.guiderFloor || 1;
    const corners = STATE.extCorners[fl];
    if (!corners || corners.length < 3) return;
    // Update base polygon, preserve per-edge overhangs
    const ohs = this._edgeOverhangs();
    this._origPoly = corners.map(c => ({ x: c.x, z: c.z }));
    // Reapply each edge overhang
    const n = this._origPoly.length;
    const newPoly = this._origPoly.map(p => ({ ...p }));
    // simple approach: reoffset uniformly with min per-edge oh
    const minOH = Math.min(...ohs, this.DEFAULT_OH);
    this._poly = this._offsetPoly(this._origPoly, Math.max(minOH, this.DEFAULT_OH));
    this._baseY = (STATE.extFloorRanges?.[fl]?.min) ?? 0;
    this._rebuild3D();
    this._rebuild2D();
  },

  onViewChange(view) {
    const in2D = (view === '2d-top');
    this._roofMeshes.forEach(m => { m.visible = !in2D; });
    this._deckMeshes.forEach(m => { m.visible = !in2D; });
    this._clmMeshes.forEach(m => { m.visible = !in2D; });
    this._planMeshes.forEach(m => { m.visible = in2D; });
  },

  applyFinish(img, col, target) {
    const tl = new THREE.TextureLoader();
    const sets = target === 'deck' ? this._deckMeshes
               : target === 'clm'  ? this._clmMeshes
               : this._roofMeshes;
    sets.forEach(m => {
      if (!m.material) return;
      if (img) {
        tl.load(img, tex => {
          tex.colorSpace = THREE.SRGBColorSpace;
          tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
          tex.repeat.set(1, 1);
          m.material.map = tex;
          m.material.color.set(0xffffff);
          m.material.needsUpdate = true;
        });
      } else {
        m.material.map = null;
        m.material.color.set(col);
        m.material.needsUpdate = true;
      }
    });
  },

  getMeshes() { return [...this._roofMeshes, ...this._deckMeshes, ...this._clmMeshes]; },

  _clear() {
    [...this._roofMeshes, ...this._deckMeshes, ...this._clmMeshes, ...this._planMeshes]
      .forEach(m => Engine.scene.remove(m));
    this._roofMeshes = []; this._deckMeshes = []; this._clmMeshes = []; this._planMeshes = [];
    this._poly = null; this._origPoly = null; this._active = false; this._dragging = null;
  }
};
window.OverhangManager = OverhangManager;



/* â•â•â• LandManager + SectionCut + FloorRadial + WallRadial + RadialMenu â•â•â• */
const LandManager = {
  gridObj:null,edgeMeshes:{},dimEls:{},active:false,xMin:0,xMax:0,zMin:0,zMax:0,baseY:0,MARGIN:1.0,MIN_SIZE:3,
  initFromModel(){const box=new THREE.Box3();Engine.scene.traverse(o=>{if(o.isMesh&&!o.userData.isLand)box.expandByObject(o);});const s=box.isEmpty()?new THREE.Vector3(10,0,10):box.getSize(new THREE.Vector3()),c=box.isEmpty()?new THREE.Vector3(0,0,0):box.getCenter(new THREE.Vector3());this.baseY=box.isEmpty()?-0.01:box.min.y-0.01;this.xMin=c.x-s.x/2-this.MARGIN;this.xMax=c.x+s.x/2+this.MARGIN;this.zMin=c.z-s.z/2-this.MARGIN;this.zMax=c.z+s.z/2+this.MARGIN;this._rebuild();this._setVisible(false);this._bindEdgeDrag();},
  toggle(show){this.active=show;this._setVisible(show);if(show){Engine.setView2DTop();this._createLabels();}else{this._removeLabels();}},
  _setVisible(v){if(this.gridObj)this.gridObj.visible=v;if(this.subGridObj)this.subGridObj.visible=v;Object.values(this.dimEls).forEach(el=>{if(el)el.style.display=v?'':'none';});},
  _gridStep(){return STATE.isMetric?0.5:0.3048;},
  _rebuild(){
    if(this.gridObj){Engine.scene.remove(this.gridObj);this.gridObj.geometry.dispose();}
    Object.values(this.edgeMeshes).forEach(m=>{if(m){Engine.scene.remove(m);m.geometry.dispose();}});
    const y=this.baseY,{xMin:x0,xMax:x1,zMin:z0,zMax:z1}=this,step=this._gridStep(),snap=v=>Math.round(v/step)*step;
    const vB=[],vG=[];
    vB.push(x0,y+.0008,z0,x1,y+.0008,z0,x1,y+.0008,z0,x1,y+.0008,z1,x1,y+.0008,z1,x0,y+.0008,z1,x0,y+.0008,z1,x0,y+.0008,z0);
    for(let xi=snap(x0);xi<=x1+.001;xi+=step){if(xi<x0-.001)continue;vG.push(xi,y+.0005,z0,xi,y+.0005,z1);}
    for(let zi=snap(z0);zi<=z1+.001;zi+=step){if(zi<z0-.001)continue;vG.push(x0,y+.0005,zi,x1,y+.0005,zi);}
    const all=[...vB,...vG],colors=[];
    const isMajorL=v=>Math.abs(Math.round(v/1.0)*1.0-v)<0.001;
    const cGL=[];
    for(let i=0;i<vB.length/3;i++)colors.push(.50,.50,.50);
    // rebuild vG colors per-line
    let gIdx=0;
    for(let xi=snap(x0);xi<=x1+.001;xi+=step){if(xi<x0-.001)continue;const c=isMajorL(xi)?.72:.90;cGL.push(c,c,c,c,c,c);gIdx++;}
    for(let zi=snap(z0);zi<=z1+.001;zi+=step){if(zi<z0-.001)continue;const c=isMajorL(zi)?.72:.90;cGL.push(c,c,c,c,c,c);}
    colors.push(...cGL);
    const geo=new THREE.BufferGeometry();geo.setAttribute('position',new THREE.Float32BufferAttribute(all,3));geo.setAttribute('color',new THREE.Float32BufferAttribute(colors,3));
    this.gridObj=new THREE.LineSegments(geo,new THREE.LineBasicMaterial({vertexColors:true}));this.gridObj.userData.isLand=true;Engine.scene.add(this.gridObj);
    // 0.5m sub-grid as separate object (metric only)
    if(this.subGridObj){Engine.scene.remove(this.subGridObj);this.subGridObj.geometry.dispose();}
    this.subGridObj=null;
    if(STATE.isMetric){
      const vS=[],half=step/2,snapH=v=>Math.round(v/half)*half;
      for(let xi=snapH(x0);xi<=x1+.001;xi+=half){if(xi<x0-.001)continue;if(Math.abs(Math.round(xi/step)*step-xi)<.001)continue;vS.push(xi,y+.0005,z0,xi,y+.0005,z1);}
      for(let zi=snapH(z0);zi<=z1+.001;zi+=half){if(zi<z0-.001)continue;if(Math.abs(Math.round(zi/step)*step-zi)<.001)continue;vS.push(x0,y+.0005,zi,x1,y+.0005,zi);}
      if(vS.length){
        const cS=[];for(let i=0;i<vS.length/3;i++)cS.push(.84,.84,.84);
        const gS=new THREE.BufferGeometry();gS.setAttribute('position',new THREE.Float32BufferAttribute(vS,3));gS.setAttribute('color',new THREE.Float32BufferAttribute(cS,3));
        this.subGridObj=new THREE.LineSegments(gS,new THREE.LineBasicMaterial({vertexColors:true}));
        this.subGridObj.userData.isLand=true;Engine.scene.add(this.subGridObj);
      }
    }
    // Shadow-receiving ground plane (same color as scene bg, invisible but catches shadows)
    Engine.scene.children.filter(o=>o.userData.isLandShadow).forEach(o=>Engine.scene.remove(o));
    const sw=this.xMax-this.xMin,sd=this.zMax-this.zMin;
    const sg=new THREE.PlaneGeometry(sw,sd);sg.rotateX(-Math.PI/2);
    const sm=new THREE.MeshStandardMaterial({color:0xf5f5f5,roughness:1,metalness:0,envMapIntensity:0});
    const sp=new THREE.Mesh(sg,sm);sp.receiveShadow=true;
    sp.position.set((this.xMin+this.xMax)/2,y,(this.zMin+this.zMax)/2);
    sp.userData={isLandShadow:true,isLand:true};sp.visible=STATE.view!=='2d-top';Engine.scene.add(sp);
    const HIT=0.8,edgeDefs={xMin:{w:HIT,h:(z1-z0)+HIT*2,px:x0,pz:(z0+z1)/2,axis:'x'},xMax:{w:HIT,h:(z1-z0)+HIT*2,px:x1,pz:(z0+z1)/2,axis:'x'},zMin:{w:(x1-x0)+HIT*2,h:HIT,px:(x0+x1)/2,pz:z0,axis:'z'},zMax:{w:(x1-x0)+HIT*2,h:HIT,px:(x0+x1)/2,pz:z1,axis:'z'}};
    Object.entries(edgeDefs).forEach(([key,d])=>{const g=new THREE.PlaneGeometry(d.w,d.h);g.rotateX(-Math.PI/2);const m=new THREE.Mesh(g,new THREE.MeshBasicMaterial({transparent:true,opacity:0,side:THREE.DoubleSide,depthWrite:false}));m.position.set(d.px,y+0.1,d.pz);m.userData={isLand:true,edgeKey:key,axis:d.axis};Engine.scene.add(m);this.edgeMeshes[key]=m;});
    this.gridObj.visible=this.active;
    if(this.subGridObj)this.subGridObj.visible=this.active;
  },
  _createLabels(){this._removeLabels();const layer=document.getElementById('cv5-dimlayer');['x','z'].forEach(axis=>{const el=document.createElement('div');el.className='v4-dim-label v4-land-dim';el.dataset.axis=axis;el.innerHTML=`<svg width="12" height="12" viewBox="0 0 12 12" style="flex-shrink:0"><circle cx="3" cy="2" r="1.4" fill="currentColor"/><circle cx="9" cy="2" r="1.4" fill="currentColor"/><circle cx="3" cy="6" r="1.4" fill="currentColor"/><circle cx="9" cy="6" r="1.4" fill="currentColor"/><circle cx="3" cy="10" r="1.4" fill="currentColor"/><circle cx="9" cy="10" r="1.4" fill="currentColor"/></svg><span></span>`;layer.appendChild(el);this.dimEls[axis]=el;});this._reprojectLabels();},
  _reprojectLabels(){if(!this.active)return;const y=this.baseY+0.1,tl=Engine.toScreen(new THREE.Vector3(this.xMin,y,this.zMin));const elX=this.dimEls['x'];if(elX){elX.style.left=(tl.x+50)+'px';elX.style.top=(tl.y-20)+'px';elX.style.transform='translateY(-100%)';elX.querySelector('span').textContent=this._fmt(this.xMax-this.xMin);}const elZ=this.dimEls['z'];if(elZ){elZ.style.left=(tl.x-50)+'px';elZ.style.top=(tl.y+50)+'px';elZ.style.transform='translateX(-100%) rotate(-90deg)';elZ.style.transformOrigin='right top';elZ.querySelector('span').textContent=this._fmt(this.zMax-this.zMin);}},
  _removeLabels(){Object.values(this.dimEls).forEach(el=>{if(el)el.remove();});this.dimEls={};},
  refreshLabels(){if(this.active)this._reprojectLabels();},
  _bindEdgeDrag(){const cv=document.getElementById('cv5-canvas'),rc=new THREE.Raycaster(),dragPlane=new THREE.Plane(new THREE.Vector3(0,1,0),-this.baseY);let dragging=null;const getCamera=()=>STATE.view==='2d-top'?Engine.orthoCamera:Engine.camera,getControls=()=>STATE.view==='2d-top'?Engine.orthoControls:Engine.controls,getMouse=e=>{const r=cv.getBoundingClientRect();return new THREE.Vector2(((e.clientX-r.left)/r.width)*2-1,-((e.clientY-r.top)/r.height)*2+1);};cv.addEventListener('pointerdown',e=>{if(!this.active)return;rc.setFromCamera(getMouse(e),getCamera());const hits=rc.intersectObjects(Object.values(this.edgeMeshes),false);if(!hits.length)return;e.stopPropagation();dragging=hits[0].object.userData.edgeKey;getControls().enabled=false;cv.style.cursor='grabbing';cv.setPointerCapture(e.pointerId);if(typeof OpeningInsert!=='undefined')OpeningInsert.setSelectedWall({type:'land'});},true);cv.addEventListener('pointermove',e=>{if(!this.active)return;if(!dragging){rc.setFromCamera(getMouse(e),getCamera());cv.style.cursor=rc.intersectObjects(Object.values(this.edgeMeshes),false).length?'grab':'';return;}e.stopPropagation();rc.setFromCamera(getMouse(e),getCamera());const pt=new THREE.Vector3();if(!rc.ray.intersectPlane(dragPlane,pt))return;const MIN=this.MIN_SIZE;if(dragging==='xMin')this.xMin=Math.min(pt.x,this.xMax-MIN);if(dragging==='xMax')this.xMax=Math.max(pt.x,this.xMin+MIN);if(dragging==='zMin')this.zMin=Math.min(pt.z,this.zMax-MIN);if(dragging==='zMax')this.zMax=Math.max(pt.z,this.zMin+MIN);this._rebuild();this._reprojectLabels();},true);cv.addEventListener('pointerup',e=>{if(!dragging)return;dragging=null;getControls().enabled=true;cv.style.cursor='';},true);},
  bindUI(){},
  _fmt(m){return STATE.isMetric?m.toFixed(1)+' m':(m/0.3048).toFixed(1)+"'";}
};
const SectionCut = {
  enabled:false,heightCm:100,
  enable(heightCm){this.enabled=true;this.heightCm=(heightCm!==undefined)?heightCm:this.heightCm;this._apply();const sl=document.getElementById('v4-sl-section');if(sl){sl.max=Math.max(400,Math.round(this._modelHeightCm()));sl.value=this.heightCm;this._updateLabel();}},
  disable(){this.enabled=false;if(!STATE.clipPlane)return;STATE.clipPlane.constant=99999;Engine.scene.traverse(o=>{if(o.userData.isExtSource||o.userData.isOrigRoofGLB||o.userData.isOpeningSource)return;if(o.userData.isFitout){o.visible=true;return;}if(!o.isMesh||o.userData.isLand)return;if(o.userData.isPlanIndicator){o.visible=false;if(o.material){o.material.clippingPlanes=[];o.material.needsUpdate=true;}return;}o.visible=true;if(o.material){o.material.clippingPlanes=(o.material.clippingPlanes||[]).filter(p=>p!==STATE.clipPlane);o.material.needsUpdate=true;}});},
  setHeight(cm){this.heightCm=cm;if(this.enabled)this._apply();this._updateLabel();},
  _apply(){if(!STATE.clipPlane)return;const worldY=STATE.modelMinY+(this.heightCm/100);STATE.clipPlane.constant=worldY;const ranges=STATE.extFloorRanges||{};if(STATE.view==='2d-top'){RoofBuilder.getMeshes().forEach(m=>{m.visible=true;if(m.material&&!(m.material.clippingPlanes||[]).includes(STATE.clipPlane)){m.material.clippingPlanes=[...(m.material.clippingPlanes||[]).filter(p=>p!==STATE.clipPlane),STATE.clipPlane];m.material.clipShadows=false;m.material.needsUpdate=true;}});}Engine.scene.traverse(o=>{if(o.userData.isExtSource||o.userData.isOrigRoofGLB||o.userData.isOpeningSource)return;if(o.userData.isFitout){o.visible=true;return;}if(!o.isMesh||o.userData.isLand)return;if(o.userData.isCutIndicator){o.visible=(STATE.view==='2d-top');return;}if(o.userData.isRoofFace)return;if(o.userData.isPlanIndicator){if(STATE.view!=='2d-top'){o.visible=false;return;}const fl=o.userData.floorNum;const r=fl?ranges[fl]:null;o.visible=r?(worldY>=r.min-0.05&&worldY<=r.max+0.05):true;if(o.material){o.material.clippingPlanes=[];o.material.needsUpdate=true;}return;}if(o.userData.isOpeningGenerated){if(STATE.view==='2d-top'){o.visible=false;return;}const fl=o.userData.floorNum;const r=fl?ranges[fl]:null;o.visible=r?(worldY>=r.min-0.05&&worldY<=r.max+0.05):true;if(o.material){o.material.clippingPlanes=[];o.material.needsUpdate=true;}return;}if((o.userData.isExtGenerated||o.userData.isIntWall)&&o.userData.floorNum){const r=ranges[o.userData.floorNum];o.visible=r?(worldY>=r.min-0.05&&worldY<=r.max+0.05):false;if(o.material){o.material.clippingPlanes=(o.material.clippingPlanes||[]).filter(p=>p!==STATE.clipPlane);o.material.needsUpdate=true;}}else{o.visible=true;if(o.material){const existing=o.material.clippingPlanes||[];if(!existing.includes(STATE.clipPlane)){o.material.clippingPlanes=[...existing.filter(p=>p!==STATE.clipPlane),STATE.clipPlane];o.material.clipShadows=false;o.material.needsUpdate=true;}}}});},
  _modelHeightCm(){const box=new THREE.Box3();Engine.scene.traverse(o=>{if(o.isMesh&&!o.userData.isLand)box.expandByObject(o);});if(box.isEmpty())return 400;return(box.max.y-box.min.y)*100;},
  _updateLabel(){const el=document.getElementById('v4-val-section');if(!el)return;el.textContent=STATE.isMetric?this.heightCm+' cm':(this.heightCm/30.48).toFixed(1)+' ft';},
  bindUI(){document.getElementById('v4-sl-section')?.addEventListener('input',e=>this.setHeight(parseInt(e.target.value)));}
};
const FloorRadial = {
  RADIUS: 97,
  DOT_RADIUS: 47,
  _mesh: null,
  _pendingMesh: null,
  _colorBtnPos: {x:0, y:0},
  _mainClickPos: {x:0, y:0},
  open(px, py, mesh) {
    this._mesh = mesh;
    const el = document.getElementById('v4-floor-radial');
    const wr = document.getElementById('cv5-root').getBoundingClientRect();
    el.style.left = (px - wr.left) + 'px';
    el.style.top  = (py - wr.top)  + 'px';
    this._mainClickPos = { x: px - wr.left, y: py - wr.top };
    const btns = el.querySelectorAll('.v4-floor-radial-btn');
    const angles = [-5*Math.PI/6, -Math.PI/2, -Math.PI/6];
    btns.forEach((btn, i) => {
      const ang = angles[i] ?? -Math.PI/2;
      btn.style.left = Math.cos(ang)*this.RADIUS + 'px';
      btn.style.top  = Math.sin(ang)*this.RADIUS + 'px';
    });
    el.classList.add('open');
    this._closeColorDots();
  },
  close() {
    document.getElementById('v4-floor-radial')?.classList.remove('open');
    this._closeColorDots();
    this._closeScaleModal();
    this._mesh = null;
  },
  _openColorDots() {
    if (!this._mesh) return;
    this._pendingMesh = this._mesh;
    const dotsEl = document.getElementById('v4-floor-color-dots');
    if (!dotsEl) return;
    dotsEl.querySelectorAll('.v4-fcd-btn').forEach(b => b.remove());
    const cx = this._colorBtnPos.x;
    const cy = this._colorBtnPos.y;
    dotsEl.style.left = cx + 'px';
    dotsEl.style.top  = cy + 'px';
    const slots = this._getSlots();
    const TOTAL = 7;
    const step  = 2*Math.PI / TOTAL;
    const backAng = Math.atan2(
      this._mainClickPos.y - cy,
      this._mainClickPos.x - cx
    );
    const orderedSlots = [
      null,
      {type:'reset'},
      ...slots.filter(s=>s.type==='color'||s.type==='texture').slice(0,4),
      {type:'upload'}
    ];
    for (let i = 0; i < TOTAL; i++) {
      const slot = orderedSlots[i];
      if (!slot) continue;
      const ang = backAng + step*i;
      const btn = document.createElement('button');
      btn.className = 'v4-fcd-btn'
        + (slot.type==='upload'  ? ' upload-btn'    : '')
        + (slot.type==='reset'   ? ' reset-btn-dot' : '');
      btn.style.left = Math.cos(ang)*this.DOT_RADIUS + 'px';
      btn.style.top  = Math.sin(ang)*this.DOT_RADIUS + 'px';
      btn.style.transitionDelay = (i*0.04) + 's';
      if (slot.type==='color')        btn.style.background = slot.col;
      else if (slot.type==='texture') { btn.style.backgroundImage='url('+slot.img+')'; btn.style.backgroundSize='cover'; }
      else if (slot.type==='upload')  btn.textContent = '+';
      else if (slot.type==='reset')   btn.textContent = 'â†ş';
      btn.addEventListener('click', e => {
        e.stopPropagation();
        if (slot.type==='upload')     document.getElementById('v4-fcd-upload-input')?.click();
        else if (slot.type==='reset') this._applyReset();
        else                          this._applySlot(slot);
      });
      dotsEl.appendChild(btn);
    }
    dotsEl.classList.add('open');
  },
  _closeColorDots() {
    const dotsEl = document.getElementById('v4-floor-color-dots');
    dotsEl?.classList.remove('open');
  },
  _closeScaleModal() {
    const m = document.getElementById('v4-floor-scale-modal');
    if (m) m.style.display = 'none';
  },
  _getSlots() {
    const defaults = [
      {type:'color', col:'#EDE8E0'},
      {type:'color', col:'#D4C8B8'},
      {type:'color', col:'#B8A898'},
      {type:'color', col:'#8B7D6E'}
    ];
    const floorCfg = CONFIG.finishes?.floors || [];
    const colorSlots = floorCfg.slice(0,4).map(s => s.img
      ? {type:'texture', img:s.img, col:s.col}
      : {type:'color',   col:s.col}
    );
    while (colorSlots.length < 4) colorSlots.push(defaults[colorSlots.length]);
    return [{type:'reset'}, ...colorSlots, {type:'upload'}];
  },
  _applySlot(slot) {
    const m = this._pendingMesh; if (!m) return;
    if (slot.type === 'texture' && slot.img) {
      new THREE.TextureLoader().load(slot.img, tex => {
        tex.colorSpace = THREE.SRGBColorSpace;
        tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
        tex.repeat.set(2, 2);
        m.material.map = tex;
        m.material.color.set(0xffffff);
        m.material.needsUpdate = true;
        m.userData.hasTexture = true;
        this._hideRoomLabel(m);
      });
    } else {
      m.material.map = null;
      m.material.color.set(slot.col);
      m.material.needsUpdate = true;
      m.userData.hasTexture = true;
      this._hideRoomLabel(m);
    }
  },
  _applyReset() {
    const m = this._pendingMesh; if (!m) return;
    m.material.map = null;
    m.material.color.set(m.userData.defaultColor || '#EDE8E0');
    m.material.needsUpdate = true;
    m.userData.hasTexture = false;
    this._showRoomLabel(m);
    this.close();
  },
  _hideRoomLabel(mesh) {
    const m = mesh || this._mesh; if (!m) return;
    const roomName = m.userData.roomName, fl = m.userData.floorNum;
    document.querySelectorAll('.v4-room-label').forEach(el => {
      if (parseInt(el.dataset.fl) !== fl) return;
      const nameEl = el.querySelector('.rl-name'); if (!nameEl) return;
      const dispName = CONFIG.roomTranslations?.[roomName] || roomName.replace(/_/,' ');
      if (nameEl.textContent.trim().toLowerCase() === dispName.trim().toLowerCase()) el.style.display='none';
    });
  },
  _showRoomLabel(mesh) {
    const m = mesh || this._mesh; if (!m) return;
    const roomName = m.userData.roomName, fl = m.userData.floorNum;
    document.querySelectorAll('.v4-room-label').forEach(el => {
      if (parseInt(el.dataset.fl) !== fl) return;
      const nameEl = el.querySelector('.rl-name'); if (!nameEl) return;
      const dispName = CONFIG.roomTranslations?.[roomName] || roomName.replace(/_/,' ');
      if (nameEl.textContent.trim().toLowerCase() === dispName.trim().toLowerCase())
        el.style.display = STATE.view === '2d-top' ? 'block' : 'none';
    });
  },
  init() {
    document.getElementById('v4-frad-color')?.addEventListener('click', e => {
      e.stopPropagation();
      if (!this._mesh) return;
      this._closeScaleModal();
      const dotsEl = document.getElementById('v4-floor-color-dots');
      if (dotsEl?.classList.contains('open')) { this._closeColorDots(); return; }
      const frEl = document.getElementById('v4-floor-radial');
      const colorBtn = document.getElementById('v4-frad-color');
      this._colorBtnPos = {
        x: (parseFloat(frEl.style.left)||0) + (parseFloat(colorBtn.style.left)||0),
        y: (parseFloat(frEl.style.top) ||0) + (parseFloat(colorBtn.style.top) ||0)
      };
      this._openColorDots();
    });
    document.getElementById('v4-frad-scale')?.addEventListener('click', e => {
      e.stopPropagation();
      if (!this._mesh) return;
      this._closeColorDots();
      const modal = document.getElementById('v4-floor-scale-modal');
      if (!modal) return;
      if (modal.style.display !== 'none') { this._closeScaleModal(); return; }
      const btn = document.getElementById('v4-frad-scale');
      const fr  = document.getElementById('v4-floor-radial');
      const wr  = document.getElementById('cv5-root').getBoundingClientRect();
      const br  = btn.getBoundingClientRect();
      const frLeft = parseFloat(fr.style.left)||0, frTop = parseFloat(fr.style.top)||0;
      const btnL = parseFloat(btn.style.left)||0,  btnT = parseFloat(btn.style.top)||0;
      modal.style.left = (frLeft + btnL - 80) + 'px';
      modal.style.top  = (frTop  + btnT - 68) + 'px';
      const curScale = this._mesh.userData.texScale || 1.0;
      const sl = document.getElementById('v4-frad-scale-sl');
      const vl = document.getElementById('v4-frad-scale-val');
      if (sl) sl.value = curScale;
      if (vl) vl.textContent = parseFloat(curScale).toFixed(1);
      modal.style.display = 'block';
    });
    document.getElementById('v4-frad-scale-sl')?.addEventListener('input', () => {
      const sl = document.getElementById('v4-frad-scale-sl');
      const vl = document.getElementById('v4-frad-scale-val');
      const sc = parseFloat(sl.value);
      if (vl) vl.textContent = sc.toFixed(1);
      if (!this._mesh?.material?.map) return;
      this._mesh.material.map.repeat.set(sc, sc);
      this._mesh.material.map.needsUpdate = true;
      if (this._mesh) this._mesh.userData.texScale = sc;
    });
    document.getElementById('v4-frad-fitout')?.addEventListener('click', () => {
      this.close();
      if(typeof UI!=='undefined')UI._openModal('v4-modal-assets');
      if(typeof FitoutManager!=='undefined')FitoutManager.openFitoutMode(this._mesh);
    });
    document.getElementById('v4-fcd-upload-input')?.addEventListener('change', e => {
      const f = e.target.files[0]; if (!f) return;
      const url = URL.createObjectURL(f);
      this._applySlot({type:'texture', img:url});
      e.target.value = '';
    });
    document.getElementById('cv5-root')?.addEventListener('pointerdown', e => {
      const el1 = document.getElementById('v4-floor-radial');
      const el2 = document.getElementById('v4-floor-color-dots');
      const el3 = document.getElementById('v4-floor-scale-modal');
      if (el1?.contains(e.target)) return;
      if (el2?.contains(e.target)) return;
      if (el3?.contains(e.target)) return;
      this.close();
    }, true);
  }
};
const WallRadial = {
  RADIUS: 97,
  DOT_RADIUS: 47,
  _mesh: null,
  _pendingMesh: null,
  _cat: 'ext',
  _colorBtnPos: {x:0, y:0},
  _mainClickPos: {x:0, y:0},

  open(px, py, mesh, cat) {
    this._mesh = mesh;
    this._cat = cat || 'ext';
    const el = document.getElementById('v4-wall-radial');
    const wr = document.getElementById('cv5-root').getBoundingClientRect();
    el.style.left = (px - wr.left) + 'px';
    el.style.top  = (py - wr.top)  + 'px';
    this._mainClickPos = { x: px - wr.left, y: py - wr.top };
    const scaleBtn = document.getElementById('v4-wrad-scale');
    const isInt = cat === 'int';
    if (scaleBtn) scaleBtn.style.display = isInt ? 'none' : '';
    const btns = [...el.querySelectorAll('.v4-floor-radial-btn')].filter(b => b.style.display !== 'none');
    const angles = isInt ? [-Math.PI/2] : [-2*Math.PI/3, -Math.PI/3];
    btns.forEach((btn, i) => {
      btn.style.left = Math.cos(angles[i])*this.RADIUS + 'px';
      btn.style.top  = Math.sin(angles[i])*this.RADIUS + 'px';
    });
    el.classList.add('open');
    this._closeColorDots();
  },

  close() {
    document.getElementById('v4-wall-radial')?.classList.remove('open');
    this._closeColorDots();
    this._closeScaleModal();
    this._mesh = null;
  },

  _openColorDots() {
    if (!this._mesh) return;
    this._pendingMesh = this._mesh;
    const dotsEl = document.getElementById('v4-wall-color-dots');
    if (!dotsEl) return;
    dotsEl.querySelectorAll('.v4-fcd-btn').forEach(b => b.remove());
    const cx = this._colorBtnPos.x;
    const cy = this._colorBtnPos.y;
    dotsEl.style.left = cx + 'px';
    dotsEl.style.top  = cy + 'px';
    const slots = this._getSlots();
    const TOTAL = 7;
    const step  = 2*Math.PI / TOTAL;
    const backAng = Math.atan2(this._mainClickPos.y - cy, this._mainClickPos.x - cx);
    const orderedSlots = [null, {type:'reset'}, ...slots.filter(s=>s.type==='color'||s.type==='texture').slice(0,4), {type:'upload'}];
    for (let i = 0; i < TOTAL; i++) {
      const slot = orderedSlots[i];
      if (!slot) continue;
      const ang = backAng + step*i;
      const btn = document.createElement('button');
      btn.className = 'v4-fcd-btn'
        + (slot.type==='upload'  ? ' upload-btn'    : '')
        + (slot.type==='reset'   ? ' reset-btn-dot' : '');
      btn.style.left = Math.cos(ang)*this.DOT_RADIUS + 'px';
      btn.style.top  = Math.sin(ang)*this.DOT_RADIUS + 'px';
      btn.style.transitionDelay = (i*0.04) + 's';
      if (slot.type==='color')        btn.style.background = slot.col;
      else if (slot.type==='texture') { btn.style.backgroundImage='url('+slot.img+')'; btn.style.backgroundSize='cover'; }
      else if (slot.type==='upload')  btn.textContent = '+';
      else if (slot.type==='reset')   btn.textContent = 'â†ş';
      btn.addEventListener('click', e => {
        e.stopPropagation();
        if (slot.type==='upload')     document.getElementById('v4-wcd-upload-input')?.click();
        else if (slot.type==='reset') this._applyReset();
        else                          this._applySlot(slot);
      });
      dotsEl.appendChild(btn);
    }
    dotsEl.classList.add('open');
  },

  _closeColorDots() { document.getElementById('v4-wall-color-dots')?.classList.remove('open'); },
  _closeScaleModal() { const m=document.getElementById('v4-wall-scale-modal'); if(m) m.style.display='none'; },

  _getSlots() {
    const cfgSlots = CONFIG.finishes?.[this._cat] || [];
    const defaults = {
      ext:   [{type:'color',col:'#4A82C4'},{type:'color',col:'#b0bec5'},{type:'color',col:'#78909c'},{type:'color',col:'#cfd8dc'}],
      int:   [{type:'color',col:'#b0bec5'},{type:'color',col:'#f5f5f5'},{type:'color',col:'#e0e0e0'},{type:'color',col:'#9e9e9e'}],
      roofs: [{type:'color',col:'#4a4a4c'},{type:'color',col:'#3a3a3c'},{type:'color',col:'#4b3621'},{type:'color',col:'#7a7a7a'}]
    }[this._cat] || [];
    const colorSlots = cfgSlots.slice(0,4).map(s => s.img ? {type:'texture',img:s.img,col:s.col} : {type:'color',col:s.col});
    while (colorSlots.length < 4) colorSlots.push(defaults[colorSlots.length] || {type:'color',col:'#888'});
    return [{type:'reset'}, ...colorSlots, {type:'upload'}];
  },

  _getMeshes() {
    if (this._cat === 'ext')   return Object.values(STATE.extWallMeshes || {}).flat().filter(m => m && !m.userData?.isCornerBlock);
    if (this._cat === 'int')   return IntWallParser.getMeshes(); //ntWall);
    if (this._cat === 'roofs') return RoofBuilder.getMeshes();
    return [];
  },

  _applySlot(slot) {
    const meshes = this._getMeshes();
    const sc = CONFIG.finishes.scales[this._cat] || 0.3;
    const colorKey = {ext:'ext', int:'int', roofs:'roof'}[this._cat];
    if (colorKey && slot.col && slot.type !== 'texture') CONFIG.meshColors[colorKey] = slot.col;
    if (slot.type === 'texture' && slot.img) {
      SceneMaterials.setTexture(meshes, slot.img, sc);
      if (this._cat === 'roofs') RoofBuilder.applyFinish(slot.img, slot.col);
    } else {
      SceneMaterials.setColor(meshes, slot.col);
      if (this._cat === 'roofs') RoofBuilder.applyFinish(null, slot.col);
      if (this._cat === 'ext' && typeof ExtWallParser !== 'undefined') {
        Object.keys(STATE.extCorners||{}).forEach(fl => ExtWallParser.rebuildFloor(parseInt(fl)));
      }
    }
  },

  _applyReset() {
    const meshes = this._getMeshes();
    const defCol = {ext: CONFIG.meshColors.ext, int: CONFIG.meshColors.int, roofs: CONFIG.meshColors.roof}[this._cat] || '#888';
    SceneMaterials.setColor(meshes, defCol);
    if (this._cat === 'roofs') RoofBuilder.applyFinish(null, defCol);
    this.close();
  },

  init() {
    document.getElementById('v4-wrad-color')?.addEventListener('click', e => {
      e.stopPropagation();
      if (!this._mesh) return;
      this._closeScaleModal();
      const dotsEl = document.getElementById('v4-wall-color-dots');
      if (dotsEl?.classList.contains('open')) { this._closeColorDots(); return; }
      const frEl = document.getElementById('v4-wall-radial');
      const colorBtn = document.getElementById('v4-wrad-color');
      const frLeft = parseFloat(frEl.style.left)||0;
      const frTop  = parseFloat(frEl.style.top) ||0;
      const btnLeft = parseFloat(colorBtn.style.left)||0;
      const btnTop  = parseFloat(colorBtn.style.top) ||0;
      this._colorBtnPos = {
        x: frLeft + btnLeft,
        y: frTop  + btnTop
      };
      this._openColorDots();
    });
    document.getElementById('v4-wrad-scale')?.addEventListener('click', e => {
      e.stopPropagation();
      if (!this._mesh) return;
      this._closeColorDots();
      const modal = document.getElementById('v4-wall-scale-modal');
      if (!modal) return;
      if (modal.style.display !== 'none') { this._closeScaleModal(); return; }
      const btn = document.getElementById('v4-wrad-scale');
      const fr  = document.getElementById('v4-wall-radial');
      const btnL = parseFloat(btn.style.left)||0, btnT = parseFloat(btn.style.top)||0;
      modal.style.left = ((parseFloat(fr.style.left)||0) + btnL - 80) + 'px';
      modal.style.top  = ((parseFloat(fr.style.top) ||0) + btnT - 68) + 'px';
      const sl = document.getElementById('v4-wrad-scale-sl');
      const vl = document.getElementById('v4-wrad-scale-val');
      const curScale = CONFIG.finishes.scales[this._cat] || 0.3;
      if (sl) sl.value = curScale;
      if (vl) vl.textContent = parseFloat(curScale).toFixed(1);
      modal.style.display = 'block';
    });
    document.getElementById('v4-wrad-scale-sl')?.addEventListener('input', () => {
      const sl = document.getElementById('v4-wrad-scale-sl');
      const vl = document.getElementById('v4-wrad-scale-val');
      const sc = parseFloat(sl.value);
      if (vl) vl.textContent = sc.toFixed(1);
      CONFIG.finishes.scales[this._cat] = sc;
      const meshes = this._getMeshes();
      meshes.forEach(m => { if (m.material?.map) { m.material.map.repeat.set(sc,sc); m.material.map.needsUpdate=true; m.material.needsUpdate=true; } });
    });
    document.getElementById('v4-wcd-upload-input')?.addEventListener('change', e => {
      const f = e.target.files[0]; if (!f) return;
      const url = URL.createObjectURL(f);
      this._applySlot({type:'texture', img:url});
      e.target.value = '';
    });
    document.getElementById('cv5-root')?.addEventListener('pointerdown', e => {
      const el1 = document.getElementById('v4-wall-radial');
      const el2 = document.getElementById('v4-wall-color-dots');
      const el3 = document.getElementById('v4-wall-scale-modal');
      if (el1?.contains(e.target)) return;
      if (el2?.contains(e.target)) return;
      if (el3?.contains(e.target)) return;
      this.close();
    }, true);
  }
};

const RadialMenu = {
  RADIUS: 56,
  init() {
    const cv=document.getElementById('cv5-canvas'),rc=new THREE.Raycaster(),el=document.getElementById('v4-radial');
    if(!el)return;
    cv.addEventListener('click',e=>{
      if(STATE.view==='2d-top'){
        if(FitoutManager._isDraggingFitout||FitoutManager._justDroppedFitout){FitoutManager._justDroppedFitout=false;return;}
        const r2=cv.getBoundingClientRect();
        const m2=new THREE.Vector2(((e.clientX-r2.left)/r2.width)*2-1,-((e.clientY-r2.top)/r2.height)*2+1);
        rc.setFromCamera(m2,Engine.orthoCamera);
        const fitoutHits=rc.intersectObjects(FitoutManager._items.map(i=>i.obj).filter(Boolean),true);
        if(fitoutHits.length)return;
        const allHits2d=rc.intersectObjects(Engine.scene.children,true).filter(h=>h.object.userData.isFloorGenerated||h.object.userData.isExtGenerated||h.object.userData.isIntWall);
        if(allHits2d.length){
          const h=allHits2d[0].object;
          if(h.userData.isFloorGenerated){FitoutManager._closeFitoutModal();WallRadial.close();FloorRadial.open(e.clientX,e.clientY,h);return;}
          if(h.userData.isExtGenerated){FitoutManager._closeFitoutModal();FloorRadial.close();WallRadial.open(e.clientX,e.clientY,h,'ext');return;}
          if(h.userData.isIntWall){FitoutManager._closeFitoutModal();FloorRadial.close();WallRadial.open(e.clientX,e.clientY,h,'int');return;}
        }
        FitoutManager._closeFitoutModal();FloorRadial.close();WallRadial.close();return;
      }
      if(STATE.view!=='3d'){this.close();return;}
      const r=cv.getBoundingClientRect();
      const mouse=new THREE.Vector2(((e.clientX-r.left)/r.width)*2-1,-((e.clientY-r.top)/r.height)*2+1);
      rc.setFromCamera(mouse,Engine.camera);
      const hits=rc.intersectObjects(Engine.scene.children,true).filter(h=>h.object.userData.isRoofFace||h.object.userData.isFloorGenerated||h.object.userData.isIntWall||h.object.userData.isExtGenerated);
      if(!hits.length){this.close();WallRadial.close();return;}
      const hit0=hits[0].object;
      if(hit0.userData.isFloorGenerated){WallRadial.close();this._openFloorAt(e.clientX,e.clientY);return;}
      if(hit0.userData.isExtGenerated){this.close();WallRadial.open(e.clientX,e.clientY,hit0,'ext');return;}
      if(hit0.userData.isIntWall){this.close();WallRadial.open(e.clientX,e.clientY,hit0,'int');return;}
      if(hit0.userData.isRoofFace){this.close();WallRadial.open(e.clientX,e.clientY,hit0,'roofs');return;}
      this._openAt(e.clientX,e.clientY);
    });
    window.addEventListener('keydown',e=>{if(e.key==='Escape')this.close();});
    document.getElementById('cv5-root')?.addEventListener('pointerdown',e=>{
      if(el.contains(e.target))return;
      if(e.target===cv)return;
      this.close();
    });
    document.getElementById('v4-rad-pitch')?.addEventListener('click',()=>{
      this.close();
      if(typeof UI!=='undefined')UI._openModal('v4-modal-design');
      const roofIdx=STATE.designSteps.findIndex(s=>s.type==='roof');
      if(roofIdx>=0&&typeof UI!=='undefined'){STATE.designStepIdx=roofIdx;UI._renderDesignStep();}
    });
    document.getElementById('v4-rad-finish')?.addEventListener('click',()=>{
      this.close();
      if(typeof UI!=='undefined')UI._openModal('v4-modal-finishes');
      STATE.finishes.activeCat='roofs';
      document.querySelectorAll('.v4-fin-cat').forEach(b=>b.classList.toggle('active',b.dataset.fcat==='roofs'));
      Finishes.renderSwatches();
    });
  },
  _openAt(px,py){
    const el=document.getElementById('v4-radial');
    const wr=document.getElementById('cv5-root').getBoundingClientRect();
    el.style.left=(px-wr.left)+'px'; el.style.top=(py-wr.top)+'px';
    const btns=el.querySelectorAll('.v4-radial-btn'),total=btns.length;
    btns.forEach((btn,i)=>{
      const ang=total>1?-Math.PI*0.85+Math.PI*0.5*(i/(total-1)):-Math.PI*0.6;
      btn.style.left=Math.cos(ang)*this.RADIUS+'px';
      btn.style.top=Math.sin(ang)*this.RADIUS+'px';
    });
    el.classList.add('open');
  },
  close(){document.getElementById('v4-radial')?.classList.remove('open');document.getElementById('v4-rad-pitch').style.display='';document.getElementById('v4-rad-finish').style.display='';},
  _openFloorAt(px,py){
    const el=document.getElementById('v4-radial'),wr=document.getElementById('cv5-root').getBoundingClientRect();
    el.style.left=(px-wr.left)+'px';el.style.top=(py-wr.top)+'px';
    document.getElementById('v4-rad-pitch').style.display='none';
    const btns=el.querySelectorAll('.v4-radial-btn');
    btns.forEach(b=>{b.style.left=Math.cos(-Math.PI/2)*this.RADIUS+'px';b.style.top=Math.sin(-Math.PI/2)*this.RADIUS+'px';});
    el.classList.add('open');
  }
};

window.LandManager = LandManager;
window.SectionCut = SectionCut;
window.FloorRadial = FloorRadial;
window.WallRadial = WallRadial;
window.RadialMenu = RadialMenu;

/* â•â•â• OpeningMeshBuilder â•â•â• */
const OpeningMeshBuilder = {
  _meshes: [],
  _planMeshes: [],
  build() {
    this._clear();
    Object.keys(STATE.extFloorRanges || {}).forEach(fl => this.rebuildExt(parseInt(fl)));
    this._buildFromPartitions();
    this._buildAllPlans();
    if (typeof SectionCut !== 'undefined' && SectionCut.enabled) SectionCut._apply();
  },
  rebuildInt() {
    this._meshes = this._meshes.filter(m => {
      if (m.userData.isOpeningGenerated && m.userData.openingScope === 'int') {
        Engine.scene.remove(m);
        return false;
      }
      return true;
    });
    this._buildFromPartitions();
    this._planMeshes = this._planMeshes.filter(m => {
      if (m.userData.planScope === 'int') { Engine.scene.remove(m); return false; }
      return true;
    });
    this._buildIntPlans();
    const in2D = (STATE.view === '2d-top');
    this._meshes.forEach(m => { if (m.userData.isOpeningGenerated) m.visible = !in2D; });
    this._planMeshes.forEach(m => { m.visible = in2D; });
    if (typeof SectionCut !== 'undefined' && SectionCut.enabled && !STATE.isDragging) SectionCut._apply();
  },
  rebuildExt(fl) {
    this._meshes = this._meshes.filter(m => {
      if (m.userData.isOpeningGenerated && m.userData.openingScope === 'ext' && m.userData.floorNum === fl) {
        Engine.scene.remove(m); return false;
      }
      return true;
    });
    const corners = STATE.extCorners[fl];
    if (!corners || corners.length < 2) return;
    const ranges = STATE.extFloorRanges || {};
    const r = ranges[fl];
    if (!r) return;
    const baseY = r.min;
    const wallH = Math.max(0.05, r.max - r.min);
    const thick = (typeof ExtWallParser !== 'undefined' && ExtWallParser._thickW) ? ExtWallParser._thickW : 0.25;
    const n = corners.length;
    let _sa=0; for(let k=0;k<n;k++){const a=corners[k],b=corners[(k+1)%n];_sa+=(a.x*b.z-b.x*a.z);}
    const _sign=_sa>0?-1:1;
    for (let i = 0; i < n; i++) {
      const A = corners[i], B = corners[(i + 1) % n];
      const dx = B.x - A.x, dz = B.z - A.z;
      const len = Math.sqrt(dx * dx + dz * dz);
      if (len < 0.001) continue;
      const ux = dx / len, uz = dz / len;
      const nx = -uz, nz = ux;
      const onx = nx*_sign, onz = nz*_sign; // guaranteed outward
      const ops = WallHoleCutter.getForSegment(A, B, baseY, wallH, thick).filter(op=>op.type!=='idr');
      ops.forEach(op => {
        if (!op.type || op.type === 'cut') return;
        const wx = A.x + op.t * ux - (thick / 2) * nx;
        const wz = A.z + op.t * uz - (thick / 2) * nz;
        const ctr = new THREE.Vector3(wx, baseY + op.cy + op.hh / 2, wz);
        const extraUD = { floorNum: fl, openingSourceRef: op.src.isVirtual ? null : op.src, voId: op.src.isVirtual ? op.src.voId : undefined, glazed: !!(op.src.isVirtual ? op.src._vo?.glazed : false),
                          wallA: {x:A.x, z:A.z}, wallB: {x:B.x, z:B.z},
                          wallThick: thick, wallIdx: i };
        if (op.type === 'barn') {
          // Barn door: build wings only, no EDR frame
          this._buildBarnAt(A, op.t, op.hw*2, op.hh, baseY+op.cy, thick, ux, uz, onx, onz, fl, extraUD)
            .forEach(m => { Engine.scene.add(m); this._meshes.push(m); });
        } else {
          this._buildOpeningAt(ctr, ux, uz, op.hw * 2, op.hh, baseY + op.cy, thick, op.type, 'ext', extraUD)
            .forEach(m => { Engine.scene.add(m); this._meshes.push(m); });
        }
      });
    }
    this._planMeshes = this._planMeshes.filter(m => {
      if (m.userData.planScope === 'ext' && m.userData.floorNum === fl) { Engine.scene.remove(m); return false; }
      return true;
    });
    this._buildExtPlans(fl);
    const in2D = (STATE.view === '2d-top');
    this._meshes.forEach(m => { if (m.userData.isOpeningGenerated && m.userData.floorNum === fl) m.visible = !in2D; });
    this._planMeshes.forEach(m => { if (m.userData.floorNum === fl) m.visible = in2D; });
    if (typeof SectionCut !== 'undefined' && SectionCut.enabled) SectionCut._apply();
  },
  _clear() {
    this._meshes.forEach(m => Engine.scene.remove(m));
    this._meshes = [];
    this._planMeshes.forEach(m => Engine.scene.remove(m));
    this._planMeshes = [];
  },
  _buildBarnAt(A, t, width, height, baseY, thick, ux, uz, onx, onz, fl, extraUD) {
    const ud = {isOpeningGenerated:true, openingScope:'ext', openingType:'barn', floorNum:fl, ...extraUD};
    const pieces = [];
    const PD=0.08, FW=0.06, GAP=2.0, panelW=width/2;
    const RAIL_H=0.14, RAIL_D=0.08, RAIL_W=width+3.0;
    // Wing origin: wall center + outward half-thick + panel depth
    const midX = A.x + t*ux;
    const midZ = A.z + t*uz;
    const pox = midX + onx*(thick/2 + PD/2 + 0.02);
    const poz = midZ + onz*(thick/2 + PD/2 + 0.02);
    const woodMat=()=>new THREE.MeshStandardMaterial({color:0x8B5E2A,roughness:0.88,metalness:0.02});
    const blackMat=()=>new THREE.MeshStandardMaterial({color:0x111111,roughness:0.3,metalness:0.75});
    const add=(tC,yC,bw,bh,bd,mat)=>{
      const wx=pox+tC*ux, wz=poz+tC*uz;
      const sX=Math.abs(ux)>0.5?bw:bd, sZ=Math.abs(ux)>0.5?bd:bw;
      const m=new THREE.Mesh(new THREE.BoxGeometry(sX,bh,sZ),mat());
      m.position.set(wx,yC,wz); m.castShadow=true; m.receiveShadow=true;
      m.userData={...ud}; pieces.push(m);
    };
    const iW=panelW-2*FW, iH=height-2*FW;
    const dLen=Math.sqrt(iW*iW+iH*iH), dAng=Math.atan2(iH,iW);
    [-1,1].forEach(side=>{
      const tS=side*(GAP/2+panelW/2);
      add(tS,baseY+height/2,panelW,height,PD,woodMat);
      add(tS,baseY+height-FW/2,panelW,FW,PD+0.012,blackMat);
      add(tS,baseY+FW/2,panelW,FW,PD+0.012,blackMat);
      add(tS-panelW/2+FW/2,baseY+height/2,FW,height,PD+0.012,blackMat);
      add(tS+panelW/2-FW/2,baseY+height/2,FW,height,PD+0.012,blackMat);
      [-1,1].forEach(ds=>{
        const geo=new THREE.BoxGeometry(Math.abs(ux)>0.5?dLen:PD+0.015,FW*0.4,Math.abs(ux)>0.5?PD+0.015:dLen);
        const m=new THREE.Mesh(geo,blackMat());
        m.position.set(pox+tS*ux,baseY+height/2,poz+tS*uz);
        if(Math.abs(ux)>0.5)m.rotation.z=ds*dAng;
        else{m.rotation.y=Math.PI/2;m.rotateZ(ds*dAng);}
        m.castShadow=true; m.userData={...ud}; pieces.push(m);
      });
    });
    // Rail on outer face
    const rox=midX+onx*(thick/2+RAIL_D/2+0.01), roz=midZ+onz*(thick/2+RAIL_D/2+0.01);
    {const sX=Math.abs(ux)>0.5?RAIL_W:RAIL_D,sZ=Math.abs(ux)>0.5?RAIL_D:RAIL_W;
     const m=new THREE.Mesh(new THREE.BoxGeometry(sX,RAIL_H,sZ),blackMat());
     m.position.set(rox,baseY+height+RAIL_H/2,roz);m.castShadow=true;m.userData={...ud};pieces.push(m);}
    for(let bi=0;bi<=4;bi++){
      const tB=-RAIL_W/2+bi*RAIL_W/4;
      const m=new THREE.Mesh(new THREE.BoxGeometry(RAIL_D,RAIL_H*1.6,RAIL_D),blackMat());
      m.position.set(rox+tB*ux,baseY+height+RAIL_H*0.8,roz+tB*uz);m.userData={...ud};pieces.push(m);
    }
    return pieces;
  },
  _buildOpeningAt(center, ux, uz, width, height, baseY, thick, type, scope, extraUD = {}) {
    // glazed: door type but with full glass fill (e.g. Sauna Door)
    const isGlazed = !!extraUD?.glazed;
    const isDoor = (type === 'edr' || type === 'idr') && !isGlazed;
    const isWin  = (type === 'win') || isGlazed;
    const fs     = (type === 'idr') ? 0.070 : 0.100;
    const offset = (isWin || type === 'edr') ? Math.max(0, (CONFIG.winFrameOffsetMm || 100) / 1000) : 0.004;
    const frameDepth = Math.max(0.020, thick - 2 * offset);
    const cx = center.x, cz = center.z;
    const ud = { isOpeningGenerated: true, openingScope: scope, openingType: type, ...extraUD };
    const pieces = [];
    const addBox = (tC, yC, bw, bh, bd, matFn) => {
      if (bw < 0.001 || bh < 0.001 || bd < 0.001) return;
      const wx = cx + tC * ux;
      const wz = cz + tC * uz;
      const sX = Math.abs(ux) > 0.5 ? bw : bd;
      const sZ = Math.abs(ux) > 0.5 ? bd : bw;
      const geo = new THREE.BoxGeometry(sX, bh, sZ);
      const mat = matFn();
      if (type === 'idr') {
        mat.polygonOffset = true;
        mat.polygonOffsetFactor = -1;
        mat.polygonOffsetUnits = -1;
      }
      const m   = new THREE.Mesh(geo, mat);
      m.position.set(wx, yC, wz);
      m.castShadow = false;
      m.receiveShadow = true;
      m.userData = { ...ud };
      pieces.push(m);
    };
    const frameMat = () => {
      if (type === 'idr') return SceneMaterials._make('idr');
      return new THREE.MeshStandardMaterial({
        color: new THREE.Color(CONFIG.meshColors.win),
        roughness: 0.70, metalness: 0.08,
        envMapIntensity: 0.4
      });
    };
    const glassMat = () => SceneMaterials._make('win');
    const innerBot = isDoor ? baseY       : baseY + fs;
    const innerTop = baseY + height - fs;
    const innerH   = Math.max(0, innerTop - innerBot);
    const innerW   = Math.max(0, width - 2 * fs);
    addBox(0, baseY + height - fs / 2, width, fs, frameDepth, frameMat);
    if (!isDoor) {
      addBox(0, baseY + fs / 2, width, fs, frameDepth, frameMat);
    }
    if (innerH > 0.001) {
      addBox(-(width / 2 - fs / 2), innerBot + innerH / 2, fs, innerH, frameDepth, frameMat);
    }
    if (innerH > 0.001) {
      addBox(+(width / 2 - fs / 2), innerBot + innerH / 2, fs, innerH, frameDepth, frameMat);
    }
    if (innerW > 0.001 && innerH > 0.001) {
      const fillDepth = isWin ? 0.008 : thick;
      const fillMat   = isWin ? glassMat : frameMat;
      if (isWin) {
        const _oid = extraUD?.voId || (extraUD?.openingSourceRef?.uuid) || '';
        const _isSinglePane = !_oid || !(window.STATE?._splitIds?.has(_oid));
        const n = _isSinglePane ? 1 : width <= 1.40 ? 1 : width <= 2.80 ? 2 : width <= 4.20 ? 3 : 4;
        const pw = width / n;
        if (n === 1) {
          addBox(0, innerBot + innerH / 2, innerW, innerH, fillDepth, fillMat);
        } else {
          let cursor = -width / 2;
          for (let pi = 0; pi < n; pi++) {
            const leftEdge  = cursor + (pi === 0 ? fs : fs / 2);
            const rightEdge = cursor + pw - (pi === n - 1 ? fs : fs / 2);
            addBox((leftEdge + rightEdge) / 2, innerBot + innerH / 2, Math.max(0.001, rightEdge - leftEdge), innerH, fillDepth, fillMat);
            if (pi < n - 1) addBox(cursor + pw - fs / 2, innerBot + innerH / 2, fs, innerH, frameDepth, frameMat);
            cursor += pw;
          }
        }
      } else {
        addBox(0, innerBot + innerH / 2, innerW, innerH, fillDepth, fillMat);
      }
    }
    return pieces;
  },
  _buildPlanAt(cx, cz, ux, uz, width, thick, planY, type, scope, extraUD = {}) {
    const PLAN_H = 0.015;
    const fs = (type === 'idr') ? 0.07 : 0.10;
    const y = planY + PLAN_H / 2;
    const offset = (type === 'win' || type === 'edr') ? Math.max(0, (CONFIG.winFrameOffsetMm || 100) / 1000) : 0;
    const planThick = Math.max(0.020, thick - 2 * offset);
    const sX = m => Math.abs(ux) > 0.5 ? m : planThick;
    const sZ = m => Math.abs(ux) > 0.5 ? planThick : m;
    const ud = { isPlanIndicator: true, planScope: scope, planType: type,
                 isOpeningGenerated: true, openingScope: scope, openingType: type, ...extraUD };
    const makeMesh = (tC, bw, isGlass = false) => {
      if (bw < 0.001) return null;
      const geo = new THREE.BoxGeometry(sX(bw), PLAN_H, sZ(bw));
      const mat = isGlass
        ? SceneMaterials._make('win')
        : type === 'idr' ? SceneMaterials._make('idr')
        : new THREE.MeshStandardMaterial({ color: new THREE.Color(CONFIG.meshColors.win), roughness: 0.5 });
      mat.depthTest = false;
      mat.needsUpdate = true;
      const m = new THREE.Mesh(geo, mat);
      m.position.set(cx + tC * ux, y, cz + tC * uz);
      m.renderOrder = 10;
      m.castShadow = false;
      m.receiveShadow = false;
      m.visible = (STATE.view === '2d-top');
      m.userData = { ...ud };
      Engine.scene.add(m);
      this._planMeshes.push(m);
      return m;
    };
    if (type === 'win') {
      makeMesh(-(width / 2 - fs / 2), fs);
      const _oid2 = extraUD?.voId || (extraUD?.openingSourceRef?.uuid) || '';
      const _isSinglePane2 = !_oid2 || !(window.STATE?._splitIds?.has(_oid2));
      const n = _isSinglePane2 ? 1 : width <= 1.40 ? 1 : width <= 2.80 ? 2 : width <= 4.20 ? 3 : 4;
      const pw = width / n;
      if (n === 1) {
        makeMesh(0, Math.max(0, width - 2 * fs), true);
      } else {
        let cursor = -width / 2;
        for (let pi = 0; pi < n; pi++) {
          const leftEdge  = cursor + (pi === 0 ? fs : fs / 2);
          const rightEdge = cursor + pw - (pi === n - 1 ? fs : fs / 2);
          makeMesh((leftEdge + rightEdge) / 2, Math.max(0.001, rightEdge - leftEdge), true);
          if (pi < n - 1) makeMesh(cursor + pw - fs / 2, fs);
          cursor += pw;
        }
      }
      makeMesh(+(width / 2 - fs / 2), fs);
    } else {
      makeMesh(0, width);
    }
  },
  _buildExtPlans(fl) {
    const ranges = STATE.extFloorRanges || {};
    const r = ranges[fl];
    if (!r) return;
    const corners = STATE.extCorners[fl] || [];
    const n = corners.length;
    const thick = (typeof ExtWallParser !== 'undefined' && ExtWallParser._thickW) ? ExtWallParser._thickW : 0.25;
    const planY = r.max + 0.02;
    const baseY = r.min;
    const wallH = Math.max(0.05, r.max - r.min);
    for (let i = 0; i < n; i++) {
      const A = corners[i], B = corners[(i + 1) % n];
      const dx = B.x - A.x, dz = B.z - A.z;
      const len = Math.sqrt(dx * dx + dz * dz);
      if (len < 0.001) continue;
      const ux = dx / len, uz = dz / len;
      const nx = -uz;
      const ops = WallHoleCutter.getForSegment(A, B, baseY, wallH, thick).filter(op => op.type !== 'idr');
      ops.forEach(op => {
        if (!op.type || op.type === 'cut') return;
        const cx = A.x + op.t * ux - (thick / 2) * nx;
        const cz_val = A.z + op.t * uz - (thick / 2) * uz * 0;
        const nz_val = ux;
        const cz_w = A.z + op.t * uz - (thick / 2) * nz_val;
        this._buildPlanAt(cx, cz_w, ux, uz, op.hw * 2, thick, planY, op.type, 'ext',
          { floorNum: fl,
            openingSourceRef: op.src?.isVirtual ? null : op.src,
            voId: op.src?.isVirtual ? op.src.voId : undefined,
            wallA: {x:A.x,z:A.z}, wallB: {x:B.x,z:B.z}, wallThick: thick, wallIdx: i });
      });
    }
  },
  _buildIntPlans() {
    const thick = CONFIG.thickIntMm / 1000;
    (IntPartitionParser._partitions || []).forEach(p => {
      if (!p.nA || !p.nB) return;
      const dx = p.nB.x - p.nA.x, dz = p.nB.z - p.nA.z;
      const len = Math.sqrt(dx * dx + dz * dz) || 1;
      const ux = dx / len, uz = dz / len;
      const planY = p.baseY + p.heightM + 0.02;
      (p.fixedOps || []).forEach((fo, opIdx) => {
        if (!fo.type || fo.type === 'cut') return;
        const t = fo.tFrac * p.lenM;
        this._buildPlanAt(p.nA.x + t*ux, p.nA.z + t*uz, ux, uz, fo.hw*2, thick, planY,
          fo.type||'idr', 'int', { floorNum: p.fl, partitionRef: p, fixedOpIdx: opIdx });
      });
      (STATE.virtualOpenings || []).filter(vo =>
        vo.wallType === 'int' && (vo.partRef === p ||
          (Math.abs(vo.A.x - p.nA.x) < 0.05 && Math.abs(vo.A.z - p.nA.z) < 0.05 &&
           Math.abs(vo.B.x - p.nB.x) < 0.05 && Math.abs(vo.B.z - p.nB.z) < 0.05))
      ).forEach(vo => {
        const lenP = Math.sqrt((p.nB.x-p.nA.x)**2 + (p.nB.z-p.nA.z)**2) || 1;
        const t = vo.tFrac * lenP;
        this._buildPlanAt(p.nA.x + t*ux, p.nA.z + t*uz, ux, uz, vo.width, thick, planY,
          vo.type, 'int', { floorNum: p.fl, partitionRef: p, voId: vo.id });
      });
    });
  },
  _buildAllPlans() {
    this._planMeshes.forEach(m => Engine.scene.remove(m));
    this._planMeshes = [];
    Object.keys(STATE.extFloorRanges || {}).forEach(fl => this._buildExtPlans(parseInt(fl)));
    this._buildIntPlans();
  },
  setPlanVisible(visible) {
    this._planMeshes.forEach(m => { m.visible = visible; });
    this._meshes.forEach(m => { if (m.userData.isOpeningGenerated) m.visible = !visible; });
  },
  _buildFromSources() {
    (STATE.openingSources || []).forEach(src => {
      const type = src.userData.openingType;
      if (!type || type === 'cut') return;
      src.updateMatrixWorld(true);
      const box = new THREE.Box3().setFromObject(src);
      const sz  = box.getSize(new THREE.Vector3());
      const ctr = box.getCenter(new THREE.Vector3());
      const axis  = sz.x >= sz.z ? 'x' : 'z';
      const ux    = axis === 'x' ? 1 : 0;
      const uz    = axis === 'x' ? 0 : 1;
      const wWide = axis === 'x' ? sz.x : sz.z;
      const wThk  = axis === 'x' ? sz.z : sz.x;
      this._buildOpeningAt(ctr, ux, uz, wWide, sz.y, box.min.y, wThk, type, 'ext')
        .forEach(m => { Engine.scene.add(m); this._meshes.push(m); });
    });
  },
  _buildFromPartitions() {
    const thick = CONFIG.thickIntMm / 1000;
    (IntPartitionParser._partitions || []).forEach(p => {
      if (!p.nA || !p.nB) return;
      const dx  = p.nB.x - p.nA.x, dz = p.nB.z - p.nA.z;
      const len = Math.sqrt(dx * dx + dz * dz) || 1;
      const ux  = dx / len, uz = dz / len;
      (p.fixedOps || []).forEach((fo, opIdx) => {
        if (!fo.type || fo.type === 'cut') return;
        const t  = fo.tFrac * p.lenM;
        const wx = p.nA.x + t * ux;
        const wz = p.nA.z + t * uz;
        const ctr = new THREE.Vector3(wx, p.baseY + fo.cy + fo.hh / 2, wz);
        const extraUD = { floorNum: p.fl, partitionRef: p, fixedOpIdx: opIdx };
        this._buildOpeningAt(ctr, ux, uz, fo.hw * 2, fo.hh, p.baseY + fo.cy, thick, fo.type || 'idr', 'int', extraUD)
          .forEach(m => { Engine.scene.add(m); this._meshes.push(m); });
      });
      (STATE.virtualOpenings || []).filter(vo => {
        if (vo.wallType !== 'int') return false;
        return (Math.abs(vo.A.x - p.nA.x) < 0.05 && Math.abs(vo.A.z - p.nA.z) < 0.05 &&
                Math.abs(vo.B.x - p.nB.x) < 0.05 && Math.abs(vo.B.z - p.nB.z) < 0.05) ||
               (Math.abs(vo.B.x - p.nA.x) < 0.05 && Math.abs(vo.B.z - p.nA.z) < 0.05 &&
                Math.abs(vo.A.x - p.nB.x) < 0.05 && Math.abs(vo.A.z - p.nB.z) < 0.05);
      }).forEach(vo => {
        const segLen = Math.sqrt((vo.B.x-vo.A.x)**2 + (vo.B.z-vo.A.z)**2) || 1;
        const t  = vo.tFrac * segLen;
        const wx = p.nA.x + t * ux;
        const wz = p.nA.z + t * uz;
        const sill = vo.sillHeight || 0;
        const ctr = new THREE.Vector3(wx, p.baseY + sill + vo.height / 2, wz);
        const extraUD = { floorNum: p.fl, partitionRef: p, voId: vo.id, glazed: !!vo.glazed };
        this._buildOpeningAt(ctr, ux, uz, vo.width, vo.height, p.baseY + sill, thick, vo.type, 'int', extraUD)
          .forEach(m => { Engine.scene.add(m); this._meshes.push(m); });
      });
    });
  },
};

window.OpeningMeshBuilder = OpeningMeshBuilder;
/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   INT DEBUG PANEL (moved from liquid)
   â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   INT DEBUG PANEL â€” live monitor
   â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
(function() {
  var _frozen = false;
  var _activeTab = 'parts';
  var _panel = null;
  var _content = null;
  var _status = null;
  var _tickId = null;

  // â”€â”€ helpers â”€â”€
  function p2(v){ return (v||0).toFixed(3); }
  function posKey(m){ return p2(m.position.x)+'_'+p2(m.position.y)+'_'+p2(m.position.z); }
  function dimStr(ud){ return (ud.w||0).toFixed(3)+'×'+(ud.d||0).toFixed(3)+'×'+(ud.wallH||0).toFixed(2); }

  // â”€â”€ scene scan helpers â”€â”€
  function getSceneIntMeshes(){
    var res=[];
    if(!window.Engine||!Engine.scene) return res;
    Engine.scene.traverse(function(o){
      if(!o.isMesh) return;
      var ud=o.userData;
      // Only count meshes actively managed as INT walls (not hidden GLB sources)
      if(ud.isIntWall && o.visible)
        res.push(o);
    });
    return res;
  }

  function getIntWallParts(){
    var IWP=window.IntWallParser;
    return IWP ? (IWP._parts||[]) : [];
  }

  function findDupes(meshes){
    var seen={}, dupes=[];
    meshes.forEach(function(m,i){
      var k=posKey(m);
      if(seen[k]!==undefined){ dupes.push([seen[k],i]); } else { seen[k]=i; }
    });
    return dupes;
  }

  // â”€â”€ tab renderers â”€â”€
  function renderParts(){
    var parts=getIntWallParts();
    var IWP=window.IntWallParser;
    var S=window.STATE;
    var out='';
    out+='IntWallParser._parts : '+parts.length+'\n';
    out+='IntWallParser._meshes: '+((IWP&&IWP._meshes)?IWP._meshes.length:'?')+'\n';
    out+='STATE.elements.layouts: '+((S&&S.elements&&S.elements.layouts)?S.elements.layouts.length:'?')+'\n';
    out+='\n';

    if(!parts.length){ out+='(no parts)'; return out; }

    // Detect dupes by position
    var posCnt={};
    parts.forEach(function(p,i){
      if(!p.mesh) return;
      var k=posKey(p.mesh);
      posCnt[k]=(posCnt[k]||[]);
      posCnt[k].push(i);
    });

    out+='#   ax fl  pos_x    pos_y    pos_z    w×d×h             dupe?\n';
    out+='â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n';
    parts.forEach(function(p,i){
      if(!p.mesh){ out+=i+' [no mesh]\n'; return; }
      var mp=p.mesh.position;
      var k=posKey(p.mesh);
      var isDupe=posCnt[k].length>1;
      var line= ('  '+i).slice(-3)+' '
               +(p.axis||'?')+'  '
               +(p.fl!==undefined?p.fl:'?')+'   '
               +(mp.x>=0?' ':'')+p2(mp.x)+'  '
               +(mp.y>=0?' ':'')+p2(mp.y)+'  '
               +(mp.z>=0?' ':'')+p2(mp.z)+'  '
               +dimStr(p.mesh.userData)+'  ';
      if(isDupe) line+=' âš  DUPE ['+posCnt[k].join(',')+']';
      out+=line+'\n';
    });
    return out;
  }

  function renderScene(){
    var meshes=getSceneIntMeshes();
    var S=window.STATE;
    var out='';
    out+='Scene INT meshes: '+meshes.length+'\n';
    out+='(isIntWall=true or name ~INT)\n\n';
    if(!meshes.length){ out+='(none found)'; return out; }

    var posCnt={};
    meshes.forEach(function(m,i){
      var k=posKey(m);
      (posCnt[k]=posCnt[k]||[]).push(i);
    });

    out+='#   name                 vis  isIntWall  pos_x    pos_y    pos_z   dupe?\n';
    out+='â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€\n';
    meshes.forEach(function(m,i){
      var ud=m.userData;
      var k=posKey(m);
      var isDupe=posCnt[k].length>1;
      var nm=(m.name||'(no name)').slice(0,20);
      var line=('  '+i).slice(-3)+'  '
              +(nm+'                    ').slice(0,20)+'  '
              +(m.visible?'Y':'N')+'   '
              +(!!ud.isIntWall?'Y':'N')+'          '
              +(m.position.x>=0?' ':'')+p2(m.position.x)+'  '
              +(m.position.y>=0?' ':'')+p2(m.position.y)+'  '
              +(m.position.z>=0?' ':'')+p2(m.position.z)+'  ';
      if(isDupe) line+='âš  DUPE ['+posCnt[k].join(',')+']';
      out+=line+'\n';
    });

    // layouts info
    out+='\nâ”€â”€â”€ STATE.elements.layouts â”€â”€â”€\n';
    ((S&&S.elements&&S.elements.layouts)||[]).forEach(function(s,i){
      out+='['+i+'] '+s.name+' vis='+s.visible+' isExtSrc='+!!s.userData.isExtSource+'\n';
    });
    return out;
  }

  function renderDupes(){
    var meshes=getSceneIntMeshes();
    var parts=getIntWallParts();
    var out='';

    // Scene-level dupes
    var sdups=findDupes(meshes);
    out+='=== SCENE DUPES (by position Â±0.0005) ===\n';
    if(!sdups.length){ out+='âś“ none\n'; }
    else {
      sdups.forEach(function(pair){
        var a=meshes[pair[0]], b=meshes[pair[1]];
        out+='âš  scene['+pair[0]+'] '+( a.name||'?')+' == scene['+pair[1]+'] '+(b.name||'?')+'\n';
        out+='   pos=('+p2(a.position.x)+', '+p2(a.position.y)+', '+p2(a.position.z)+')\n';
      });
    }

    // Parts-level dupes
    var pmeshes=parts.map(function(p){return p.mesh;}).filter(Boolean);
    var pdups=findDupes(pmeshes);
    out+='\n=== PARTS DUPES ===\n';
    if(!pdups.length){ out+='âś“ none\n'; }
    else {
      pdups.forEach(function(pair){
        var a=pmeshes[pair[0]], b=pmeshes[pair[1]];
        out+='âš  parts['+pair[0]+'] == parts['+pair[1]+']\n';
        out+='   pos=('+p2(a.position.x)+', '+p2(a.position.y)+', '+p2(a.position.z)+')\n';
      });
    }

    // Cross-check: are any scene meshes missing from _parts?
    out+='\n=== ORPHAN scene meshes (not in _parts) ===\n';
    var IWP=window.IntWallParser;
    var partMeshSet=new Set((IWP&&IWP._meshes)||[]);
    var orphans=meshes.filter(function(m){ return !partMeshSet.has(m); });
    if(!orphans.length){ out+='âś“ none\n'; }
    else {
      orphans.forEach(function(m){
        out+='âš  '+( m.name||'(no name)')+' pos=('+p2(m.position.x)+','+p2(m.position.y)+','+p2(m.position.z)+')\n';
      });
    }
    return out;
  }

  function renderGraph(){
    var WG=window.WallGraph, IPP=window.IntPartitionParser, S=window.STATE;
    var out='';
    out+='=== WallGraph segments ===\n';
    var segs=(WG&&WG.segments)||[];
    var extSegs=segs.filter(function(s){return s.type==='ext';});
    var intSegs=segs.filter(function(s){return s.type==='int';});
    out+='EXT: '+extSegs.length+'  INT: '+intSegs.length+'\n\n';
    extSegs.forEach(function(s){
      out+=s.id+' nA('+s.nA.x.toFixed(3)+','+s.nA.z.toFixed(3)+') nB('+s.nB.x.toFixed(3)+','+s.nB.z.toFixed(3)+')\n';
    });
    out+='\n=== IntPartitionParser ===\n';
    var parts=(IPP&&IPP._partitions)||[];
    out+='_partitions: '+parts.length+'  _meshes: '+((IPP&&IPP._meshes)||[]).length+'\n\n';
    parts.forEach(function(p){
      var nA=p.nA,nB=p.nB;
      out+=p.id+' ax='+p.axis+' fl='+p.fl+'\n';
      out+='  nA x='+(nA?nA.x.toFixed(3):'?')+' z='+(nA?nA.z.toFixed(3):'?')+'\n';
      out+='  nB x='+(nB?nB.x.toFixed(3):'?')+' z='+(nB?nB.z.toFixed(3):'?')+'\n';
    });
    return out;
  }

  function renderJoints(){
    var IWP=window.IntWallParser;
    var cs=(IWP&&IWP._constraints)||[];
    var out='=== JOINTS & CONSTRAINTS ('+cs.length+') ===\n\n';
    if(!cs.length){ out+='(none â€” call IntWallParser._computeConstraints())'; return out; }
    function jStr(j){
      if(!j) return '!! NONE';
      if(j.type==='ext') return 'EXT seg'+j.segIdx+' t='+j.t;
      return 'INT['+j.partIdx+'] '+j.glbName;
    }
    cs.forEach(function(c,i){
      var p=c.part, mp=p.mesh?p.mesh.position:null;
      var nm=(p.glbName||'?').slice(0,16);
      out+=i+'. ['+p.axis+'] '+nm+'\n';
      if(p.axis==='x'){
        var xA=mp?(mp.x-p.w/2).toFixed(3):'?', xB=mp?(mp.x+p.w/2).toFixed(3):'?';
        out+='  nA ('+xA+', '+(mp?mp.z.toFixed(3):'?')+') â†’ '+jStr(c.jA)+'\n';
        out+='  nB ('+xB+', '+(mp?mp.z.toFixed(3):'?')+') â†’ '+jStr(c.jB)+'\n';
        out+='  range Z ['+c.minPos.toFixed(3)+' â€¦ '+c.maxPos.toFixed(3)+']  cur='+(mp?mp.z.toFixed(3):'?')+'\n';
      } else {
        var zA=mp?(mp.z-p.d/2).toFixed(3):'?', zB=mp?(mp.z+p.d/2).toFixed(3):'?';
        out+='  nA ('+(mp?mp.x.toFixed(3):'?')+', '+zA+') â†’ '+jStr(c.jA)+'\n';
        out+='  nB ('+(mp?mp.x.toFixed(3):'?')+', '+zB+') â†’ '+jStr(c.jB)+'\n';
        out+='  range X ['+c.minPos.toFixed(3)+' â€¦ '+c.maxPos.toFixed(3)+']  cur='+(mp?mp.x.toFixed(3):'?')+'\n';
      }
      out+='\n';
    });
    return out;
  }

  function renderActive(){
    try {
      if(_activeTab==='parts')  return renderParts();
      if(_activeTab==='scene')  return renderScene();
      if(_activeTab==='dupes')  return renderDupes();
      if(_activeTab==='joints') return renderJoints();
      if(_activeTab==='graph')  return renderGraph();
      if(_activeTab==='points') return renderPoints();
      if(_activeTab==='log')    return renderLog();
    } catch(e){ return '!! ERROR: '+e.message; }
    return '';
  }

  // â”€â”€ tick â”€â”€
  function tick(){
    if(_frozen) return;
    if(!_panel || _panel.style.display==='none' || _panel.style.display==='') return;
    var txt=renderActive();
    if(_content) _content.textContent=txt;
    if(_activeTab==='points') _refreshPointOverlay();

    // status bar
    var parts=getIntWallParts(), sm=getSceneIntMeshes();
    var pdups=findDupes(sm).length;
    if(_status) _status.textContent=
      'parts:'+parts.length+' sceneMeshes:'+sm.length
      +(pdups?' âš DUPES:'+pdups:' âś“nodupes')
      +'  @'+new Date().toLocaleTimeString();
  }

  // â”€â”€ init (after DOM ready) â”€â”€
  function init(){
    _panel   = document.getElementById('cv5-idbg-panel');
    _content = document.getElementById('cv5-idbg-content');
    _status  = document.getElementById('cv5-idbg-status');
    if(!_panel) return;

    // â”€â”€ panel drag â”€â”€
    (function(){
      var handle=document.getElementById('cv5-idbg-drag');
      if(!handle||!_panel) return;
      var ox=0,oy=0,px=0,py=0,dragging=false;
      handle.addEventListener('pointerdown',function(e){
        dragging=true;
        handle.style.cursor='grabbing';
        // Get current panel position (left/top, defaulting from current offset)
        var rect=_panel.getBoundingClientRect();
        var root=document.getElementById('cv5-root');
        var rr=root?root.getBoundingClientRect():{left:0,top:0};
        px=rect.left-rr.left; py=rect.top-rr.top;
        ox=e.clientX; oy=e.clientY;
        // Switch to absolute left/top positioning
        _panel.style.left=px+'px'; _panel.style.top=py+'px';
        _panel.style.right='auto'; _panel.style.bottom='auto';
        handle.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      handle.addEventListener('pointermove',function(e){
        if(!dragging) return;
        var dx=e.clientX-ox, dy=e.clientY-oy;
        var root=document.getElementById('cv5-root');
        var rr=root?root.getBoundingClientRect():{width:9999,height:9999};
        var nLeft=Math.max(0,Math.min(px+dx, rr.width-60));
        var nTop =Math.max(0,Math.min(py+dy, rr.height-60));
        _panel.style.left=nLeft+'px'; _panel.style.top=nTop+'px';
      });
      handle.addEventListener('pointerup',function(){
        dragging=false; handle.style.cursor='grab';
      });
    })();

    // open button
    var openBtn=document.getElementById('cv5-idbg-btn');
    if(openBtn) openBtn.addEventListener('click', function(){
      _panel.style.display='flex';
      tick();
    });
    // In dev mode panel is always visible â€” start tick immediately
    if(window.CONFIG&&window.CONFIG.devMode){
      if(_panel) _panel.style.display='flex';
      _tickId=setInterval(tick, 500);
    }

    // close button
    var closeBtn=document.getElementById('cv5-idbg-close');
    if(closeBtn) closeBtn.addEventListener('click', function(){
      _panel.style.display='none';
    });

    // freeze toggle
    var freezeBtn=document.getElementById('cv5-idbg-freeze');
    if(freezeBtn) freezeBtn.addEventListener('click', function(){
      _frozen=!_frozen;
      freezeBtn.textContent=_frozen?'â–¶ LIVE':'âŹ¸ FREEZE';
      freezeBtn.style.color=_frozen?'#f90':'#ff0';
    });

    // tabs
    _panel.querySelectorAll('.cv5-idbg-tab').forEach(function(btn){
      btn.addEventListener('click', function(){
        _activeTab=btn.dataset.tab;
        _panel.querySelectorAll('.cv5-idbg-tab').forEach(function(b){
          b.style.background= b===btn ? '#001830' : 'transparent';
          b.style.color=      b===btn ? '#0ff'    : '#0ff8';
        });
        tick();
      });
    });

    // auto-refresh
    _tickId=setInterval(tick, 500);
  }

  if(document.readyState==='loading')
    document.addEventListener('DOMContentLoaded', init);
  else
    init();

  // â”€â”€ POINTS overlay (only active when POINTS tab is open) â”€â”€
  var _ptDots = [];
  var _PT_COLORS = {
    'ext-corner':  '#ff3333',
    'int-endpoint':'#00ff44',
    'int-face':    '#00ffff',
    'int-center':  '#ff8800',
    'joint-ext':   '#ff00ff',
    'joint-int':   '#ffff00'
  };

  function _collectDebugPoints() {
    var pts = [], fl = (window.STATE&&window.STATE.activeFloor)||1;
    var S = window.STATE, IWP = window.IntWallParser;
    var corners = (S&&S.extCorners&&S.extCorners[fl])||[];
    corners.forEach(function(c,i){ pts.push({x:c.x,z:c.z,group:'ext-corner',label:'EC'+i}); });
    var parts = (IWP&&IWP._parts)||[];
    parts.forEach(function(p,i){
      if(!p.mesh) return;
      var mp=p.mesh.position, ud=p.mesh.userData;
      pts.push({x:mp.x,z:mp.z,group:'int-center',label:'C'+i});
      if(ud.axis==='x'){
        pts.push({x:mp.x-ud.w/2,z:mp.z,group:'int-endpoint',label:'A'+i});
        pts.push({x:mp.x+ud.w/2,z:mp.z,group:'int-endpoint',label:'B'+i});
        pts.push({x:mp.x,z:mp.z-ud.d/2,group:'int-face',label:'FN'+i});
        pts.push({x:mp.x,z:mp.z+ud.d/2,group:'int-face',label:'FS'+i});
      } else {
        pts.push({x:mp.x,z:mp.z-ud.d/2,group:'int-endpoint',label:'A'+i});
        pts.push({x:mp.x,z:mp.z+ud.d/2,group:'int-endpoint',label:'B'+i});
        pts.push({x:mp.x-ud.w/2,z:mp.z,group:'int-face',label:'FW'+i});
        pts.push({x:mp.x+ud.w/2,z:mp.z,group:'int-face',label:'FE'+i});
      }
    });
    var joints = (IWP&&IWP._intJoints)||[];
    joints.forEach(function(j,i){
      if(j.type==='ext'){
        var c2=(S&&S.extCorners&&S.extCorners[fl])||[];
        var A=c2[j.segIdx], B=c2[(j.segIdx+1)%c2.length];
        if(A&&B) pts.push({x:A.x+j.tFrac*(B.x-A.x),z:A.z+j.tFrac*(B.z-A.z),group:'joint-ext',label:'JE'+i});
      } else {
        var pp=parts[j.pi]; if(!pp||!pp.mesh) return;
        var pmp=pp.mesh.position, pud=pp.mesh.userData;
        var hl=pud.axis==='x'?pud.w/2:pud.d/2, ht=pud.axis==='x'?pud.d/2:pud.w/2;
        var so=j.side==='neg'?-ht:ht, tx, tz;
        if(pud.axis==='x'){tx=(pmp.x-hl)+j.tFrac*2*hl;tz=pmp.z+so;}
        else{tx=pmp.x+so;tz=(pmp.z-hl)+j.tFrac*2*hl;}
        pts.push({x:tx,z:tz,group:'joint-int',label:'JI'+i});
      }
    });
    return pts;
  }

  function _refreshPointOverlay() {
    var layer = document.getElementById('cv5-dimlayer');
    if(!layer) return;
    _ptDots.forEach(function(el){ if(el.parentNode) el.parentNode.removeChild(el); });
    _ptDots = [];
    if(!window.STATE || window.STATE.view !== '2d-top') return;
    var E = window.Engine; if(!E) return;
    var yW = 0, fl = (window.STATE.activeFloor)||1;
    if(window.STATE.extFloorRanges&&window.STATE.extFloorRanges[fl])
      yW = window.STATE.extFloorRanges[fl].min + 0.05;
    _collectDebugPoints().forEach(function(p) {
      var sp = E.toScreen(new THREE.Vector3(p.x, yW, p.z));
      var dot = document.createElement('div');
      dot.style.cssText = 'position:absolute;pointer-events:none;z-index:300;border-radius:50%;'
        + 'left:'+(Math.round(sp.x)-6)+'px;top:'+(Math.round(sp.y)-6)+'px;'
        + 'width:12px;height:12px;'
        + 'background:'+(_PT_COLORS[p.group]||'#fff')+';'
        + 'border:1.5px solid rgba(0,0,0,0.6);box-sizing:border-box;';
      dot.title = p.group+' '+p.label+' ('+p.x.toFixed(3)+', '+p.z.toFixed(3)+')';
      layer.appendChild(dot);
      _ptDots.push(dot);
    });
  }

  function renderPoints() {
    _refreshPointOverlay();
    var pts = _collectDebugPoints();
    var groups = {}, order = ['ext-corner','int-center','int-endpoint','int-face','joint-ext','joint-int'];
    pts.forEach(function(p){ if(!groups[p.group]) groups[p.group]=[]; groups[p.group].push(p); });
    var out = '=== DEBUG POINTS ('+pts.length+') ===\n';
    out += 'RED=EXT-corner  LIME=INT-endpoint  CYAN=INT-face\n';
    out += 'ORANGE=INT-center  MAGENTA=joint-EXT  YELLOW=joint-INT\n\n';
    order.forEach(function(g) {
      var arr = groups[g]||[]; if(!arr.length) return;
      out += '-- '+g+' ('+arr.length+')\n';
      arr.forEach(function(p) {
        var lbl = (p.label+'        ').slice(0,8);
        var px = ('         '+p.x.toFixed(3)).slice(-9);
        var pz = ('         '+p.z.toFixed(3)).slice(-9);
        out += '  '+lbl+px+'  '+pz+'\n';
      });
      out += '\n';
    });
    return out;
  }

  function renderLog() {
    var log = window._intLog || [];
    if (!log.length) return '(no log entries yet)\n\nDrag an EXT wall, then try INT.';
    return log.slice(-60).reverse().join('\n');
  }

})();
/* â•â•â• WallGraph â•â•â• */
const WallGraph = {
  nodes:    [],
  segments: [],
  reset() {
    this.nodes    = [];
    this.segments = [];
  },
  initFromExt() {
    this.nodes    = this.nodes.filter(n => n.type !== 'ext');
    this.segments = this.segments.filter(s => s.type !== 'ext');
    Object.entries(STATE.extCorners || {}).forEach(([flStr, corners]) => {
      const fl = parseInt(flStr);
      const n  = corners.length;
      const flNodes = corners.map((c, i) => {
        c.id   = `ext_f${fl}_n${i}`;
        c.fl   = fl;
        c.type = 'ext';
        this.nodes.push(c);
        return c;
      });
      for (let i = 0; i < n; i++) {
        const nA   = flNodes[i];
        const nB   = flNodes[(i + 1) % n];
        const dx   = nB.x - nA.x, dz = nB.z - nA.z;
        const axis = Math.abs(dx) > Math.abs(dz) ? 'x' : 'z';
        this.segments.push({ id: `ext_f${fl}_s${i}`, nA, nB, fl, type: 'ext', axis });
      }
    });
    console.log(`[WallGraph] EXT init: ${this.nodes.filter(n=>n.type==='ext').length} nodes, `
      + `${this.segments.filter(s=>s.type==='ext').length} segments`);
  },
  addIntSegments() {
    this.nodes    = this.nodes.filter(n => n.type !== 'int');
    this.segments = this.segments.filter(s => s.type !== 'int');
    (IntPartitionParser._partitions || []).forEach(p => {
      if (!p.nA || !p.nB) return;
      const nA = { id: `int_${p.id}_nA`, x: p.nA.x, z: p.nA.z, fl: p.fl, type: 'int' };
      const nB = { id: `int_${p.id}_nB`, x: p.nB.x, z: p.nB.z, fl: p.fl, type: 'int' };
      this.nodes.push(nA, nB);
      this.segments.push({ id: `int_${p.id}`, nA, nB, fl: p.fl, type: 'int', axis: p.axis, ref: p });
    });
    console.log(`[WallGraph] INT added: ${this.nodes.filter(n=>n.type==='int').length} nodes, `
      + `${this.segments.filter(s=>s.type==='int').length} segments`);
  },
  getOrCreate(x, z, fl, TOL) {
    const found = this.nodes.find(n => n.type==='int' && n.fl===fl && Math.hypot(n.x-x, n.z-z) < TOL);
    if (found) return found;
    const id = 'int_n' + this.nodes.filter(n=>n.type==='int').length;
    const n = { id, x, z, fl, type: 'int' };
    this.nodes.push(n);
    return n;
  },
};
window.WallGraph = WallGraph;

/* â•â•â• BindingGroups â•â•â• */
const BindingGroups = {
  SNAP:0.08,
  build() {
    const segs=STATE.wallSegments,used=new Set();let gi=0;
    segs.forEach(s=>{
      if(used.has(s.id))return;
      const g={id:`bg-${gi++}`,segIds:[s.id],axis:s.axis,refLength:s.refLength,label:s.label};
      used.add(s.id);
      segs.forEach(t=>{if(used.has(t.id)||t.id===s.id||t.axis!==s.axis)return;const sp=this.SNAP;const same=s.axis==='x'?Math.abs(s.bbox.min.z-t.bbox.min.z)<sp&&Math.abs(s.bbox.max.z-t.bbox.max.z)<sp:Math.abs(s.bbox.min.x-t.bbox.min.x)<sp&&Math.abs(s.bbox.max.x-t.bbox.max.x)<sp;if(same){g.segIds.push(t.id);used.add(t.id);}});
      STATE.bindingGroups[g.id]=g;
    });
    
  }
};
window.BindingGroups = BindingGroups;

/* â•â•â• WallHoleCutter â•â•â• */
const WallHoleCutter = {
  getForSegment(A, B, baseY, wallH, thick) {
    const dx=B.x-A.x, dz=B.z-A.z;
    const len=Math.sqrt(dx*dx+dz*dz)||1;
    const ux=dx/len, uz=dz/len;
    const nx=-uz,    nz=ux;
    const result = [];
    (STATE.openingSources||[]).forEach(src => {
      if(src.userData._consumed) return; // converted to virtualOpening at init
      src.updateMatrixWorld(true);
      const box=new THREE.Box3().setFromObject(src);
      const ctr=box.getCenter(new THREE.Vector3());
      const sz =box.getSize(new THREE.Vector3());
      const nProj = (ctr.x-A.x)*nx + (ctr.z-A.z)*nz;
      const TOL = thick * 2.0;
      if (nProj > TOL || nProj < -(thick + TOL)) return;
      const t = (ctr.x-A.x)*ux + (ctr.z-A.z)*uz;
      if (t < -0.05 || t > len+0.05) return;
      const hw = (Math.abs(sz.x*ux) + Math.abs(sz.z*uz)) / 2;
      const cy = Math.max(0, box.min.y - baseY);
      const hh = Math.min(sz.y, wallH - cy);
      if (hh < 0.01) return;
      result.push({ t, hw, cy, hh, type: src.userData.openingType || 'idr', src });
    });
    (STATE.virtualOpenings||[]).forEach(vo => {
      const dax=B.x-A.x, daz=B.z-A.z, vlen=Math.sqrt(dax*dax+daz*daz)||1;
      const vux=dax/vlen, vuz=daz/vlen;
      let sameSeg;
      if (vo.wallType === 'ext' && vo.wallIdx !== undefined && vo.wallIdx !== null) {
        const corners = (STATE.extCorners||{})[vo.fl] || [];
        const liveA = corners[vo.wallIdx];
        const liveB = corners[(vo.wallIdx+1) % corners.length];
        if (liveA && liveB) {
          vo.A = { x: liveA.x, z: liveA.z };
          vo.B = { x: liveB.x, z: liveB.z };
        }
        sameSeg = liveA && liveB &&
          Math.abs(liveA.x-A.x)<0.05 && Math.abs(liveA.z-A.z)<0.05 &&
          Math.abs(liveB.x-B.x)<0.05 && Math.abs(liveB.z-B.z)<0.05;
      } else {
        sameSeg = (Math.abs(vo.A.x-A.x)<0.05 && Math.abs(vo.A.z-A.z)<0.05 &&
                   Math.abs(vo.B.x-B.x)<0.05 && Math.abs(vo.B.z-B.z)<0.05) ||
                  (Math.abs(vo.B.x-A.x)<0.05 && Math.abs(vo.B.z-A.z)<0.05 &&
                   Math.abs(vo.A.x-B.x)<0.05 && Math.abs(vo.A.z-B.z)<0.05);
      }
      if (!sameSeg) return;
      if (vo.fl !== undefined && vo.fl !== null) {
        const r = (STATE.extFloorRanges||{})[vo.fl];
        if (r && (baseY < r.min - 0.1 || baseY > r.max + 0.1)) return;
      }
      let t, hw;
      if (vo.type === 'cut' && vo.leftDist !== undefined && vo.rightDist !== undefined) {
        // CUT: stretches with wall, residuals (leftDist, rightDist) preserved
        const _cutLen = Math.max(0.01, vlen - vo.leftDist - vo.rightDist);
        t = vo.leftDist + _cutLen / 2;
        hw = _cutLen / 2;
      } else {
        // Standard: tFrac-based position with fixed width
        t = vo.tFrac * vlen;
        hw = vo.width / 2;
      }
      const cy = vo.sillHeight || 0;
      const hh = Math.min(vo.height, wallH - cy);
      if (hh < 0.01) return;
      const fakeSrc = {
        isVirtual: true, voId: vo.id, _vo: vo,
        userData: { openingType: vo.type, isOpeningSource: true },
        matrixAutoUpdate: false,
        updateMatrixWorld(){},
        matrix: { elements: [1,0,0,0, 0,1,0,0, 0,0,1,0, A.x+t*vux, baseY+cy+hh/2, A.z+t*vuz, 1] }
      };
      result.push({ t, hw, cy, hh, type: vo.type, src: fakeSrc, voId: vo.id });
    });
    return result.sort((a,b)=>a.t-b.t);
  },
  buildPieces(A, B, openings, thick, baseY, wallH, axis, matFn, userData) {
    const dx=B.x-A.x, dz=B.z-A.z;
    const len=Math.sqrt(dx*dx+dz*dz)||1;
    const ux=dx/len, uz=dz/len;
    const nx=-uz,    nz=ux;
    const pieces = [];
    const addBox = (xL, xR, yB, yT) => {
      const bw = xR-xL, bh = yT-yB;
      if (bw < 0.002 || bh < 0.002) return;
      const tc = (xL+xR)/2;
      const wx = A.x + tc*ux - (thick/2)*nx;
      const wy = baseY + (yB+yT)/2;
      const wz = A.z + tc*uz - (thick/2)*nz;
      const gW = axis==='x' ? bw    : thick;
      const gD = axis==='x' ? thick : bw;
      const geo = new THREE.BoxGeometry(gW, bh, gD);
      const uv=geo.attributes.uv;
      const fU=[thick,thick,bw,bw,bw,bw], fV=[bh,bh,thick,thick,bh,bh];
      for(let f=0;f<6;f++){const b=f*4,fu=fU[f],fv=fV[f];uv.setXY(b,0,fv);uv.setXY(b+1,fu,fv);uv.setXY(b+2,0,0);uv.setXY(b+3,fu,0);}
      uv.needsUpdate=true;
      const m=new THREE.Mesh(geo, matFn());
      m.position.set(wx, wy, wz);
      m.userData = userData;
      m.castShadow = m.receiveShadow = true;
      m.visible = true;
      pieces.push(m);
    };
    if (!openings.length) {
      addBox(0, len, 0, wallH);
      return pieces;
    }
    const ops = openings.map(o=>({
      xL: Math.max(0,   o.t - o.hw),
      xR: Math.min(len, o.t + o.hw),
      yB: Math.max(0,        o.cy),
      yT: Math.min(wallH,    o.cy + o.hh)
    })).filter(o=>o.xR-o.xL>0.002 && o.yT-o.yB>0.002)
       .sort((a,b)=>a.xL-b.xL);
    let curX = 0;
    for (const op of ops) {
      if (op.xL > curX+0.002) addBox(curX, op.xL, 0, wallH);
      if (op.yB > 0.002)       addBox(op.xL, op.xR, 0,     op.yB);
      if (op.yT < wallH-0.002) addBox(op.xL, op.xR, op.yT, wallH);
      curX = op.xR;
    }
    if (curX < len-0.002) addBox(curX, len, 0, wallH);
    return pieces;
  }
};
window.WallHoleCutter = WallHoleCutter;

/* â•â•â• Finishes â•â•â• */
const Finishes = {
  init(){document.querySelectorAll('.v4-fin-cat').forEach(btn=>{btn.addEventListener('click',()=>{document.querySelectorAll('.v4-fin-cat').forEach(b=>b.classList.remove('active'));btn.classList.add('active');STATE.finishes.activeCat=btn.dataset.fcat;STATE.finishes.activeTargetIdx=0;this.renderSwatches();this._updateTarget();});});document.getElementById('v4-fin-prev')?.addEventListener('click',()=>{if(STATE.finishes.activeTargetIdx>0){STATE.finishes.activeTargetIdx--;this._updateTarget();}});document.getElementById('v4-fin-next')?.addEventListener('click',()=>{const max=this._targets().length;if(STATE.finishes.activeTargetIdx<max){STATE.finishes.activeTargetIdx++;this._updateTarget();}});document.getElementById('v4-sl-texscale')?.addEventListener('input',function(){document.getElementById('v4-val-texscale').textContent=parseFloat(this.value).toFixed(1);Finishes._applyScale(parseFloat(this.value));});document.getElementById('v4-fin-upload')?.addEventListener('change',e=>{const f=e.target.files[0];if(!f)return;const url=URL.createObjectURL(f);new THREE.TextureLoader().load(url,tex=>{tex.colorSpace=THREE.SRGBColorSpace;tex.wrapS=tex.wrapT=THREE.RepeatWrapping;this._getMeshes().forEach(m=>{if(!m.material)return;m.material.map=tex;m.material.needsUpdate=true;});});});this.renderSwatches();},
  renderSwatches(){const grid=document.getElementById('v4-fin-swatches');grid.innerHTML='';const slots=CONFIG.finishes[STATE.finishes.activeCat]||[];slots.forEach((sl,i)=>{const sw=document.createElement('div');sw.className='v4-swatch';sw.style.background=sl.img?`url(${sl.img}) center/cover`:sl.col;sw.addEventListener('click',()=>this._applySlot(i));grid.appendChild(sw);});const up=document.createElement('div');up.className='v4-swatch-upload';up.textContent='+';up.addEventListener('click',()=>document.getElementById('v4-fin-upload').click());grid.appendChild(up);},
  _applySlot(i){const sl=CONFIG.finishes[STATE.finishes.activeCat]?.[i];if(!sl)return;const sc=CONFIG.finishes.scales[STATE.finishes.activeCat]||0.3;
if(STATE.finishes.activeCat==='floors'&&typeof FloorRadial!=='undefined'&&FloorRadial._pendingMesh){const pm=FloorRadial._pendingMesh;if(sl.img){new THREE.TextureLoader().load(sl.img,tex=>{tex.colorSpace=THREE.SRGBColorSpace;tex.wrapS=tex.wrapT=THREE.RepeatWrapping;tex.repeat.set(sc,sc);pm.material.map=tex;pm.material.color.set(0xffffff);pm.material.needsUpdate=true;pm.userData.hasTexture=true;FloorRadial._hideRoomLabel.call({_mesh:pm});});}else{pm.material.map=null;pm.material.color.set(sl.col);pm.material.needsUpdate=true;pm.userData.hasTexture=true;FloorRadial._hideRoomLabel.call({_mesh:pm});}document.querySelectorAll('.v4-swatch').forEach((sw,j)=>sw.classList.toggle('active',j===i));return;}const meshes=this._getMeshes();if(sl.img){SceneMaterials.setTexture(meshes,sl.img,sc);}else{SceneMaterials.setColor(meshes,sl.col);}if(STATE.finishes.activeCat==='roofs')RoofBuilder.applyFinish(sl.img||null,sl.col);document.querySelectorAll('.v4-swatch').forEach((sw,j)=>sw.classList.toggle('active',j===i));},
  _applyScale(sc){const cat=STATE.finishes.activeCat;if(CONFIG.finishes.scales[cat]!==undefined)CONFIG.finishes.scales[cat]=sc;const meshes=cat==='roofs'?RoofBuilder.getMeshes():this._getMeshes();meshes.forEach(mesh=>{if(mesh.material?.map){mesh.material.map.repeat.set(sc,sc);mesh.material.map.needsUpdate=true;mesh.material.needsUpdate=true;}});},
  _reapplyExt(meshes){if(!meshes?.length)return;const activeSwatch=document.querySelector('#v4-fin-swatches .v4-swatch.active');if(!activeSwatch)return;const swatches=[...document.querySelectorAll('#v4-fin-swatches .v4-swatch')],idx=swatches.indexOf(activeSwatch);if(idx<0)return;const prevCat=STATE.finishes.activeCat;STATE.finishes.activeCat='ext';const sl=CONFIG.finishes.ext?.[idx];if(!sl){STATE.finishes.activeCat=prevCat;return;}const sc=CONFIG.finishes.scales.ext||1;if(sl.img){SceneMaterials.setTexture(meshes,sl.img,sc);}else{SceneMaterials.setColor(meshes,sl.col);}STATE.finishes.activeCat=prevCat;},
  _getMeshes(){const catMap={ext:STATE.elements.walls,int:IntWallParser.getMeshes(),roofs:STATE.elements.roofs,floors:STATE.elements.floors,windows:STATE.elements.windows,doors:STATE.elements.doors},arr=catMap[STATE.finishes.activeCat]||[],idx=STATE.finishes.activeTargetIdx;return idx===0?arr:[arr[idx-1]].filter(Boolean);},
  _targets(){const catMap={ext:STATE.elements.walls,int:IntWallParser.getMeshes(),roofs:STATE.elements.roofs,floors:STATE.elements.floors,windows:STATE.elements.windows,doors:STATE.elements.doors};return catMap[STATE.finishes.activeCat]||[];},
  _updateTarget(){const targets=this._targets(),idx=STATE.finishes.activeTargetIdx,lbl=idx===0?'ALL':(targets[idx-1]?.userData.sysName||targets[idx-1]?.name||`#${idx}`);document.getElementById('v4-fin-target-label').textContent=lbl;}
};
window.Finishes = Finishes;

/* â•â•â• LayoutSwitcher â•â•â• */
const LayoutSwitcher = {
  _idx: 0,
  _SK: 'leva_layout_',
  init() {
    this._readIdx();
    const urls = CONFIG.layoutUrls || [];
    if (this._idx > 0 && urls[this._idx]) CONFIG.glbUrl = urls[this._idx];
    document.getElementById('v4-btn-reset')?.addEventListener('click', () => {
      try { sessionStorage.clear(); } catch(e){}
      window.location.reload();
    });
    if (urls.length < 2) return;
    const container = document.getElementById('cv5-layout-btns');
    if (!container) return;
    container.innerHTML = '';
    // Aktivní layout vždy na první pozici, ostatní v původním pořadí
    const order = [this._idx];
    for (let i = 0; i < urls.length; i++) {
      if (i !== this._idx) order.push(i);
    }
    order.forEach(i => {
      const btn = document.createElement('button');
      btn.className = 'v4-icon-btn cv5-layout-tab' + (i === this._idx ? ' active' : '');
      btn.textContent = 'L' + (i + 1);
      btn.dataset.layoutIdx = i;
      btn.addEventListener('click', () => this._switchTo(i));
      container.appendChild(btn);
    });
    container.style.display = 'flex';
    container.style.flexDirection = 'row';
    container.style.gap = '8px';
  },
  _switchTo(idx) {
    const urls = CONFIG.layoutUrls || [];
    if (idx === this._idx || !urls[idx]) return;
    this._saveState(this._idx);
    this._idx = idx;
    try {
      sessionStorage.setItem(this._SK + 'idx', this._idx);
      sessionStorage.setItem(this._SK + 'switching', '1');
    } catch (e) {}
    window.location.reload();
  },
  _readIdx() {
    try {
      const switching = sessionStorage.getItem(this._SK+'switching');
      if (switching) {
        this._idx = parseInt(sessionStorage.getItem(this._SK+'idx') || '0');
        sessionStorage.removeItem(this._SK+'switching');
      } else {
        this._idx = 0;
        sessionStorage.setItem(this._SK+'idx', '0');
      }
    } catch(e) { this._idx = 0; }
  },
  _next() {
    const urls = CONFIG.layoutUrls || [];
    if (urls.length < 2) return;
    this._saveState(this._idx);
    this._idx = (this._idx + 1) % urls.length;
    try {
      sessionStorage.setItem(this._SK+'idx', this._idx);
      sessionStorage.setItem(this._SK+'switching', '1');
    } catch(e){}
    window.location.reload();
  },
  _updateLabel() {
    const el = document.getElementById('v4-layout-num');
    if (el) el.textContent = this._idx + 1;
  },
  _saveState(idx) {
    try {
      const state = {
        extCorners: {},
        intParts: []
      };
      Object.keys(STATE.extCorners).forEach(fl => {
        state.extCorners[fl] = STATE.extCorners[fl].map(c => ({x:c.x, y:c.y, z:c.z}));
      });
      state.intParts = (IntPartitionParser._partitions||[]).map(p => ({
        id: p.id, cx: p.cx, cz: p.cz, lenM: p.lenM, halfLen: p.halfLen
      }));
      sessionStorage.setItem(this._SK+'state_'+idx, JSON.stringify(state));
    } catch(e) { console.warn('[LS] save failed', e); }
  },
  restoreState() {
    try {
      const raw = sessionStorage.getItem(this._SK+'state_'+this._idx);
      if (!raw) return false;
      const state = JSON.parse(raw);
      Object.keys(state.extCorners).forEach(fl => {
        const flN = parseInt(fl);
        const saved = state.extCorners[fl];
        const cur = STATE.extCorners[flN];
        if (!cur || cur.length !== saved.length) return;
        saved.forEach((c, i) => { cur[i].x = c.x; cur[i].y = c.y; cur[i].z = c.z; });
        ExtWallParser.rebuildFloor(flN);
      });
      state.intParts.forEach(s => {
        const p = IntPartitionParser._partitions.find(q => q.id === s.id);
        if (!p) return;
        p.cx = s.cx; p.cz = s.cz; p.lenM = s.lenM; p.halfLen = s.halfLen;
      });
      IntPartitionParser._buildJunctions();
      RoofBuilder.rebuildForWalls();
      if(typeof FloorParser!=='undefined')FloorParser.rebuild();
      CornerDrag.build();
      if(typeof UI!=='undefined')UI.refreshDimLabels();
      console.log('[LS] state restored for L'+(this._idx+1));
      return true;
    } catch(e) { console.warn('[LS] restore failed', e); return false; }
  }
};
window.LayoutSwitcher = LayoutSwitcher;


/* â•â•â• FloorParser â•â•â• */
const FloorParser = {
  _meshes: [], _rooms: [],
  _roomNames: {},
  init() {
    this._roomNames = {};
    (STATE.elements.floors||[]).forEach(mesh => {
      const fl = floorNum(mesh.name);
      const box = new THREE.Box3().setFromObject(mesh);
      const cx = (box.min.x+box.max.x)/2, cz = (box.min.z+box.max.z)/2;
      const raw = mesh.name.replace(/^[^_]+_/,'').replace(/&\d+$/,'');
      if(!this._roomNames[fl]) this._roomNames[fl]=[];
      this._roomNames[fl].push({cx,cz,name:raw,baseY:box.min.y});
      mesh.visible=false; mesh.userData.isExtSource=true;
    });
    this.rebuild();
  },
  rebuild() {
    this._meshes.forEach(m=>Engine.scene.remove(m));
    this._meshes=[]; this._rooms=[];
    Object.keys(STATE.extCorners||{}).forEach(flStr=>{
      this._buildFloor(parseInt(flStr));
    });
    this.calcArea();
    Object.keys(STATE.extCorners||{}).forEach(flStr=>{
      this._updateRoomLabels(parseInt(flStr));
    });
    window.OpeningMeshBuilder?.rebuildIwOpenings?.();
    if(window.SaunaManager&&typeof window.SaunaManager.run==='function') window.SaunaManager.run();
  },
  _buildFloor(fl) {
    const extPoly = STATE.extCorners[fl];
    if(!extPoly||extPoly.length<3) return;
    const baseY = (STATE.extFloorRanges?.[fl]?.min ?? 0);
    const floorY = baseY + 0.001;
    const debugY = baseY + 0.05;
    const SNAP = 0.005;
    const snap = (v) => ({
      x: Math.round(v.x/SNAP)*SNAP,
      z: Math.round(v.z/SNAP)*SNAP
    });
    const nodeMap = new Map();
    const addNode = (v) => {
      const s = snap(v);
      const k = s.x.toFixed(3)+'_'+s.z.toFixed(3);
      if(!nodeMap.has(k)) nodeMap.set(k,s);
      return k;
    };
    const extKeys = extPoly.map(c=>addNode(c));
    const ippParts=(typeof IntPartitionParser!=='undefined')
      ? IntPartitionParser._partitions.filter(p=>p.fl===fl&&p.nA&&p.nB)
      : [];
    const iwParts=(typeof IntWallParser!=='undefined'&&IntWallParser._parts)
      ? IntWallParser._parts.filter(p=>p.fl===fl&&p.mesh).map(p=>{
          const mp=p.mesh.position,ud=p.mesh.userData;
          const thickM=ud.axis==='x'?ud.d:ud.w;
          let halfLen=ud.axis==='x'?ud.w/2:ud.d/2;
          const extJoints=(IntWallParser._intJoints||[]).filter(j=>
            j.type==='ext'&&IntWallParser._parts[j.pi]?.mesh===p.mesh
          );
          if(extJoints.length>=2){
            const crns=STATE.extCorners[fl]||[];
            const gc=j=>{const A=crns[j.segIdx],B=crns[(j.segIdx+1)%crns.length];
              return(A&&B)?{x:A.x+j.tFrac*(B.x-A.x),z:A.z+j.tFrac*(B.z-A.z)}:null;};
            const c0=gc(extJoints[0]),c1=gc(extJoints[1]);
            if(c0&&c1){
              const jLen=Math.sqrt((c1.x-c0.x)**2+(c1.z-c0.z)**2)/2;
              halfLen=Math.max(halfLen,jLen);
            }
          }
          const nA=ud.axis==='x'?{x:mp.x-halfLen,z:mp.z}:{x:mp.x,z:mp.z-halfLen};
          const nB=ud.axis==='x'?{x:mp.x+halfLen,z:mp.z}:{x:mp.x,z:mp.z+halfLen};
          return {nA,nB,axis:ud.axis,thickM,cx:mp.x,cz:mp.z,halfLen,fl};
        })
      : [];
    const intPartitions=[...ippParts,...iwParts];
    intPartitions.forEach(p=>{
      addNode(p.nA); addNode(p.nB);
    });
    const splitEdge = (aKey, bKey) => {
      const a = nodeMap.get(aKey), b = nodeMap.get(bKey);
      if(!a||!b) return [[aKey,bKey]];
      const dx=b.x-a.x, dz=b.z-a.z;
      const len2=dx*dx+dz*dz;
      if(len2<1e-8) return [];
      const isH = Math.abs(dz)<SNAP;
      const isV = Math.abs(dx)<SNAP;
      if(!isH&&!isV) return [[aKey,bKey]];
      const onEdge = [];
      nodeMap.forEach((n,k)=>{
        if(k===aKey||k===bKey) return;
        if(isH && Math.abs(n.z-a.z)<SNAP) {
          const t=(n.x-a.x)/dx;
          if(t>0.001&&t<0.999) onEdge.push({t,k});
        } else if(isV && Math.abs(n.x-a.x)<SNAP) {
          const t=(n.z-a.z)/dz;
          if(t>0.001&&t<0.999) onEdge.push({t,k});
        }
      });
      if(!onEdge.length) return [[aKey,bKey]];
      onEdge.sort((x,y)=>x.t-y.t);
      const segs=[];
      let prev=aKey;
      onEdge.forEach(({k})=>{segs.push([prev,k]);prev=k;});
      segs.push([prev,bKey]);
      return segs;
    };
    const edges = [];
    const addEdge = (a,b) => {
      if(a===b) return;
      const segs = splitEdge(a,b);
      segs.forEach(([sa,sb])=>{ if(sa!==sb) edges.push({a:sa,b:sb}); });
    };
    const n = extKeys.length;
    for(let i=0;i<n;i++) addEdge(extKeys[i],extKeys[(i+1)%n]);
    intPartitions.forEach(p=>{
      const half = (p.thickM || CONFIG.thickIntMm/1000) / 2;
      if(p.axis==='x'){
        const k1A=addNode({x:p.nA.x, z:p.cz-half}), k1B=addNode({x:p.nB.x, z:p.cz-half});
        const k2A=addNode({x:p.nA.x, z:p.cz+half}), k2B=addNode({x:p.nB.x, z:p.cz+half});
        addEdge(k1A,k1B); addEdge(k2A,k2B);
      } else {
        const k1A=addNode({x:p.cx-half, z:p.nA.z}), k1B=addNode({x:p.cx-half, z:p.nB.z});
        const k2A=addNode({x:p.cx+half, z:p.nA.z}), k2B=addNode({x:p.cx+half, z:p.nB.z});
        addEdge(k1A,k1B); addEdge(k2A,k2B);
      }
    });
    const wallSegs = [];
    edges.forEach(({a,b})=>{
      const na=nodeMap.get(a), nb=nodeMap.get(b);
      if(!na||!nb) return;
      wallSegs.push({x1:Math.min(na.x,nb.x),z1:Math.min(na.z,nb.z),
                     x2:Math.max(na.x,nb.x),z2:Math.max(na.z,nb.z)});
    });
    const _mergeClose = (arr, tol=0.010) => {
      const s = arr.slice().sort((a,b)=>a-b);
      return s.reduce((r,v)=>{ if(!r.length||v-r[r.length-1]>tol) r.push(v); return r; },[]);
    };
    const xs = _mergeClose([...new Set([...nodeMap.values()].map(n=>n.x))]);
    const zs = _mergeClose([...new Set([...nodeMap.values()].map(n=>n.z))]);
    const cells=[];
    for(let ix=0;ix<xs.length-1;ix++){
      for(let iz=0;iz<zs.length-1;iz++){
        const cx=(xs[ix]+xs[ix+1])/2, cz=(zs[iz]+zs[iz+1])/2;
        let inside=false;
        const ecN=extPoly.length;
        for(let ii=0,jj=ecN-1;ii<ecN;jj=ii++){
          const xi=extPoly[ii].x,zi=extPoly[ii].z,xj=extPoly[jj].x,zj=extPoly[jj].z;
          if((zi>cz)!==(zj>cz)&&cx<(xj-xi)*(cz-zi)/(zj-zi)+xi) inside=!inside;
        }
        if(inside) cells.push({ix,iz,cx,cz,room:-1});
      }
    }
    const blockedV = new Set();
    const blockedH = new Set();
    wallSegs.forEach(w=>{
      if(Math.abs(w.x1-w.x2)<SNAP){
        const ixB = xs.findIndex(v=>Math.abs(v-w.x1)<SNAP*2);
        if(ixB<0) return;
        for(let iz=0;iz<zs.length-1;iz++){
          if(zs[iz]>=w.z1-SNAP&&zs[iz+1]<=w.z2+SNAP)
            blockedV.add(ixB+'_'+iz);
        }
      } else if(Math.abs(w.z1-w.z2)<SNAP){
        const izB = zs.findIndex(v=>Math.abs(v-w.z1)<SNAP*2);
        if(izB<0) return;
        for(let ix=0;ix<xs.length-1;ix++){
          if(xs[ix]>=w.x1-SNAP&&xs[ix+1]<=w.x2+SNAP)
            blockedH.add(izB+'_'+ix);
        }
      }
    });
    const isBlocked=(ix1,iz1,ix2,iz2)=>{
      if(ix2!==ix1){
        return blockedV.has(Math.max(ix1,ix2)+'_'+iz1);
      } else {
        return blockedH.has(Math.max(iz1,iz2)+'_'+ix1);
      }
    };
    const isWallCell = c => intPartitions.some(p=>{
      const half = (p.thickM || CONFIG.thickIntMm/1000) / 2;
      return p.axis==='x'
        ? c.cx>=p.cx-p.halfLen-0.005 && c.cx<=p.cx+p.halfLen+0.005
          && c.cz>=p.cz-half-0.001  && c.cz<=p.cz+half+0.001
        : c.cx>=p.cx-half-0.001    && c.cx<=p.cx+half+0.001
          && c.cz>=p.cz-p.halfLen-0.005 && c.cz<=p.cz+p.halfLen+0.005;
    });
    const validCells = cells.filter(c=>!isWallCell(c));
    let roomId=0;
    const cellMap=new Map();
    validCells.forEach(c=>cellMap.set(c.ix+'_'+c.iz,c));
    validCells.forEach(startCell=>{
      if(startCell.room>=0) return;
      const queue=[startCell];
      startCell.room=roomId;
      while(queue.length){
        const c=queue.shift();
        [[c.ix+1,c.iz],[c.ix-1,c.iz],[c.ix,c.iz+1],[c.ix,c.iz-1]].forEach(([nix,niz])=>{
          const nb=cellMap.get(nix+'_'+niz);
          if(!nb||nb.room>=0) return;
          if(!isBlocked(c.ix,c.iz,nix,niz)){
            nb.room=roomId;
            queue.push(nb);
          }
        });
      }
      roomId++;
    });
    const roomCells=new Map();
    validCells.forEach(c=>{
      if(!roomCells.has(c.room)) roomCells.set(c.room,[]);
      roomCells.get(c.room).push(c);
    });
    const colors=['#D4623A','#4A8BBF','#5AAD42','#8B5FA8','#D4AA30',
                  '#C03030','#2AA88A','#D47830','#2A78B0','#2A9850'];
    roomCells.forEach((rcells, rid)=>{
      if(!rcells.length) return;
      const cx=rcells.reduce((s,c)=>s+c.cx,0)/rcells.length;
      const cz=rcells.reduce((s,c)=>s+c.cz,0)/rcells.length;
      let roomName='Room '+(rid+1);
      let bestDist=Infinity;
      (this._roomNames[fl]||[]).forEach(r=>{
        const d=(r.cx-cx)**2+(r.cz-cz)**2;
        if(d<bestDist){bestDist=d;roomName=r.name;}
      });
      const verts=[], uvs=[];
      let totalArea=0;
      rcells.forEach(c=>{
        const x0=xs[c.ix],x1=xs[c.ix+1],z0=zs[c.iz],z1=zs[c.iz+1];
        totalArea+=(x1-x0)*(z1-z0);
        verts.push(x0,floorY,z0, x1,floorY,z0, x1,floorY,z1);
        verts.push(x0,floorY,z0, x1,floorY,z1, x0,floorY,z1);
        uvs.push(0,0,1,0,1,1, 0,0,1,1,0,1);
      });
      const geo=new THREE.BufferGeometry();
      geo.setAttribute('position',new THREE.BufferAttribute(new Float32Array(verts),3));
      geo.setAttribute('uv',new THREE.BufferAttribute(new Float32Array(uvs),2));
      geo.computeVertexNormals();
      const color=colors[rid%colors.length];
      const mat=new THREE.MeshStandardMaterial({color:new THREE.Color(color),roughness:0.8,metalness:0,transparent:true,opacity:0.85,side:THREE.DoubleSide});
      mat.shadowSide=THREE.FrontSide;
      const mesh=new THREE.Mesh(geo,mat);
      mesh.name='FLR_gen_'+roomName+'&'+fl;
      mesh.userData={isFloorGenerated:true,floorNum:fl,roomName};
      mesh.receiveShadow=true;
      Engine.scene.add(mesh);
      this._meshes.push(mesh);
      let wcx=0,wcz=0,wTotal=0;
      rcells.forEach(c=>{
        const w=(xs[c.ix+1]-xs[c.ix])*(zs[c.iz+1]-zs[c.iz]);
        wcx+=c.cx*w; wcz+=c.cz*w; wTotal+=w;
      });
      const labelCx=wTotal>0?wcx/wTotal:cx;
      const labelCz=wTotal>0?wcz/wTotal:cz;
      const _defColor=colors[rid%colors.length];mesh.userData.defaultColor=_defColor;mesh.userData.hasTexture=false;
      this._rooms.push({name:roomName,fl,mesh,area:totalArea,cx:labelCx,cz:labelCz,floorY,defaultColor:_defColor});
    });
    this._updateRoomLabels(fl);
    this._buildCutIndicators(fl, floorY);
  },
  _buildCutIndicators(fl, floorY) {
    this._meshes = this._meshes.filter(m => {
      if (m.userData.isCutIndicator && m.userData.floorNum === fl) { Engine.scene.remove(m); return false; }
      return true;
    });
    const rooms = this._rooms.filter(r => r.fl === fl);
    if (!rooms.length) return;
    const intParts = (typeof IntPartitionParser !== 'undefined') ? IntPartitionParser._partitions : [];
    
    intParts.filter(p => p.fl === fl && p.cutIndSz).forEach(p => {
      const {tFrac} = p.cutIndSz;
      if (!p.nA || !p.nB) return;
      const dx=p.nB.x-p.nA.x, dz=p.nB.z-p.nA.z, len=Math.sqrt(dx*dx+dz*dz)||1;
      const ux=dx/len,uz=dz/len,t=tFrac*len,cx=p.nA.x+t*ux,cz=p.nA.z+t*uz;
      const thick = p.thickM || CONFIG.thickIntMm/1000;
      const s2=rooms.slice().sort((a,b)=>((a.cx-cx)**2+(a.cz-cz)**2)-((b.cx-cx)**2+(b.cz-cz)**2));
      const room=s2.length>1?(s2[0].area<=s2[1].area?s2[0]:s2[1]):s2[0];
      if(!room)return;
      const rb=new THREE.Box3().setFromObject(room.mesh),rc=rb.getCenter(new THREE.Vector3()),rs=rb.getSize(new THREE.Vector3());
      const indSzX=p.axis==='x'?rs.x:thick,indSzZ=p.axis==='x'?thick:rs.z;
      const indCx=p.axis==='x'?rc.x:cx,indCz=p.axis==='x'?cz:rc.z;
      const geo = new THREE.BoxGeometry(indSzX, 0.015, indSzZ);
      const mat = new THREE.MeshStandardMaterial({
        color: new THREE.Color(room.defaultColor),
        roughness: 0.8, transparent: true, opacity: 0.85,
        depthTest: false, side: THREE.DoubleSide
      });
      const m = new THREE.Mesh(geo, mat);
      m.position.set(indCx, floorY + 0.016, indCz);
      m.renderOrder = 15;
      m.visible = (STATE.view === '2d-top');
      m.userData = { isCutIndicator: true, floorNum: fl, isFloorGenerated: true };
      Engine.scene.add(m);
      this._meshes.push(m);
    });
  },
  _showRoomDims(dragRef) {
    const root = document.getElementById('cv5-root');
    if (!root || STATE.view !== '2d-top') return;
    root.querySelectorAll('.v4-room-dim').forEach(el => el.remove());
    if (!dragRef) return;
    const snapMm = CONFIG.stepX || 25;
    const fmt = mm => {
      const s = Math.round(Math.abs(mm) / snapMm) * snapMm;
      return STATE.isMetric ? s + '' : (s/25.4).toFixed(1) + '"';
    };
    const makeLbl = (txt, wx, wz, fl) => {
      const yW = (STATE.extFloorRanges?.[fl]?.min ?? 0) + 0.05;
      const sp = Engine.toScreen(new THREE.Vector3(wx, yW, wz));
      const el = document.createElement('div');
      el.className = 'v4-room-dim';
      el.style.cssText = 'position:absolute;pointer-events:none;z-index:210;transform:translate(-50%,-50%);'
        + 'left:'+Math.round(sp.x)+'px;top:'+Math.round(sp.y)+'px;'
        + 'background:#fff;border:1.5px solid var(--accent);color:var(--accent);'
        + 'font-weight:700;font-size:10px;padding:4px 10px;border-radius:50px;'
        + 'white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,0.12);';
      el.textContent = txt;
      root.appendChild(el);
    };

    // INT mesh drag — show distances from each endpoint of the wall
    // in the slide direction (perpendicular to wall axis)
    if (dragRef.isMesh || dragRef.userData) {
      const mesh = dragRef;
      const ud = mesh.userData, mp = mesh.position;
      const fl = ud.floorNum || 1;
      const thick = CONFIG.thickIntMm / 1000;
      // endpoints of this wall
      const endpoints = ud.axis === 'x'
        ? [{x: mp.x - ud.w/2, z: mp.z}, {x: mp.x + ud.w/2, z: mp.z}]
        : [{x: mp.x, z: mp.z - ud.d/2}, {x: mp.x, z: mp.z + ud.d/2}];
      // slide direction
      const dirX = ud.axis === 'x' ? 0 : 1;
      const dirZ = ud.axis === 'x' ? 1 : 0;
      endpoints.forEach(ep => {
        // raycast in both slide directions from this endpoint
        const dPos = IntDrag._raycastWall(ep.x, ep.z, dirX, dirZ, fl, mesh);
        const dNeg = IntDrag._raycastWall(ep.x, ep.z, -dirX, -dirZ, fl, mesh);
        if (isFinite(dPos) && dPos > 0.01) {
          const dist = dPos - thick/2;
          const midX = ep.x + dirX * dPos/2;
          const midZ = ep.z + dirZ * dPos/2;
          makeLbl(fmt(dist * 1000), midX, midZ, fl);
        }
        if (isFinite(dNeg) && dNeg > 0.01) {
          const dist = dNeg - thick/2;
          const midX = ep.x - dirX * dNeg/2;
          const midZ = ep.z - dirZ * dNeg/2;
          makeLbl(fmt(dist * 1000), midX, midZ, fl);
        }
      });
      return;
    }

    // EXT drag seg — show distances from dragged seg to nearest INT walls
    if (dragRef.nA && dragRef.nB) {
      const fl = dragRef.fl || 1;
      const thick = CONFIG.thickIntMm / 1000;
      const dx = dragRef.nB.x - dragRef.nA.x;
      const dz = dragRef.nB.z - dragRef.nA.z;
      const len = Math.sqrt(dx*dx + dz*dz) || 1;
      // normal pointing inward (approximate)
      const corners = (STATE.extCorners||{})[fl]||[];
      const cx = corners.reduce((s,c)=>s+c.x,0)/(corners.length||1);
      const cz = corners.reduce((s,c)=>s+c.z,0)/(corners.length||1);
      const nx = -dz/len, nz = dx/len;
      const midX = (dragRef.nA.x + dragRef.nB.x)/2;
      const midZ = (dragRef.nA.z + dragRef.nB.z)/2;
      const toCenter = (cx - midX)*nx + (cz - midZ)*nz;
      const inX = toCenter > 0 ? nx : -nx;
      const inZ = toCenter > 0 ? nz : -nz;
      // sample points along the segment
      const steps = 3;
      const shown = new Set();
      for (let i = 0; i <= steps; i++) {
        const t = i / steps;
        const px = dragRef.nA.x + t * dx;
        const pz = dragRef.nA.z + t * dz;
        const d = IntDrag._raycastWall(px, pz, inX, inZ, fl, null);
        if (!isFinite(d) || d > 20 || d < 0.01) continue;
        const dist = d - thick/2;
        const key = Math.round(dist*100)+'';
        if (shown.has(key)) continue;
        shown.add(key);
        makeLbl(fmt(dist * 1000), px + inX * d/2, pz + inZ * d/2, fl);
      }
    }
  },
  _hideRoomDims() {
    document.getElementById('cv5-root')?.querySelectorAll('.v4-room-dim').forEach(el => el.remove());
  },
  _updateRoomLabels(fl) {
    const layer = document.getElementById('cv5-room-labels');
    if (!layer) return;
    layer.querySelectorAll('.v4-room-label[data-fl="'+fl+'"]').forEach(el=>el.remove());
    const rooms = this._rooms.filter(r => r.fl === fl);
    rooms.forEach(r => {
      const box = new THREE.Box3().setFromObject(r.mesh);
      const fy = box.min.y + 0.05;
      const el = document.createElement('div');
      el.className = 'v4-room-label';
      el.dataset.fl = fl;
      el.dataset.cx = r.cx;
      el.dataset.cz = r.cz;
      el.dataset.floorY = fy;
      el.style.display = (STATE.view === '2d-top') ? 'block' : 'none';
      const a = STATE.isMetric ? r.area.toFixed(1) : (r.area*10.7639).toFixed(1);
      const u = STATE.isMetric ? 'm\u00b2' : 'ft\u00b2';
      const displayName = CONFIG.roomTranslations?.[r.name] || r.name.replace(/_/,' ');
      el.innerHTML = '<span class="rl-name">'+displayName+'</span>'
        + '<span class="rl-area">'+a+' <span class="rl-unit">'+u+'</span></span>';
      layer.appendChild(el);
    });
    this._reprojectRoomLabels();
  },
  _reprojectRoomLabels() {
    if (typeof Engine === 'undefined') return;
    const layer = document.getElementById('cv5-room-labels');
    if (!layer) return;
    layer.querySelectorAll('.v4-room-label').forEach(el => {
      const cx = parseFloat(el.dataset.cx);
      const cz = parseFloat(el.dataset.cz);
      const fy = parseFloat(el.dataset.floorY || 0) + 0.05;
      const sp = Engine.toScreen(new THREE.Vector3(cx, fy, cz));
      el.style.left = Math.round(sp.x) + 'px';
      el.style.top  = Math.round(sp.y) + 'px';
    });
  },
  calcArea() {
    const fl=1;
    const rooms=this._rooms.filter(r=>r.fl===fl);
    if(!rooms.length){
      const box=new THREE.Box3();
      STATE.elements.walls.filter(w=>(w.userData.floorNum||1)===fl).forEach(w=>box.expandByObject(w));
      if(box.isEmpty()) return;
      const s=box.getSize(new THREE.Vector3());
      const m2=s.x*s.z;
      const val=STATE.isMetric?m2.toFixed(1):(m2*10.7639).toFixed(1);
      const unit=STATE.isMetric?'m²':'ft²';
      const el=document.getElementById('v4-area-val'),uel=document.getElementById('v4-area-unit');
      if(el)el.textContent=val; if(uel)uel.textContent=unit;
      return;
    }
    const total=rooms.reduce((s,r)=>s+r.area,0);
    const val=STATE.isMetric?total.toFixed(1):(total*10.7639).toFixed(1);
    const unit=STATE.isMetric?'m²':'ft²';
    const el=document.getElementById('v4-area-val'),uel=document.getElementById('v4-area-unit');
    if(el)el.textContent=val; if(uel)uel.textContent=unit;
    const ov=document.getElementById('v4-area-overlay-val'),ou=document.getElementById('v4-area-overlay-unit');
    if(ov)ov.textContent=val; if(ou)ou.textContent=' '+unit;
    if(typeof UI!=='undefined')UI._updateVolume();
    const fp=document.getElementById('cv5-floor-pills');
    if(fp){
      if(!fp.querySelector('.v4-floor-pill')) fp.style.display='none';
    }
  }
};
window.FloorParser = FloorParser;

/* â•â•â• IntDrag â•â•â• */
const IntDrag = {
  _dragging: false,
  _mesh: null,
  _axis: null,
  _startPt: null,
  _origCenter: null,   // center at drag start

  // â”€â”€ Find the nearest wall hit along a ray from (ox,oz) in direction (dx,dz) â”€â”€
  // Returns distance or Infinity
  _raycastWall(ox, oz, dirX, dirZ, fl, skipMesh) {
    const corners = (STATE.extCorners||{})[fl]||[];
    const EPS = 0.001;
    let best = Infinity;

    // EXT polygon edges
    for (let i = 0; i < corners.length; i++) {
      const A = corners[i], B = corners[(i+1)%corners.length];
      const ex = B.x-A.x, ez = B.z-A.z;
      const denom = dirX*ez - dirZ*ex;
      if (Math.abs(denom) < EPS) continue;
      const t = ((A.x-ox)*ez - (A.z-oz)*ex) / denom;
      const s = ((A.x-ox)*dirZ - (A.z-oz)*dirX) / denom;
      if (t > EPS && s >= -EPS && s <= 1+EPS) best = Math.min(best, t);
    }

    // INT partition faces
    IntWallParser._parts.forEach(p => {
      if (!p.mesh || p.mesh === skipMesh) return;
      const px = p.mesh.position.x, pz = p.mesh.position.z;
      // Each partition has 2 faces perpendicular to its thin axis
      // axis=x â†’ faces at z = pz Â± d/2 (normal Â±Z)
      // axis=z â†’ faces at x = px Â± w/2 (normal Â±X)
      const faces = p.axis === 'x'
        ? [{nx:0,nz:1,fx:px,fz:pz-p.d/2},{nx:0,nz:-1,fx:px,fz:pz+p.d/2}]
        : [{nx:1,nz:0,fx:px-p.w/2,fz:pz},{nx:-1,nz:0,fx:px+p.w/2,fz:pz}];
      faces.forEach(({nx,nz,fx,fz}) => {
        const denom = dirX*nx + dirZ*nz;
        if (denom <= 0) return;   // front-face only: reject back-face & parallel
        const t = ((fx-ox)*nx + (fz-oz)*nz) / denom;
        if (t < EPS) return;
        // Hit point must be within face span
        const hx = ox+t*dirX, hz = oz+t*dirZ;
        if (p.axis === 'x') {
          if (hx < px-p.w/2-EPS || hx > px+p.w/2+EPS) return;
        } else {
          if (hz < pz-p.d/2-EPS || hz > pz+p.d/2+EPS) return;
        }
        best = Math.min(best, t);
      });
    });
    return best;
  },

  // â”€â”€ Stretch mesh to fill between walls along its axis â”€â”€
  _stretchToWalls(mesh, fl) {
    const ud = mesh.userData;
    const mp = mesh.position;
    const thick = CONFIG.thickIntMm / 1000;

    if (ud.axis === 'x') {
      const dPos = this._raycastWall(mp.x, mp.z,  1, 0, fl, mesh);
      const dNeg = this._raycastWall(mp.x, mp.z, -1, 0, fl, mesh);
      if (!isFinite(dPos) || !isFinite(dNeg)) return;
      const newW = dPos + dNeg;
      const newCx = mp.x + (dPos - dNeg) / 2;
      mesh.position.x = newCx;
      mesh.geometry.dispose();
      mesh.geometry = new THREE.BoxGeometry(newW, ud.wallH, thick);
      ud.w = newW;
    } else {
      const dPos = this._raycastWall(mp.x, mp.z, 0,  1, fl, mesh);
      const dNeg = this._raycastWall(mp.x, mp.z, 0, -1, fl, mesh);
      if (!isFinite(dPos) || !isFinite(dNeg)) return;
      const newD = dPos + dNeg;
      const newCz = mp.z + (dPos - dNeg) / 2;
      mesh.position.z = newCz;
      mesh.geometry.dispose();
      mesh.geometry = new THREE.BoxGeometry(thick, ud.wallH, newD);
      ud.d = newD;
    }
    // Restore door holes after geometry rebuild
    const part = this._parts.find(p => p.mesh === mesh);
    if (part && window.IntWallParser?._rebuildHolesForPart) window.IntWallParser._rebuildHolesForPart(part);
  },

  bindDrag() {
    const cv = document.getElementById('cv5-canvas');
    const rc = new THREE.Raycaster();
    const floorPlane = new THREE.Plane(new THREE.Vector3(0,1,0), 0);
    const getMouse = e => {
      const r = cv.getBoundingClientRect();
      return new THREE.Vector2(((e.clientX-r.left)/r.width)*2-1, -((e.clientY-r.top)/r.height)*2+1);
    };

    // Hover cursor
    cv.addEventListener('pointermove', e => {
      if (this._dragging) return;
      if (STATE.view !== '2d-top') return;
      rc.setFromCamera(getMouse(e), Engine.orthoCamera);
      const hits = rc.intersectObjects(Engine.scene.children, true)
        .filter(h => h.object.userData.isIntWall);
      cv.style.cursor = hits.length ? 'grab' : '';
    });

    // Start drag
    cv.addEventListener('pointerdown', e => {
      if (STATE.view !== '2d-top') return;
      window._ilog&&window._ilog('INT pointerdown: isDragging='+STATE.isDragging);
      if (STATE.isDragging) { window._ilog&&window._ilog('  BLOCKED by STATE.isDragging'); return; }
      rc.setFromCamera(getMouse(e), Engine.orthoCamera);
      const hits = rc.intersectObjects(Engine.scene.children, true)
        .filter(h => h.object.userData.isIntWall);
      window._ilog&&window._ilog('  hits='+hits.length+' totalJoints='+IntWallParser._intJoints.length);
      if (!hits.length) { window._ilog&&window._ilog('  no INT hit'); return; }
      const mesh = hits[0].object;
      this._mesh = mesh;
      this._axis = mesh.userData.axis;
      const fl = mesh.userData.floorNum;
      const yW = (STATE.extFloorRanges?.[fl]?.min ?? 0);
      floorPlane.constant = -yW;
      rc.setFromCamera(getMouse(e), Engine.orthoCamera);
      this._startPt = new THREE.Vector3();
      rc.ray.intersectPlane(floorPlane, this._startPt);
      this._origCenter = mesh.position.clone();
      // Compute slide limits: magenta points (joint-ext) must stay between red points (EXT corners)
      this._slideMin = -Infinity;
      this._slideMax =  Infinity;
      const _fl = mesh.userData.floorNum;
      const _corners = (STATE.extCorners||{})[_fl]||[];
      const _ht = CONFIG.thickIntMm / 1000 / 2;
      const _joints = (IntWallParser._intJoints||[]).filter(j =>
        j.type==='ext' && IntWallParser._parts[j.pi]?.mesh === mesh
      );
      if (_joints.length >= 2) {
        // Only use segments parallel to the slide direction for clamping.
        // Perpendicular segments (dxâ‰0 for X-slide, dzâ‰0 for Z-slide) are skipped â€”
        // they would produce zero-range clamp and lock the partition.
        const MIN_EXTENT = 0.05;
        _joints.forEach(j => {
          const A = _corners[j.segIdx], B = _corners[(j.segIdx+1)%_corners.length];
          if (!A || !B) return;
          const ud = mesh.userData;
          if (ud.axis === 'x') {
            // slides in Z â€” only use segments with Z extent
            const zExtent = Math.abs(B.z - A.z);
            if (zExtent < MIN_EXTENT) return;
            this._slideMin = Math.max(this._slideMin, Math.min(A.z, B.z) + _ht);
            this._slideMax = Math.min(this._slideMax, Math.max(A.z, B.z) - _ht);
          } else {
            // slides in X â€” only use segments with X extent
            const xExtent = Math.abs(B.x - A.x);
            if (xExtent < MIN_EXTENT) return;
            this._slideMin = Math.max(this._slideMin, Math.min(A.x, B.x) + _ht);
            this._slideMax = Math.min(this._slideMax, Math.max(A.x, B.x) - _ht);
          }
        });
      }
      this._dragging = true;
      STATE.isDragging = true;
      // Notify OpeningInsert that an INT wall (partition) is selected
      // so that IDR ('int doors') button enables in the insert panel.
      if (typeof OpeningInsert !== 'undefined') {
        const _ud = mesh.userData || {};
        const _halfW = (_ud.w || 0) / 2;
        const _halfD = (_ud.d || 0) / 2;
        const _wA = _ud.axis === 'x'
          ? { x: mesh.position.x - _halfW, z: mesh.position.z }
          : { x: mesh.position.x, z: mesh.position.z - _halfD };
        const _wB = _ud.axis === 'x'
          ? { x: mesh.position.x + _halfW, z: mesh.position.z }
          : { x: mesh.position.x, z: mesh.position.z + _halfD };
        OpeningInsert.setSelectedWall({ type:'int', A:_wA, B:_wB, fl: _ud.floorNum, axis: _ud.axis, partRef: mesh });
        if (typeof OpeningEditor !== 'undefined') OpeningEditor.close();
      }
      window._ilog&&window._ilog('  INT drag START ax='+mesh.userData.axis+' joints='+_joints.length+' slideMin='+this._slideMin.toFixed(3)+' slideMax='+this._slideMax.toFixed(3));
      Engine.orthoControls.enabled = false;
      cv.style.cursor = 'grabbing';
      cv.setPointerCapture(e.pointerId);
      e.preventDefault();
      e.stopPropagation();
    }, true);

    // Move â€” translate along perpendicular axis, then stretch along own axis
    cv.addEventListener('pointermove', e => {
      if (!this._dragging) return;
      const fl = this._mesh.userData.floorNum;
      const yW = (STATE.extFloorRanges?.[fl]?.min ?? 0);
      floorPlane.constant = -yW;
      rc.setFromCamera(getMouse(e), Engine.orthoCamera);
      const pt = new THREE.Vector3();
      if (!rc.ray.intersectPlane(floorPlane, pt)) return;
      if (this._axis === 'x') {
        const step = CONFIG.stepZ / 1000;
        let newZ = this._origCenter.z + Math.round((pt.z - this._startPt.z) / step) * step;
        if (isFinite(this._slideMin)) newZ = Math.max(this._slideMin, newZ);
        if (isFinite(this._slideMax)) newZ = Math.min(this._slideMax, newZ);
        this._mesh.position.z = newZ;
      } else {
        const step = CONFIG.stepX / 1000;
        let newX = this._origCenter.x + Math.round((pt.x - this._startPt.x) / step) * step;
        if (isFinite(this._slideMin)) newX = Math.max(this._slideMin, newX);
        if (isFinite(this._slideMax)) newX = Math.min(this._slideMax, newX);
        this._mesh.position.x = newX;
      }
      // Dragged has 2 parent joints. Recompute its length by intersecting its axis
      // line at new slide position with both parents' face planes â€” no raycast needed.
      IntWallParser._resolveDraggedFromJoints(this._mesh);
      // Neighbours: use _resolveDraggedFromJoints (topology) instead of raw raycast stretch.
      for (let pass = 0; pass < 3; pass++) {
        IntWallParser._parts.forEach(p => {
          if (p.mesh && p.mesh !== this._mesh)
            IntWallParser._resolveDraggedFromJoints(p.mesh);
        });
        IntWallParser._enforceIntJoints(this._mesh);
      }
      IntWallParser._computeConstraints();
      if(typeof FloorParser!=='undefined') { FloorParser.rebuild(); FloorParser._showRoomDims(this._mesh); }
      if(typeof OpeningMeshBuilder!=='undefined') OpeningMeshBuilder.rebuildIwOpenings();
      if(typeof UI!=='undefined') UI.refreshDimLabels();
    });

    // End drag
    cv.addEventListener('pointerup', () => {
      if (!this._dragging) return;
      STATE.isDragging = false;
      this._dragging = false;
      Engine.orthoControls.enabled = true;
      cv.style.cursor = '';
      if(typeof FloorParser!=='undefined') FloorParser._hideRoomDims();
      // Also clear any leftover EXT dim labels
      document.getElementById('cv5-dimlayer')?.querySelectorAll('.v4-dim-label:not(.v4-land-dim):not(.v4-drag-dim)').forEach(el=>el.remove());
      IntWallParser._detectIntJoints();
      if(typeof FloorParser!=='undefined') FloorParser.rebuild();
      if(typeof OpeningMeshBuilder!=='undefined') OpeningMeshBuilder.rebuildIwOpenings();
      this._mesh = null;
      this._startPt = null;
      this._origCenter = null;
      this._slideMin = -Infinity;
      this._slideMax =  Infinity;
    });
  },
};

window.IntDrag = IntDrag
/* â•â•â• ARViewer â•â•â• */
const ARViewer = {
  _blobUrl: null,

  open() {
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isAndroid = /Android/.test(ua);
    // On Android: use original CDN GLB URL directly â†’ native Scene Viewer
    if (isAndroid) {
      const glbUrl = window.CONFIG?.glbUrl || window.CONFIG?.glbUrls?.[0];
      if (glbUrl) {
        const sceneViewerUrl = 'intent://arvr.google.com/scene-viewer/1.0'
          + '?file=' + encodeURIComponent(glbUrl)
          + '&mode=ar_preferred'
          + '&title=LEVA+House'
          + '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url='
          + encodeURIComponent('https://arvr.google.com/scene-viewer/') + ';end;';
        window.location.href = sceneViewerUrl;
        return;
      }
    }
    const overlay = document.getElementById('cv5-ar-overlay');
    if (!overlay) return;
    overlay.style.display = 'flex';
    document.getElementById('cv5-ar-mv-wrap').innerHTML =
      '<div style="color:#fff;font-size:13px;font-family:Montserrat,sans-serif;display:flex;align-items:center;justify-content:center;height:100%;gap:10px;">'
      + '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>'
      + ' Preparing 3D model...</div>';
    document.getElementById('cv5-ar-download').style.display = 'none';
    this._export();
  },

  _export() {
    if (!window.THREE) return;
    import('https://esm.sh/three@0.160.0/examples/jsm/exporters/GLTFExporter.js').then(({ GLTFExporter }) => {
      const exporter = new GLTFExporter();
      // Collect all visible 3D meshes â€” traverse deeply, skip 2D/source/land objects
      const exportRoot = new THREE.Group();
      Engine.scene.traverse(obj => {
        if (!obj.isMesh) return;
        const ud = obj.userData;
        if (ud.isLand || ud.isLandShadow) return;
        if (ud.isExtSource || ud.isOrigRoofGLB || ud.isOpeningSource) return;
        if (ud.isPlanIndicator || ud.isCutIndicator) return;
        if (ud.isSprite2D) return;
        // Force visible for export regardless of current 2D/section-cut state
        const wasVisible = obj.visible;
        obj.visible = true;
        const clone = obj.clone();
        obj.visible = wasVisible;
        // Strip clipping planes from clone material so export isn't clipped
        if (clone.material) {
          const mats = Array.isArray(clone.material) ? clone.material : [clone.material];
          mats.forEach((m, i) => {
            if (m && m.clippingPlanes && m.clippingPlanes.length) {
              const mc = m.clone(); mc.clippingPlanes = []; mc.needsUpdate = true;
              if (Array.isArray(clone.material)) clone.material[i] = mc;
              else clone.material = mc;
            }
          });
        }
        exportRoot.add(clone);
      });
      exporter.parse(exportRoot, (glb) => {
        this._onExported(glb);
      }, (err) => {
        console.error('[AR] GLTFExporter error:', err);
        document.getElementById('cv5-ar-mv-wrap').innerHTML =
          '<p style="color:#f66;font-size:12px;padding:20px;font-family:Montserrat,sans-serif;">Export failed: ' + err + '</p>';
      }, { binary: true, embedImages: true });
    }).catch(err => { console.error('[AR] Import error:', err); });
  },

  _onExported(glb) {
    if (this._blobUrl) URL.revokeObjectURL(this._blobUrl);
    const blob = new Blob([glb], { type: 'model/gltf-binary' });
    this._blobUrl = URL.createObjectURL(blob);
    this._lastBlob = blob;
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isAndroid = /Android/.test(ua);
    const isMobile = isIOS || isAndroid;
    const wrap = document.getElementById('cv5-ar-mv-wrap');
    const dlLink = document.getElementById('cv5-ar-download');
    dlLink.href = this._blobUrl;
    dlLink.style.display = '';

    if (isIOS) {
      // iOS: download GLB
      dlLink.style.display = '';
      wrap.innerHTML = '<div style="color:#fff;font-size:13px;font-family:Montserrat,sans-serif;display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;gap:16px;padding:20px;text-align:center;">'
        + '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#0af" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>'
        + '<strong style="font-size:15px;">Download 3D model</strong>'
        + '<p style="color:#aaa;margin:0;font-size:11px;">Open in Safari or Files to view in AR.</p>'
        + '</div>';
    } else {
      // Android + desktop: ÄŤistĂ˝ model-viewer, AR tlaÄŤĂ­tko spustĂ­ Scene Viewer
      dlLink.style.display = 'none';
      document.getElementById('cv5-ar-hint').style.display = 'none';
      wrap.innerHTML = '<model-viewer'
        + ' src="' + this._blobUrl + '"'
        + ' ar ar-modes="scene-viewer webxr"'
        + ' ar-scale="fixed"'
        + ' camera-controls touch-action="pan-y"'
        + ' shadow-intensity="1"'
        + ' style="width:100%;height:100%;"'
        + '></model-viewer>';
    }
  },

  _uploadAndOpenSceneViewer(blob) {
    const wrap = document.getElementById('cv5-ar-mv-wrap');
    const formData = new FormData();
    formData.append('file', blob, 'leva-model.glb');
    fetch('https://0x0.st', {
      method: 'POST',
      body: formData
    })
    .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
    .then(text => {
      const pageUrl = text.trim();
      if (!pageUrl.startsWith('http')) throw new Error('No URL returned');
      const sceneViewerUrl = 'https://arvr.google.com/scene-viewer/1.0'
        + '?file=' + encodeURIComponent(pageUrl)
        + '&mode=ar_preferred'
        + '&title=LEVA+House';
      wrap.innerHTML = '<div style="color:#fff;font-size:13px;font-family:Montserrat,sans-serif;display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;gap:20px;padding:24px;text-align:center;">'
        + '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#0af" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>'
        + '<strong style="font-size:16px;">Ready for AR</strong>'
        + '<a href="' + sceneViewerUrl + '" style="display:inline-block;background:#0af;color:#000;font-weight:700;padding:14px 28px;border-radius:24px;text-decoration:none;font-size:14px;font-family:Montserrat,sans-serif;">View in AR 1:1</a>'
        + '<p style="color:#aaa;margin:0;font-size:10px;">Opens Google AR viewer at real-world scale</p>'
        + '</div>';
    })
    .catch(err => {
      console.error('[AR] Upload failed:', err);
      wrap.innerHTML = '<div style="color:#f66;font-size:12px;padding:20px;font-family:Montserrat,sans-serif;text-align:center;">'
        + 'Upload failed: ' + err.message + '<br><br>'
        + '<small style="color:#aaa;">Try downloading the GLB and opening manually.</small></div>';
    });
  },

  close() {
    document.getElementById('cv5-ar-overlay').style.display = 'none';
  }
};
window.ARViewer = ARViewer;

document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('cv5-ar-close')?.addEventListener('click', () => ARViewer.close());
  document.getElementById('cv5-ar-overlay')?.addEventListener('click', function(e) {
    if (e.target === this) ARViewer.close();
  });
  // Auto-trigger AR on mobile if ?autoar=1
  const ua = navigator.userAgent;
  const isMobileAR = /Android|iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  if (isMobileAR && new URLSearchParams(window.location.search).get('autoar') === '1') {
    // Wait for model to load, then open AR
    const tryOpen = () => {
      if (window._v4StartupDone) { ARViewer.open(); }
      else { setTimeout(tryOpen, 400); }
    };
    setTimeout(tryOpen, 600);
  }
});
// ─── ColumnManager ───────────────────────────────────────────────────────────
const ColumnManager = {
  _meshes:[],
  _texture:null,
  _textureUrl:'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/75016.jpg?v=1778397390',
  _textureRepeat:{x:1, y:4},
  OVERHANG_MIN:1.600,
  SIDE_LONG:3.000,
  COL_SPACING:3.000,
  COL_SIZE:0.200,
  INSET:0.200,
  _loadTexture(){
    if(this._texture||!window.THREE) return this._texture;
    try {
      const tex=new THREE.TextureLoader().load(this._textureUrl);
      tex.colorSpace=THREE.SRGBColorSpace;
      tex.wrapS=tex.wrapT=THREE.RepeatWrapping;
      tex.repeat.set(this._textureRepeat.x, this._textureRepeat.y);
      this._texture=tex;
    } catch(e){ console.warn('[ColumnManager] texture load failed', e); }
    return this._texture;
  },
  run(){
    this._clear();
    const RB=RoofBuilder;
    if(!RB._origMesh) return;
    const _fls=Object.keys(STATE.extCorners||{}).map(Number);
    if(!_fls.length) return;
    const _topFl=Math.max(..._fls);
    const extPoly=STATE.extCorners[_topFl];
    if(!extPoly||extPoly.length<3) return;
    let roofPoly,roofBaseY;
    if(RB._roofType==='flat2'){
      roofPoly=RB._flat2ExpandPoly;
      roofBaseY=RB._flatParams?RB._flatParams.minY:undefined;
    } else {
      // For gable/hip: use DeckManager's current deck polygon (eave = deck perimeter)
      roofPoly=(typeof DeckManager!=='undefined'&&DeckManager._currentPoly)||extPoly;
      const allY=(RB._origVerts||[]).map(v=>v.y);
      if(!allY.length) return;
      const mnY=Math.min(...allY),mxY=Math.max(...allY),thresh=mnY+(mxY-mnY)*0.2;
      const eaveYs=allY.filter(y=>y<=thresh);
      roofBaseY=(eaveYs.reduce((a,b)=>a+b,0)/(eaveYs.length||1))+(RB._yOffset||0);
    }
    if(!roofPoly||roofPoly.length<3) return;
    const colH=roofBaseY-(STATE.modelMinY||0);
    if(!colH||colH<0.1) return;
    const n=roofPoly.length;
    const edgeOH=[];
    for(let i=0;i<n;i++){
      const A=roofPoly[i],B=roofPoly[(i+1)%n];
      const mid={x:(A.x+B.x)/2,z:(A.z+B.z)/2};
      edgeOH.push(this._distToBoundary(mid,extPoly));
    }
    let _area=0;
    for(let k=0;k<n;k++){const j=(k+1)%n; _area+=roofPoly[k].x*roofPoly[j].z-roofPoly[j].x*roofPoly[k].z;}
    const _sgn=_area>0?1:-1;
    const _isConvex=(i)=>{
      const A=roofPoly[(i-1+n)%n],B=roofPoly[i],C=roofPoly[(i+1)%n];
      const cross=(B.x-A.x)*(C.z-B.z)-(B.z-A.z)*(C.x-B.x);
      return cross*_sgn>0;
    };
    const positions=[];
    const added=new Set();
    const addCol=(x,z)=>{const k=x.toFixed(4)+','+z.toFixed(4);if(!added.has(k)){added.add(k);positions.push({x,z});}};
    for(let i=0;i<n;i++){
      if(!_isConvex(i)) continue;
      const prevEdge=(i-1+n)%n;
      if(edgeOH[prevEdge]>this.OVERHANG_MIN||edgeOH[i]>this.OVERHANG_MIN){
        const p=this._cornerInset(roofPoly,i,this.INSET);
        addCol(p.x,p.z);
      }
    }
    // Middle columns: only in the overhang zone of long edges
    // (= portion of edge where distance from EXT > OVERHANG_MIN)
    for(let i=0;i<n;i++){
      const A=roofPoly[i],B=roofPoly[(i+1)%n];
      const dx=B.x-A.x,dz=B.z-A.z,len=Math.sqrt(dx*dx+dz*dz);
      if(len<=this.SIDE_LONG) continue;
      // Sample edge at fine resolution to find continuous overhang zones (>OVERHANG_MIN)
      const samples=Math.max(20, Math.ceil(len*4));
      const inOverhang=[];
      for(let s=0;s<=samples;s++){
        const t=s/samples;
        const px=A.x+dx*t, pz=A.z+dz*t;
        inOverhang.push(this._distToBoundary({x:px,z:pz}, extPoly) > this.OVERHANG_MIN);
      }
      // Find continuous overhang zones [tStart, tEnd]
      const zones=[];
      let zStart=null;
      for(let s=0;s<=samples;s++){
        if(inOverhang[s] && zStart===null) zStart=s;
        if(!inOverhang[s] && zStart!==null){zones.push([zStart/samples, (s-1)/samples]); zStart=null;}
      }
      if(zStart!==null) zones.push([zStart/samples, 1]);
      // Place columns inside each overhang zone according to spacing
      const inN=this._inwardNormal(A,B,extPoly);
      zones.forEach(z=>{
        const t0=z[0], t1=z[1];
        const zoneLen=(t1-t0)*len;
        if(zoneLen<this.COL_SPACING*0.5) return;  // skip tiny zones
        const num=Math.max(1, Math.round(zoneLen/this.COL_SPACING));
        for(let k=0;k<=num;k++){
          const t=t0+(t1-t0)*(k/num);
          // Skip endpoints if too close to edge corner (corners already handled above)
          if(t<0.01 || t>0.99) continue;
          addCol(A.x+dx*t+inN.x*this.INSET, A.z+dz*t+inN.z*this.INSET);
        }
      });
    }
    const _tex=this._loadTexture();
    const mat=new THREE.MeshStandardMaterial({color:_tex?0xffffff:0xfaf9f7,map:_tex||null,roughness:0.85,metalness:0});
    const edgeMat=new THREE.LineBasicMaterial({color:0xcccccc});
    const baseY=STATE.modelMinY||0;
    const isGable=(RB._roofType==='gable'||RB._roofType==='hip');
    const S2=this.COL_SIZE/2;
    positions.forEach(pos=>{
      let geo,mesh;
      if(isGable&&RB._roofYatXZ){
        // Sample roof Y at each of 4 top corners of the column
        const corners=[[-S2,-S2],[S2,-S2],[S2,S2],[-S2,S2]];
        const topYs=corners.map(function(c){
          const y=RB._roofYatXZ(pos.x+c[0],pos.z+c[1],roofBaseY);
          return(y!==null&&y>roofBaseY)?y:roofBaseY;
        });
        // Build custom geometry: 8 verts (4 bottom, 4 top with individual heights)
        const verts=new Float32Array(8*3);
        for(let i=0;i<4;i++){
          const cx=pos.x+corners[i][0],cz=pos.z+corners[i][1];
          // Bottom
          verts[i*3]=corners[i][0];verts[i*3+1]=baseY-pos.z*0+0;verts[i*3+2]=corners[i][1];
          // Top (slanted)
          verts[(i+4)*3]=corners[i][0];verts[(i+4)*3+1]=topYs[i];verts[(i+4)*3+2]=corners[i][1];
        }
        // Place mesh at pos, adjust bottom to 0 relative
        const bottomY=baseY;
        const v=[];
        const bots=corners.map(c=>bottomY);
        // Build faces: bottom(0), top(1), 4 sides
        const mkFace=(ax,ay,az,bx,by,bz,cx,cy,cz,dx,dy,dz)=>{
          v.push(ax,ay,az,bx,by,bz,cx,cy,cz);
          v.push(ax,ay,az,cx,cy,cz,dx,dy,dz);
        };
        const c=corners;const t=topYs;const b=bottomY;
        // Top face (slanted)
        v.push(pos.x+c[0][0],t[0],pos.z+c[0][1], pos.x+c[1][0],t[1],pos.z+c[1][1], pos.x+c[2][0],t[2],pos.z+c[2][1]);
        v.push(pos.x+c[0][0],t[0],pos.z+c[0][1], pos.x+c[2][0],t[2],pos.z+c[2][1], pos.x+c[3][0],t[3],pos.z+c[3][1]);
        // Bottom face
        v.push(pos.x+c[0][0],b,pos.z+c[0][1], pos.x+c[2][0],b,pos.z+c[2][1], pos.x+c[1][0],b,pos.z+c[1][1]);
        v.push(pos.x+c[0][0],b,pos.z+c[0][1], pos.x+c[3][0],b,pos.z+c[3][1], pos.x+c[2][0],b,pos.z+c[2][1]);
        // 4 side faces
        for(let i=0;i<4;i++){
          const ni=(i+1)%4;
          const ax=pos.x+c[i][0],az=pos.z+c[i][1],ti=t[i];
          const bx=pos.x+c[ni][0],bz=pos.z+c[ni][1],tni=t[ni];
          v.push(ax,b,az, bx,b,bz, bx,tni,bz);
          v.push(ax,b,az, bx,tni,bz, ax,ti,az);
        }
        const g=new THREE.BufferGeometry();
        g.setAttribute('position',new THREE.BufferAttribute(new Float32Array(v),3));
        // Face groups: 0-5 top, 6-11 bottom (both gray), 12-35 sides (textured)
        g.addGroup(0,6,0);     // top → material 0 (gray)
        g.addGroup(6,6,0);     // bottom → material 0 (gray)
        g.addGroup(12,24,1);   // sides → material 1 (textured)
        g.computeVertexNormals();
        geo=g;
        const _topColor2 = (CONFIG.meshColors && CONFIG.meshColors.ext) || '#a8a8a8';
        const _topMat2 = new THREE.MeshStandardMaterial({color:new THREE.Color(_topColor2),roughness:0.85,metalness:0,polygonOffset:true,polygonOffsetFactor:-4,polygonOffsetUnits:-4});
        mesh=new THREE.Mesh(geo,[_topMat2,mat.clone()]);
        mesh.position.set(0,0,0);
      } else {
        const topY=roofBaseY;
        const h=Math.max(0.1,topY-baseY);
        geo=new THREE.BoxGeometry(S2*2,h,S2*2);
        // Multi-material: sides use textured `mat`, top/bottom use solid color so they're
        // distinguishable from deck in 2D top view.
        const _topColor = (CONFIG.meshColors && CONFIG.meshColors.ext) || '#a8a8a8';
        const _topMat = new THREE.MeshStandardMaterial({color:new THREE.Color(_topColor),roughness:0.85,metalness:0,polygonOffset:true,polygonOffsetFactor:-4,polygonOffsetUnits:-4});
        const _sideMat = mat.clone();
        mesh=new THREE.Mesh(geo,[_sideMat,_sideMat,_topMat,_topMat,_sideMat,_sideMat]);
        mesh.position.set(pos.x,baseY+h/2,pos.z);
        mesh.add(new THREE.LineSegments(new THREE.EdgesGeometry(geo,15),edgeMat));
      }
      mesh.castShadow=mesh.receiveShadow=true;
      mesh.userData={isOverhangColumn:true,isExtSource:true};
      Engine.scene.add(mesh);this._meshes.push(mesh);
    });
  },
  _distToBoundary(pt,poly){
    let d=Infinity;const n=poly.length;
    for(let i=0;i<n;i++){
      const A=poly[i],B=poly[(i+1)%n],dx=B.x-A.x,dz=B.z-A.z,len2=dx*dx+dz*dz;
      if(len2<1e-6) continue;
      const t=Math.max(0,Math.min(1,((pt.x-A.x)*dx+(pt.z-A.z)*dz)/len2));
      const px=A.x+t*dx,pz=A.z+t*dz;
      const dd=Math.sqrt((pt.x-px)**2+(pt.z-pz)**2);
      if(dd<d) d=dd;
    }
    return d;
  },
  _inwardNormal(A,B,extPoly){
    const dx=B.x-A.x,dz=B.z-A.z,len=Math.sqrt(dx*dx+dz*dz)||1;
    let area=0;
    for(let k=0;k<extPoly.length;k++){const j=(k+1)%extPoly.length; area+=extPoly[k].x*extPoly[j].z-extPoly[j].x*extPoly[k].z;}
    const sign=area>0?1:-1;
    return {x:-dz/len*sign, z:dx/len*sign};
  },
  _cornerInset(poly,idx,inset){
    const n=poly.length;
    const prev=poly[(idx-1+n)%n],cur=poly[idx],next=poly[(idx+1)%n];
    const d1x=prev.x-cur.x,d1z=prev.z-cur.z,l1=Math.sqrt(d1x*d1x+d1z*d1z)||1;
    const d2x=next.x-cur.x,d2z=next.z-cur.z,l2=Math.sqrt(d2x*d2x+d2z*d2z)||1;
    return{x:cur.x+(d1x/l1)*inset+(d2x/l2)*inset,z:cur.z+(d1z/l1)*inset+(d2z/l2)*inset};
  },
  onExtChanged(){this.run();},
  _clear(){this._meshes.forEach(m=>Engine.scene.remove(m));this._meshes=[];}
};
window.ColumnManager = ColumnManager;

// ─── RoofBuilder (modified for flat2) ────────────────────────────────────────
const RoofBuilder = {
  _meshes:[],_planMesh:null,_origMesh:null,THICK:0.15,_pitchDeg:null,_yOffset:0,_origVerts:null,_origCorners:null,_roofType:'gable',_flatParams:null,_hasAtika:false,
  run() {
    this._clear();
    const roofMeshes=STATE.elements.roofs;
    if(!roofMeshes.length){console.warn('[RB] No ROOF meshes');return;}
    roofMeshes.forEach(m=>{m.visible=false;m.userData.isOrigRoofGLB=true;});
    const src=roofMeshes[0];
    this._origMesh=src;src.updateMatrixWorld(true);
    const _rn=src.name.toUpperCase();
    this._roofType=_rn.includes('FLAT2')?'flat2':_rn.includes('FLAT')?'flat':_rn.includes('HIP')?'hip':'gable';
    this._hasAtika=(this._roofType==='flat');
    // Debug log + FLAT2 instance detection (no build yet)
    const _dbgEl=document.getElementById('cv5-rb-debug');
    const _dbg=msg=>{if(_dbgEl)_dbgEl.textContent+=msg+'\n';};
    if(_dbgEl)_dbgEl.textContent='';
    _dbg('[RB] roofType='+this._roofType+' meshes='+roofMeshes.length);
    roofMeshes.forEach((m,i)=>_dbg('  ['+i+'] '+m.name));
    if(this._roofType==='flat2'){
      try {
        this._flat2Instances=this._detectFlat2Instances(roofMeshes);
        _dbg('[RB] FLAT2 instances: '+this._flat2Instances.length);
        this._flat2Instances.forEach(inst=>{
          _dbg('  '+inst.name+' pitch='+inst.pitchDeg.toFixed(1)+'° flat='+inst.isFlat+' polyN='+inst.polygon.length+' baseY='+inst.baseY.toFixed(3)+' anchorE='+inst.anchorEdgeIdx);
        });
      } catch(e) {
        _dbg('[RB] FLAT2 DETECT ERROR: '+e.message);
      }
    }
    // FLAT3 detection (pergola attached to EXT wall)
    try {
      this._flat3Instances=this._detectFlat3Instances(roofMeshes);
      if(this._flat3Instances.length){
        _dbg('[RB] FLAT3 instances: '+this._flat3Instances.length);
        this._flat3Instances.forEach(inst=>{
          _dbg('  '+inst.name+' pitch='+inst.pitchDeg.toFixed(1)+'° width='+inst.width.toFixed(2)+' depth='+inst.depth.toFixed(2)+' baseY='+inst.baseY.toFixed(3));
          _dbg('  anchorEdge: ('+inst.anchorA.x.toFixed(2)+','+inst.anchorA.z.toFixed(2)+')-('+inst.anchorB.x.toFixed(2)+','+inst.anchorB.z.toFixed(2)+')');
        });
      }
    } catch(e) {
      _dbg('[RB] FLAT3 DETECT ERROR: '+e.message);
    }
    STATE.dims.roofType=this._roofType;
    const pos=src.geometry.attributes.position,mw=src.matrixWorld,vCount=pos.count;
    this._origVerts=new Array(vCount);
    this._origCorners={};
    Object.entries(STATE.extCorners||{}).forEach(([fl,cs])=>{this._origCorners[parseInt(fl)]=cs.map(c=>({x:c.x,z:c.z}));});
    for(let i=0;i<vCount;i++){const v=new THREE.Vector3().fromBufferAttribute(pos,i).applyMatrix4(mw);this._origVerts[i]={x:v.x,y:v.y,z:v.z};}
    if(this._roofType==='flat'){
      this._buildGLBSolid();
      return;
    }
    if(this._roofType==='flat2'){
      // FLAT2: use mini-gable only if instance has slope; else legacy flat slab
      const inst=(this._flat2Instances||[])[0];
      const _polyN=inst&&inst.polygon?inst.polygon.length:0;
      const useSlope=inst&&!inst.isFlat&&inst.pitchDeg>0.5;
      // L/U/T-shape (polyN > 4): legacy flat slab without slope (synthetic doesn't handle these)
      if(useSlope&&_polyN>4){
        this._buildFlatSolid(this._defaultPitch||10);
        if(_dbgEl)_dbgEl.textContent+='[FLAT2] L/U-shape, flat slab no slope, polyN='+_polyN+'\n';
        return;
      }
      if(useSlope&&this._setupSyntheticFlat2()){
        this._roofType='gable';
        this._buildSolid(null);
        if(_dbgEl)_dbgEl.textContent+='[FLAT2] mini-gable active, p='+(this._defaultPitch||0).toFixed(1)+'\n';
        return;
      }
      this._buildFlatSolid(this._defaultPitch||10);
      if(_dbgEl)_dbgEl.textContent+='[FLAT2] flat slab (no slope detected)\n';
      return;
    }
    {
      const allY2=this._origVerts.map(v=>v.y),minY2=Math.min(...allY2),maxY2=Math.max(...allY2);
      const eThresh=minY2+(maxY2-minY2)*0.2;
      this._vertBinding=new Array(vCount).fill(null);
      for(let i=0;i<vCount;i++){const v=this._origVerts[i];if(v.y>eThresh)continue;let bestFl=null,bestIdx=null,bestD=Infinity;Object.entries(this._origCorners).forEach(([fl,cs])=>{cs.forEach((c,ci)=>{const d=(c.x-v.x)**2+(c.z-v.z)**2;if(d<bestD){bestD=d;bestFl=parseInt(fl);bestIdx=ci;}});});if(bestFl!==null)this._vertBinding[i]={fl:bestFl,idx:bestIdx};}
      const eaveIdxs=[];for(let i=0;i<vCount;i++){if(this._origVerts[i].y<=eThresh)eaveIdxs.push(i);}
      this._ridgeParents=new Array(vCount).fill(null);
      for(let i=0;i<vCount;i++){const v=this._origVerts[i];if(v.y<=eThresh)continue;let bestPair=null,bestDist=Infinity;for(let a=0;a<eaveIdxs.length;a++){for(let b=a+1;b<eaveIdxs.length;b++){const ea=this._origVerts[eaveIdxs[a]],eb=this._origVerts[eaveIdxs[b]];const mx=(ea.x+eb.x)/2,mz=(ea.z+eb.z)/2,d=(v.x-mx)**2+(v.z-mz)**2;if(d<bestDist){bestDist=d;bestPair=[eaveIdxs[a],eaveIdxs[b]];}}}if(bestPair)this._ridgeParents[i]=bestPair;}
    }
    {
      const allY=this._origVerts.map(v=>v.y),minY=Math.min(...allY),maxY=Math.max(...allY);
      const thresh=minY+(maxY-minY)*0.2,eaveYs=allY.filter(y=>y<=thresh);
      const eaveY=eaveYs.reduce((a,b)=>a+b,0)/(eaveYs.length||1);
      const xs=this._origVerts.map(v=>v.x),zs=this._origVerts.map(v=>v.z);
      const halfSpan=Math.min(Math.max(...xs)-Math.min(...xs),Math.max(...zs)-Math.min(...zs))/2;
      const detectedDeg=halfSpan>0.01?Math.round(Math.atan((maxY-eaveY)/halfSpan)*180/Math.PI):25;
      this._defaultPitch=detectedDeg;
      const slPitch=document.getElementById('v4-sl-pitch');
      if(slPitch){
        if(this._roofType==='flat'){slPitch.min=2;slPitch.max=10;slPitch.step=1;slPitch.value=Math.min(10,Math.max(2,detectedDeg));}
        else{slPitch.min=10;slPitch.max=50;slPitch.step=1;slPitch.value=Math.min(50,Math.max(10,detectedDeg));}
        STATE.dims.pitch=parseInt(slPitch.value);
        const valEl=document.getElementById('v4-val-pitch');if(valEl)valEl.textContent=slPitch.value+' °';
      }
      const ridgeEl=document.getElementById('v4-val-ridge');if(ridgeEl)ridgeEl.textContent=Math.round((maxY-minY)*1000)+' mm';
    }
    this._buildFaceGroups();this._buildSolid(null);
  },
  _buildFaceGroups() {
    const src=this._origMesh,idx=src.geometry.index,vCount=this._origVerts.length;
    const triCount=idx?idx.count/3:vCount/3;
    const nKey=n=>`${Math.round(n.x*100)},${Math.round(n.y*100)},${Math.round(n.z*100)}`,map=new Map();
    for(let t=0;t<triCount;t++){
      const ia=idx?idx.getX(t*3):t*3,ib=idx?idx.getX(t*3+1):t*3+1,ic=idx?idx.getX(t*3+2):t*3+2;
      const A=this._origVerts[ia],B=this._origVerts[ib],C=this._origVerts[ic];
      const n=new THREE.Vector3().crossVectors(new THREE.Vector3(B.x-A.x,B.y-A.y,B.z-A.z),new THREE.Vector3(C.x-A.x,C.y-A.y,C.z-A.z)).normalize();
      if(n.y<0)n.negate();if(n.y>0.99||Math.abs(n.y)<0.08)continue;
      const k=nKey(n);if(!map.has(k))map.set(k,{nx:0,ny:0,nz:0,cnt:0,ptSet:new Set(),ptIdxs:[]});
      const g=map.get(k);g.nx+=n.x;g.ny+=n.y;g.nz+=n.z;g.cnt++;
      [ia,ib,ic].forEach(i=>{if(!g.ptSet.has(i)){g.ptSet.add(i);g.ptIdxs.push(i);}});
    }
    this._faceGroups=[...map.values()].map(g=>{
      // Deduplicate: per XZ position keep only the highest-Y vert (excludes bottom-face duplicates)
      const best=new Map();
      g.ptIdxs.forEach(i=>{const v=this._origVerts[i],k=`${Math.round(v.x*200)}_${Math.round(v.z*200)}`;if(!best.has(k)||this._origVerts[best.get(k)].y<v.y)best.set(k,i);});
      return{n:new THREE.Vector3(g.nx/g.cnt,g.ny/g.cnt,g.nz/g.cnt).normalize(),ptIdxs:[...best.values()]};
    });
  },
  _buildGLBSolid() {
    this._clear();if(!this._origMesh||!this._origVerts)return;
    const src=this._origMesh,idx=src.geometry.index,vCount=this._origVerts.length;
    const triCount=idx?idx.count/3:vCount/3;
    const vertDelta=new Array(vCount);
    for(let i=0;i<vCount;i++){
      const v=this._origVerts[i];
      let bestDx=0,bestDz=0,bestD=Infinity;
      Object.entries(this._origCorners||{}).forEach(([fl,cs])=>{
        const curCs=STATE.extCorners[parseInt(fl)];
        if(!curCs)return;
        cs.forEach((orig,ci)=>{
          const cur=curCs[ci];if(!cur)return;
          const d=(orig.x-v.x)**2+(orig.z-v.z)**2;
          if(d<bestD){bestD=d;bestDx=cur.x-orig.x;bestDz=cur.z-orig.z;}
        });
      });
      vertDelta[i]={dx:bestDx,dz:bestDz};
    }
    const allV=[],allUV=[];
    const yOff=this._yOffset||0;
    const wv=i=>{const v=this._origVerts[i],d=vertDelta[i];return{x:v.x+d.dx,y:v.y+yOff,z:v.z+d.dz};};
    for(let t=0;t<triCount;t++){
      const ia=idx?idx.getX(t*3):t*3,ib=idx?idx.getX(t*3+1):t*3+1,ic=idx?idx.getX(t*3+2):t*3+2;
      const A=wv(ia),B=wv(ib),C=wv(ic);
      allV.push(A.x,A.y,A.z,B.x,B.y,B.z,C.x,C.y,C.z);
      allUV.push(A.x,A.z,B.x,B.z,C.x,C.z);
    }
    const geo=new THREE.BufferGeometry();
    geo.setAttribute('position',new THREE.BufferAttribute(new Float32Array(allV),3));
    geo.setAttribute('uv',new THREE.BufferAttribute(new Float32Array(allUV),2));
    geo.computeVertexNormals();
    const mat=SceneMaterials._make('roof');
    const mesh=new THREE.Mesh(geo,mat);
    mesh.castShadow=mesh.receiveShadow=true;
    mesh.userData={isRoofFace:true,isRoofGLB:true};
    mesh.visible=(STATE.view!=='2d-top');
    Engine.scene.add(mesh);this._meshes.push(mesh);
    this._roofClipPlanes=[];this._ridgeVerts=[];this._facePolygons=[];this._flatParams=null;
  },
  setPitch(deg) {
    this._pitchDeg=deg;if(!this._origMesh||!this._origVerts)return;
    if(this._roofType==='flat'){return;}
    // Synthetic flat2 (originally flat2 with slope, masquerading as gable)
    if(this._origMesh.userData&&this._origMesh.userData.isSyntheticRoof){
      if(this._flat2Instances&&this._flat2Instances[0]) this._flat2Instances[0].pitchDeg=deg;
      if(this._setupSyntheticFlat2()){
        const _ep=window.DeckManager&&window.DeckManager._currentPoly||null;
        this._buildSolid(null,_ep);
        if(window.DeckManager) window.DeckManager.run();
        if(window.ColumnManager) window.ColumnManager.run();
      }
      return;
    }
    if(this._roofType==='flat2'){
      // Legacy flat2 (no slope, plain flat slab)
      if(this._flat2Instances){
        const inst1=this._flat2Instances.find(i=>/FLAT2_1\b|FLAT2_1$/.test(i.name.toUpperCase()))||this._flat2Instances[0];
        if(inst1)inst1.pitchDeg=deg;
      }
      this._buildFlatSolid(deg);return;
    }
    const allY=this._origVerts.map(v=>v.y),minY=Math.min(...allY),maxY=Math.max(...allY);
    // eaveY: only from face-group eave verts (top face, excludes bottom-face duplicates)
    const fgV=new Set();(this._faceGroups||[]).forEach(fg=>fg.ptIdxs.forEach(i=>fgV.add(i)));
    const thresh=minY+(maxY-minY)*0.2;
    const faceEaveYs=this._origVerts.filter((_,i)=>fgV.has(i)&&_.y<=thresh).map(v=>v.y);
    const eaveY=faceEaveYs.length?faceEaveYs.reduce((a,b)=>a+b,0)/faceEaveYs.length:minY;
    // halfSpan: from center to eave XZ edge (use _gableEavePoly if available for accurate span)
    let halfSpan;
    if(this._gableEavePoly&&this._gableEavePoly.length>=3){
      const ep=this._gableEavePoly;
      const exs=ep.map(p=>p.x),ezs=ep.map(p=>p.z);
      halfSpan=Math.min(Math.max(...exs)-Math.min(...exs),Math.max(...ezs)-Math.min(...ezs))/2;
    } else {
      const xs=this._origVerts.map(v=>v.x),zs=this._origVerts.map(v=>v.z);
      halfSpan=Math.min(Math.max(...xs)-Math.min(...xs),Math.max(...zs)-Math.min(...zs))/2;
    }
    const newRidgeH=halfSpan*Math.tan(deg*Math.PI/180),newRidgeY=eaveY+newRidgeH;
    const el=document.getElementById('v4-val-ridge');if(el)el.textContent=Math.round(newRidgeH*1000)+' mm';
    const _eavePoly=window.DeckManager&&window.DeckManager._currentPoly||null;
    this._buildSolid({eaveY,newRidgeY,oldMaxY:maxY}, _eavePoly);
    if(window.DeckManager) window.DeckManager.run();
    if(window.ColumnManager) window.ColumnManager.run();
  },
  _setupSyntheticFlat2() {
    const inst=(this._flat2Instances||[])[0];
    if(!inst||!inst.polygon||inst.polygon.length<4) return false;
    // Use EXT corners (top floor) as basis for synthetic geometry, NOT GLB polygon
    const fls=Object.keys(this._origCorners||{}).map(Number);
    const topFl=fls.length?Math.max(...fls):null;
    const extCorners=topFl!==null?(this._origCorners[topFl]||[]):[];
    if(extCorners.length<4) return false;
    // Determine anchor edge of EXT polygon: pair of adjacent corners closest to GLB anchor edge
    const aIdx=inst.anchorEdgeIdx||0;
    const glbA=inst.polygon[aIdx], glbB=inst.polygon[(aIdx+1)%inst.polygon.length];
    // For each EXT edge, compute distance to GLB anchor midpoint
    const glbMidX=(glbA.x+glbB.x)/2, glbMidZ=(glbA.z+glbB.z)/2;
    let extAnchorIdx=0, bestD=Infinity;
    for(let i=0;i<extCorners.length;i++){
      const ea=extCorners[i], eb=extCorners[(i+1)%extCorners.length];
      const emx=(ea.x+eb.x)/2, emz=(ea.z+eb.z)/2;
      const d=(emx-glbMidX)**2+(emz-glbMidZ)**2;
      if(d<bestD){bestD=d; extAnchorIdx=i;}
    }
    // Eave = anchor EXT edge corners; Ridge = opposite EXT edge corners
    const eaveCornerA=extCorners[extAnchorIdx];
    const eaveCornerB=extCorners[(extAnchorIdx+1)%extCorners.length];
    // For 4-corner polygon, opposite edge = (extAnchorIdx+2, extAnchorIdx+3)
    // But we need to assign ridge corners such that ridgeA is "above" eaveA
    let ridgeCornerA, ridgeCornerB;
    let ridgeIdxA, ridgeIdxB;
    if(extCorners.length===4){
      const c1=extCorners[(extAnchorIdx+2)%extCorners.length];
      const c2=extCorners[(extAnchorIdx+3)%extCorners.length];
      const d1A=(c1.x-eaveCornerA.x)**2+(c1.z-eaveCornerA.z)**2;
      const d2A=(c2.x-eaveCornerA.x)**2+(c2.z-eaveCornerA.z)**2;
      if(d2A<d1A){
        ridgeCornerA=c2; ridgeIdxA=(extAnchorIdx+3)%extCorners.length;
        ridgeCornerB=c1; ridgeIdxB=(extAnchorIdx+2)%extCorners.length;
      } else {
        ridgeCornerA=c1; ridgeIdxA=(extAnchorIdx+2)%extCorners.length;
        ridgeCornerB=c2; ridgeIdxB=(extAnchorIdx+3)%extCorners.length;
      }
    } else {
      // Non-rectangular EXT — fallback to using GLB poly directly
      ridgeCornerA={x:eaveCornerA.x, z:eaveCornerA.z+1};
      ridgeCornerB={x:eaveCornerB.x, z:eaveCornerB.z+1};
      ridgeIdxA=-1; ridgeIdxB=-1;
    }
    // Use these as A, B, oppA, oppB
    const A=eaveCornerA, B=eaveCornerB;
    const oppA=ridgeCornerA, oppB=ridgeCornerB;
    const baseY=inst.baseY+(this._yOffset||0);
    // Inward normal direction for depth calc
    const dxe=B.x-A.x, dze=B.z-A.z, lenAnchor=Math.sqrt(dxe*dxe+dze*dze)||1;
    let nx=-dze/lenAnchor, nz=dxe/lenAnchor;
    let signCheck=(oppA.x-A.x)*nx+(oppA.z-A.z)*nz;
    if(signCheck<0){nx=-nx;nz=-nz;}
    // Perpendicular depth from anchor to opposite edge
    const depth=Math.abs((oppA.x-A.x)*nx+(oppA.z-A.z)*nz)||1;
    const tanP=Math.tan(inst.pitchDeg*Math.PI/180);
    const ridgeY=baseY+depth*tanP;
    // Synthetic vertices: 0=eave_A, 1=eave_B, 2=ridge_A (above A), 3=ridge_B (above B)
    this._origVerts=[
      {x:A.x, y:baseY, z:A.z},
      {x:B.x, y:baseY, z:B.z},
      {x:oppA.x, y:ridgeY, z:oppA.z},
      {x:oppB.x, y:ridgeY, z:oppB.z}
    ];
    // Synthetic indexed mesh (2 triangles forming the slope)
    const positions=new Float32Array([
      A.x, baseY, A.z,
      B.x, baseY, B.z,
      oppA.x, ridgeY, oppA.z,
      oppB.x, ridgeY, oppB.z
    ]);
    const indices=new Uint16Array([0,1,3, 0,3,2]);
    const g=new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    g.setIndex(new THREE.BufferAttribute(indices, 1));
    g.computeVertexNormals();
    this._origMesh=new THREE.Mesh(g);
    this._origMesh.matrixAutoUpdate=false;
    this._origMesh.matrix=new THREE.Matrix4().identity();
    this._origMesh.userData={isSyntheticRoof:true};
    // _vertBinding: bind ALL 4 verts (eave + ridge) to nearest EXT corner
    this._vertBinding=new Array(4).fill(null);
    const bindToCorner=vIdx=>{
      const v=this._origVerts[vIdx];
      let bestFl=null, bestIdx=null, bestD=Infinity;
      Object.entries(this._origCorners||{}).forEach(([fl, cs])=>{
        cs.forEach((c, ci)=>{
          const d=(c.x-v.x)**2+(c.z-v.z)**2;
          if(d<bestD){bestD=d; bestFl=parseInt(fl); bestIdx=ci;}
        });
      });
      if(bestFl!==null) this._vertBinding[vIdx]={fl:bestFl, idx:bestIdx};
    };
    // Eave verts (0, 1) bind to anchor-side EXT corners
    // Ridge verts (2, 3) bind to opp-side EXT corners
    bindToCorner(0); bindToCorner(1); bindToCorner(2); bindToCorner(3);
    // DEBUG: log binding result
    if(document.getElementById('cv5-rb-debug')){
      const _d=document.getElementById('cv5-rb-debug');
      _d.textContent+='[F2] eaveA=('+A.x.toFixed(2)+','+A.z.toFixed(2)+') → fl='+(this._vertBinding[0]?.fl)+' idx='+(this._vertBinding[0]?.idx)+'\n';
      _d.textContent+='[F2] eaveB=('+B.x.toFixed(2)+','+B.z.toFixed(2)+') → fl='+(this._vertBinding[1]?.fl)+' idx='+(this._vertBinding[1]?.idx)+'\n';
      _d.textContent+='[F2] ridgeA=('+oppA.x.toFixed(2)+','+oppA.z.toFixed(2)+') → fl='+(this._vertBinding[2]?.fl)+' idx='+(this._vertBinding[2]?.idx)+'\n';
      _d.textContent+='[F2] ridgeB=('+oppB.x.toFixed(2)+','+oppB.z.toFixed(2)+') → fl='+(this._vertBinding[3]?.fl)+' idx='+(this._vertBinding[3]?.idx)+'\n';
      _d.textContent+='[F2] EXT corners fl=1: ';
      const cs=(this._origCorners||{})[1]||[];
      cs.forEach((c,i)=>{_d.textContent+=i+'('+c.x.toFixed(2)+','+c.z.toFixed(2)+') ';});
      _d.textContent+='\n';
      _d.textContent+='[F2] ridgeY='+ridgeY.toFixed(2)+' baseY='+baseY.toFixed(2)+' depth='+depth.toFixed(2)+'\n';
    }
    // _ridgeParents: not used since all verts have explicit binding, but set as fallback
    this._ridgeParents=[null, null, null, null];
    // Face group: single sloped face containing all 4 verts
    const e1=new THREE.Vector3(B.x-A.x, 0, B.z-A.z);
    const e2=new THREE.Vector3(oppA.x-A.x, ridgeY-baseY, oppA.z-A.z);
    const normal=new THREE.Vector3().crossVectors(e1, e2).normalize();
    if(normal.y<0) normal.negate();
    this._faceGroups=[{n:normal, ptIdxs:[0,1,2,3]}];
    // Defaults + slider
    this._defaultPitch=inst.pitchDeg;
    const slPitch=document.getElementById('v4-sl-pitch');
    if(slPitch){
      slPitch.min=2; slPitch.max=45; slPitch.step=1;
      slPitch.value=Math.round(inst.pitchDeg);
      if(STATE.dims) STATE.dims.pitch=parseInt(slPitch.value);
      const valEl=document.getElementById('v4-val-pitch');
      if(valEl) valEl.textContent=slPitch.value+' °';
    }
    const ridgeEl=document.getElementById('v4-val-ridge');
    if(ridgeEl) ridgeEl.textContent=Math.round((ridgeY-baseY)*1000)+' mm';
    return true;
  },
  _detectFlat3Instances(roofMeshes) {
    const TOL=0.010, GRID=0.005;
    const instances=[];
    roofMeshes.forEach(mesh=>{
      const nm=(mesh.name||'').toUpperCase();
      if(!nm.includes('FLAT3')) return;
      mesh.updateMatrixWorld(true);
      const pos=mesh.geometry.attributes.position, mw=mesh.matrixWorld;
      const wv=[];
      for(let i=0;i<pos.count;i++){wv.push(new THREE.Vector3().fromBufferAttribute(pos,i).applyMatrix4(mw));}
      // Lower-face vertices (XZ snap, min Y per position)
      const minMap=new Map();
      wv.forEach(v=>{
        const sx=Math.round(v.x/GRID)*GRID, sz=Math.round(v.z/GRID)*GRID;
        const k=sx.toFixed(4)+','+sz.toFixed(4);
        if(!minMap.has(k)||minMap.get(k).y>v.y) minMap.set(k,{x:sx,y:v.y,z:sz});
      });
      const lowerPts=Array.from(minMap.values());
      let poly=null;
      try{poly=ExtWallParser._giftWrap(lowerPts.map(p=>({x:p.x,z:p.z})),GRID);}catch(e){}
      if(!poly||poly.length<3){
        const xs=lowerPts.map(p=>p.x),zs=lowerPts.map(p=>p.z);
        poly=[{x:Math.min(...xs),z:Math.min(...zs)},{x:Math.max(...xs),z:Math.min(...zs)},
              {x:Math.max(...xs),z:Math.max(...zs)},{x:Math.min(...xs),z:Math.max(...zs)}];
      }
      const allY=wv.map(v=>v.y), minYall=Math.min(...allY), maxY=Math.max(...allY);
      // Y at each lower-face point
      const yMap=new Map();
      lowerPts.forEach(p=>{yMap.set(p.x.toFixed(4)+','+p.z.toFixed(4),p.y);});
      const ptY=(x,z)=>{
        const sx=Math.round(x/GRID)*GRID, sz=Math.round(z/GRID)*GRID;
        return yMap.get(sx.toFixed(4)+','+sz.toFixed(4));
      };
      // Find anchor edge: highest avg Y AND closest to any EXT wall
      const fls=Object.keys(STATE.extCorners||{}).map(Number);
      const topFl=fls.length?Math.max(...fls):null;
      const extPoly=topFl!==null?(STATE.extCorners[topFl]||[]):[];
      const distEdgeToExt=(eA,eB)=>{
        if(!extPoly.length) return Infinity;
        const midX=(eA.x+eB.x)/2, midZ=(eA.z+eB.z)/2;
        let minD=Infinity;
        for(let i=0;i<extPoly.length;i++){
          const A=extPoly[i], B=extPoly[(i+1)%extPoly.length];
          const dx=B.x-A.x, dz=B.z-A.z, len2=dx*dx+dz*dz;
          if(len2<1e-6) continue;
          const t=Math.max(0,Math.min(1,((midX-A.x)*dx+(midZ-A.z)*dz)/len2));
          const px=A.x+t*dx, pz=A.z+t*dz;
          const d=Math.sqrt((midX-px)*(midX-px)+(midZ-pz)*(midZ-pz));
          if(d<minD) minD=d;
        }
        return minD;
      };
      const n=poly.length;
      let bestI=-1, bestScore=Infinity;
      for(let i=0;i<n;i++){
        const A=poly[i], B=poly[(i+1)%n];
        const yA=ptY(A.x,A.z), yB=ptY(B.x,B.z);
        if(yA===undefined||yB===undefined) continue;
        const avgY=(yA+yB)/2;
        // Score: prioritize edges with high avgY (close to maxY) AND close to EXT
        // score = (maxY - avgY) + dist_to_ext  [lower is better]
        const dExt=distEdgeToExt(A,B);
        const score=(maxY-avgY)*2 + dExt;
        if(score<bestScore){bestScore=score; bestI=i;}
      }
      if(bestI<0) return;
      const anchorA=poly[bestI], anchorB=poly[(bestI+1)%n];
      const anchorY=Math.max(ptY(anchorA.x,anchorA.z)||maxY, ptY(anchorB.x,anchorB.z)||maxY);
      // Width = anchor edge length
      const adx=anchorB.x-anchorA.x, adz=anchorB.z-anchorA.z;
      const width=Math.sqrt(adx*adx+adz*adz);
      // Depth = max perpendicular distance from any polygon vertex to anchor edge
      const len=width||1;
      const nx=-adz/len, nz=adx/len;
      let depth=0;
      poly.forEach(p=>{
        const d=Math.abs((p.x-anchorA.x)*nx+(p.z-anchorA.z)*nz);
        if(d>depth) depth=d;
      });
      // Pitch from anchor (highest) down to opposite (lowest)
      const rise=anchorY-minYall;
      const pitchDeg=depth>0.01 ? Math.atan2(rise,depth)*180/Math.PI : 0;
      // baseY = anchor Y (highest, where pergola attaches to building)
      const baseY=anchorY;
      instances.push({
        name: mesh.name,
        mesh: mesh,
        polygon: poly,
        anchorA: {x:anchorA.x, z:anchorA.z},
        anchorB: {x:anchorB.x, z:anchorB.z},
        baseY: baseY,
        width: width,
        depth: depth,
        pitchDeg: pitchDeg,
        anchorEdgeIdx: bestI
      });
    });
    return instances;
  },
  _detectFlat2Instances(roofMeshes) {
    const TOL=0.010, GRID=0.005;
    const instances=[];
    roofMeshes.forEach(mesh=>{
      const nm=(mesh.name||'').toUpperCase();
      if(!nm.includes('FLAT2')) return;
      mesh.updateMatrixWorld(true);
      const pos=mesh.geometry.attributes.position, mw=mesh.matrixWorld;
      const wv=[];
      for(let i=0;i<pos.count;i++){wv.push(new THREE.Vector3().fromBufferAttribute(pos,i).applyMatrix4(mw));}
      const minMap=new Map();
      wv.forEach(v=>{
        const sx=Math.round(v.x/GRID)*GRID, sz=Math.round(v.z/GRID)*GRID;
        const k=sx.toFixed(4)+','+sz.toFixed(4);
        if(!minMap.has(k)||minMap.get(k).y>v.y) minMap.set(k,{x:sx,y:v.y,z:sz});
      });
      const lowerPts=Array.from(minMap.values());
      let poly=null;
      try{poly=ExtWallParser._giftWrap(lowerPts.map(p=>({x:p.x,z:p.z})),GRID);}catch(e){}
      if(!poly||poly.length<3){
        const xs=lowerPts.map(p=>p.x),zs=lowerPts.map(p=>p.z);
        poly=[{x:Math.min(...xs),z:Math.min(...zs)},{x:Math.max(...xs),z:Math.min(...zs)},
              {x:Math.max(...xs),z:Math.max(...zs)},{x:Math.min(...xs),z:Math.max(...zs)}];
      }
      const allY=wv.map(v=>v.y), minY=Math.min(...allY), maxY=Math.max(...allY);
      const isFlat=(maxY-minY)<TOL;
      let anchorEdgeIdx=0, pitchDeg=0, baseY=minY;
      if(!isFlat){
        const yMap=new Map();
        lowerPts.forEach(p=>{yMap.set(p.x.toFixed(4)+','+p.z.toFixed(4),p.y);});
        const ptY=(x,z)=>{
          const sx=Math.round(x/GRID)*GRID, sz=Math.round(z/GRID)*GRID;
          return yMap.get(sx.toFixed(4)+','+sz.toFixed(4));
        };
        const n=poly.length;
        let bestI=0, bestY=Infinity;
        for(let i=0;i<n;i++){
          const A=poly[i], B=poly[(i+1)%n];
          const yA=ptY(A.x,A.z), yB=ptY(B.x,B.z);
          if(yA===undefined||yB===undefined) continue;
          if(Math.abs(yA-yB)>TOL) continue;
          const avgY=(yA+yB)/2;
          if(avgY<bestY){bestY=avgY;bestI=i;}
        }
        anchorEdgeIdx=bestI;
        baseY=isFinite(bestY)?bestY:minY;
        const A=poly[anchorEdgeIdx], B=poly[(anchorEdgeIdx+1)%n];
        const dx=B.x-A.x, dz=B.z-A.z, len=Math.sqrt(dx*dx+dz*dz)||1;
        const nx=-dz/len, nz=dx/len;
        let maxDist=0;
        poly.forEach(p=>{const d=Math.abs((p.x-A.x)*nx+(p.z-A.z)*nz); if(d>maxDist) maxDist=d;});
        const rise=maxY-baseY;
        pitchDeg=maxDist>0.01 ? Math.atan2(rise,maxDist)*180/Math.PI : 0;
      }
      instances.push({
        name: mesh.name,
        mesh: mesh,
        polygon: poly,
        baseY: baseY,
        anchorEdgeIdx: anchorEdgeIdx,
        pitchDeg: pitchDeg,
        isFlat: isFlat
      });
    });
    return instances;
  },
  _buildFlatSolid(deg) {
    this._clear();if(!this._origMesh||!this._origVerts)return;
    const OVER=0.2,SLAB=0.05,GRID=0.005,TOL=0.05;
    // Find FLAT2_1 instance (main roof). If not found, fall back to first instance, else legacy flat.
    const inst1=(this._flat2Instances||[]).find(i=>/FLAT2_1\b|FLAT2_1$/.test(i.name.toUpperCase()))
              ||(this._flat2Instances||[])[0]||null;
    const useInst=!!inst1;
    let poly, exp, baseY;
    if(useInst){
      baseY=inst1.baseY+(this._yOffset||0);
      // Prefer DeckManager's current polygon (after user drag) over GLB polygon
      const dmPoly=(window.DeckManager&&window.DeckManager._currentPoly)||null;
      if(dmPoly&&dmPoly.length>=3){
        // DeckManager poly already includes overhang, use directly as exp; poly = same shape
        exp=dmPoly.map(p=>({x:p.x,z:p.z}));
        poly=exp;
      } else {
        // Initial load: build exp from instance polygon + OVER inset
        poly=inst1.polygon.map(p=>({x:p.x,z:p.z}));
        try{exp=ExtWallParser._insetPolygon(poly,-OVER);}catch(e){exp=null;}
        if(!exp||exp.length<3){const xs=poly.map(p=>p.x),zs=poly.map(p=>p.z);exp=[{x:Math.min(...xs)-OVER,z:Math.min(...zs)-OVER},{x:Math.max(...xs)+OVER,z:Math.min(...zs)-OVER},{x:Math.max(...xs)+OVER,z:Math.max(...zs)+OVER},{x:Math.min(...xs)-OVER,z:Math.max(...zs)+OVER}];}
      }
    } else {
      // Legacy: build from _origVerts
      const verts=this._origVerts,allY=verts.map(v=>v.y),minY=Math.min(...allY);
      baseY=minY+(this._yOffset||0);
      const snap=new Map();
      verts.forEach(v=>{if(v.y>minY+TOL)return;const sx=Math.round(v.x/GRID)*GRID,sz=Math.round(v.z/GRID)*GRID,k=sx.toFixed(4)+','+sz.toFixed(4);if(!snap.has(k))snap.set(k,{x:sx,z:sz});});
      const raw=Array.from(snap.values());
      try{poly=ExtWallParser._giftWrap(raw,GRID);}catch(e){poly=null;}
      if(!poly||poly.length<3){const xs=raw.map(p=>p.x),zs=raw.map(p=>p.z);poly=[{x:Math.min(...xs),z:Math.min(...zs)},{x:Math.max(...xs),z:Math.min(...zs)},{x:Math.max(...xs),z:Math.max(...zs)},{x:Math.min(...xs),z:Math.max(...zs)}];}
      try{exp=ExtWallParser._insetPolygon(poly,-OVER);}catch(e){exp=null;}
      if(!exp||exp.length<3){const xs=poly.map(p=>p.x),zs=poly.map(p=>p.z);exp=[{x:Math.min(...xs)-OVER,z:Math.min(...zs)-OVER},{x:Math.max(...xs)+OVER,z:Math.min(...zs)-OVER},{x:Math.max(...xs)+OVER,z:Math.max(...zs)+OVER},{x:Math.min(...xs)-OVER,z:Math.max(...zs)+OVER}];}
    }
    // yAt: slope from anchor edge if pitch, else flat
    const usePitch=useInst&&!inst1.isFlat&&inst1.pitchDeg>0.5;
    let yAt=()=>baseY;
    if(usePitch){
      const aIdx=inst1.anchorEdgeIdx||0;
      const polyA_orig=inst1.polygon, nA_orig=polyA_orig.length;
      const A_orig=polyA_orig[aIdx], B_orig=polyA_orig[(aIdx+1)%nA_orig];
      // If we're using dmPoly (after user drag), pick the corresponding edge in dmPoly
      // by finding the one closest to GLB anchor edge midpoint.
      let polyA=polyA_orig, A=A_orig, B=B_orig;
      const dmPoly2=(window.DeckManager&&window.DeckManager._currentPoly)||null;
      if(dmPoly2&&dmPoly2.length>=3){
        const glbMx=(A_orig.x+B_orig.x)/2, glbMz=(A_orig.z+B_orig.z)/2;
        const glbDx=B_orig.x-A_orig.x, glbDz=B_orig.z-A_orig.z;
        const glbLen=Math.sqrt(glbDx*glbDx+glbDz*glbDz)||1;
        // Compute GLB anchor edge direction normalized
        const glbUx=glbDx/glbLen, glbUz=glbDz/glbLen;
        // Find dmPoly edge with closest direction and reasonable position match
        let bestIdx=0, bestScore=Infinity;
        for(let i=0;i<dmPoly2.length;i++){
          const P=dmPoly2[i], Q=dmPoly2[(i+1)%dmPoly2.length];
          const ex=Q.x-P.x, ez=Q.z-P.z;
          const eLen=Math.sqrt(ex*ex+ez*ez)||1;
          const ux=ex/eLen, uz=ez/eLen;
          // Direction similarity (dot product, prefer aligned or anti-aligned)
          const dot=Math.abs(ux*glbUx+uz*glbUz);
          if(dot<0.85)continue; // edges not parallel enough
          // Distance from edge midpoint to GLB anchor midpoint
          const mx=(P.x+Q.x)/2, mz=(P.z+Q.z)/2;
          const dist=Math.sqrt((mx-glbMx)*(mx-glbMx)+(mz-glbMz)*(mz-glbMz));
          // Score: prefer parallel + closer; but we want the one on the SAME SIDE as GLB
          const score=dist*(1.1-dot);
          if(score<bestScore){bestScore=score; bestIdx=i;}
        }
        polyA=dmPoly2;
        A=dmPoly2[bestIdx]; B=dmPoly2[(bestIdx+1)%dmPoly2.length];
      }
      const nA=polyA.length;
      const dx=B.x-A.x, dz=B.z-A.z, len=Math.sqrt(dx*dx+dz*dz)||1;
      const nx=-dz/len, nz=dx/len;
      // Sign: pick direction toward the farthest polygon vertex from anchor edge
      let maxAbs=0, sign=1;
      polyA.forEach(p=>{
        const dRaw=(p.x-A.x)*nx+(p.z-A.z)*nz;
        if(Math.abs(dRaw)>maxAbs){maxAbs=Math.abs(dRaw); sign=dRaw>0?1:-1;}
      });
      const tan=Math.tan(inst1.pitchDeg*Math.PI/180);
      yAt=(px,pz)=>{
        const d=((px-A.x)*nx+(pz-A.z)*nz)*sign;
        return baseY+d*tan;
      };
      if(document.getElementById('cv5-rb-debug')){
        document.getElementById('cv5-rb-debug').textContent+='  [SIGN] sign='+sign+' maxAbs='+maxAbs.toFixed(2)+' tan='+tan.toFixed(3)+'\n';
      }
    }
    const n=exp.length;
    const allV=[],allUV=[];
    const push=(x,y,z)=>{allV.push(x,y,z);allUV.push(x,z);};
    const pts2d=exp.map(p=>new THREE.Vector2(p.x,p.z));
    let tris=null;
    try{tris=THREE.ShapeUtils.triangulateShape(pts2d,[]);}catch(e){tris=null;}
    if(tris&&tris.length){
      tris.forEach(t=>{
        const A=exp[t[0]],B=exp[t[1]],C=exp[t[2]];
        push(A.x,yAt(A.x,A.z)+SLAB,A.z); push(B.x,yAt(B.x,B.z)+SLAB,B.z); push(C.x,yAt(C.x,C.z)+SLAB,C.z);
        push(A.x,yAt(A.x,A.z)-0.001,A.z); push(C.x,yAt(C.x,C.z)-0.001,C.z); push(B.x,yAt(B.x,B.z)-0.001,B.z);
      });
    } else {
      const cx=exp.reduce((s,p)=>s+p.x,0)/n,cz=exp.reduce((s,p)=>s+p.z,0)/n;
      const cyTop=yAt(cx,cz)+SLAB,cyBot=yAt(cx,cz)-0.001;
      for(let i=0;i<n;i++){
        const A=exp[i],B=exp[(i+1)%n];
        push(cx,cyTop,cz); push(A.x,yAt(A.x,A.z)+SLAB,A.z); push(B.x,yAt(B.x,B.z)+SLAB,B.z);
        push(cx,cyBot,cz); push(B.x,yAt(B.x,B.z)-0.001,B.z); push(A.x,yAt(A.x,A.z)-0.001,A.z);
      }
    }
    for(let i=0;i<n;i++){
      const A=exp[i],B=exp[(i+1)%n];
      const yAt_top=yAt(A.x,A.z)+SLAB,yBt_top=yAt(B.x,B.z)+SLAB;
      const yAt_bot=yAt(A.x,A.z)-0.001,yBt_bot=yAt(B.x,B.z)-0.001;
      push(A.x,yAt_top,A.z); push(B.x,yBt_top,B.z); push(B.x,yBt_bot,B.z);
      push(A.x,yAt_top,A.z); push(B.x,yBt_bot,B.z); push(A.x,yAt_bot,A.z);
    }
    const geo=new THREE.BufferGeometry();
    geo.setAttribute('position',new THREE.BufferAttribute(new Float32Array(allV),3));
    geo.setAttribute('uv',new THREE.BufferAttribute(new Float32Array(allUV),2));
    geo.computeVertexNormals();
    const mat=SceneMaterials._make('roof');
    const mesh=new THREE.Mesh(geo,mat);
    mesh.castShadow=mesh.receiveShadow=true;
    mesh.userData={isRoofFace:true,isRoofFlat2:true};
    mesh.visible=(STATE.view!=='2d-top');
    Engine.scene.add(mesh);this._meshes.push(mesh);
    this._roofClipPlanes=[];this._ridgeVerts=[];this._facePolygons=[];
    this._currentEaveY=baseY+SLAB;
    this._flatParams={minY:baseY,fixedCoord:0,slopeAlongZ:false,span:1,rise:0};
    this._flat2OrigPoly=poly;this._flat2ExpandPoly=exp;
    const planY=baseY+0.012,pts=[];
    exp.forEach(p=>pts.push(p.x,planY,p.z));pts.push(exp[0].x,planY,exp[0].z);
    const lg=new THREE.BufferGeometry();lg.setAttribute('position',new THREE.Float32BufferAttribute(pts,3));
    const lm=new THREE.LineDashedMaterial({color:0x333333,dashSize:0.12,gapSize:0.06,depthTest:false});
    const line=new THREE.Line(lg,lm);line.computeLineDistances();line.renderOrder=20;
    line.userData={isRoofPlan:true,isExtSource:true};line.visible=(STATE.view==='2d-top');
    Engine.scene.add(line);this._planMesh=line;
    if(document.getElementById('cv5-rb-debug')){
      const _d=document.getElementById('cv5-rb-debug');
      _d.textContent+='[BUILD] useInst='+useInst+' usePitch='+usePitch+(inst1?' '+inst1.name+' aE='+inst1.anchorEdgeIdx+' p='+inst1.pitchDeg.toFixed(1)+' baseY='+inst1.baseY.toFixed(2):'')+'\n';
    }
  },
  _buildSolid(pitchOverride, eavePoly) {
    this._clear();if(!this._origMesh||!this._origVerts)return;
    const src=this._origMesh,idx=src.geometry.index,vCount=this._origVerts.length;
    const binding=this._vertBinding||[],ridgeParents=this._ridgeParents||[];
    const allOrigY2=this._origVerts.map(v=>v.y),origMinY2=Math.min(...allOrigY2),origMaxY2=Math.max(...allOrigY2);
    const eaveThresh2=origMinY2+(origMaxY2-origMinY2)*0.2,isEaveVert=i=>this._origVerts[i].y<=eaveThresh2;
    const eaveDelta=new Array(vCount).fill(null);
    for(let i=0;i<vCount;i++){
      if(!isEaveVert(i))continue;
      const b=binding[i];
      if(b){const origC=this._origCorners[b.fl]?.[b.idx],curC=STATE.extCorners[b.fl]?.[b.idx];if(origC&&curC){eaveDelta[i]={dx:curC.x-origC.x,dz:curC.z-origC.z};continue;}}
      eaveDelta[i]={dx:0,dz:0};
    }
    // Compute deltas for ALL bound vertices (eave AND ridge), not just eave
    const allDelta=new Array(vCount).fill(null);
    for(let i=0;i<vCount;i++){
      const b=binding[i];
      if(b){
        const origC=this._origCorners[b.fl]?.[b.idx];
        const curC=STATE.extCorners[b.fl]?.[b.idx];
        if(origC&&curC){allDelta[i]={dx:curC.x-origC.x,dz:curC.z-origC.z};}
      }
    }
    const wv=this._origVerts.map((v,i)=>{
      // If vertex has explicit binding (eave or ridge), apply directly
      if(allDelta[i]){const d=allDelta[i];return new THREE.Vector3(v.x+d.dx,v.y,v.z+d.dz);}
      // Otherwise: gable-style ridge propagation via parent eave verts
      const parents=ridgeParents[i];
      if(parents){const dA=allDelta[parents[0]]||{dx:0,dz:0},dB=allDelta[parents[1]]||{dx:0,dz:0};return new THREE.Vector3(v.x+(dA.dx+dB.dx)/2,v.y,v.z+(dA.dz+dB.dz)/2);}
      return new THREE.Vector3(v.x,v.y,v.z);
    });
    if(pitchOverride){const{eaveY,newRidgeY,oldMaxY}=pitchOverride,scale=(oldMaxY-eaveY)>0.001?(newRidgeY-eaveY)/(oldMaxY-eaveY):1;for(let i=0;i<wv.length;i++)wv[i].y=eaveY+(wv[i].y-eaveY)*scale;}
    if(this._yOffset){for(let i=0;i<wv.length;i++)wv[i].y+=this._yOffset;}
    // _gableEavePoly: gift-wrap initial eave verts for DeckManager reference
    // On initial build: do NOT move eave verts (GLB eave is modeled at correct position)
    // On deck drag: snap eave verts to eavePoly
    if(!eavePoly){
      const GRID=0.005,OVER=0.200,_th=(typeof ExtWallParser!=='undefined'&&ExtWallParser._thickW)||0.15;
      const snap2=new Map();
      for(let i=0;i<wv.length;i++){if(!isEaveVert(i))continue;const sx=Math.round(wv[i].x/GRID)*GRID,sz=Math.round(wv[i].z/GRID)*GRID;const k=sx.toFixed(4)+','+sz.toFixed(4);if(!snap2.has(k))snap2.set(k,{x:sx,z:sz});}
      const raw2=Array.from(snap2.values());
      if(raw2.length>=3){let hull2=null;try{hull2=ExtWallParser._giftWrap(raw2,GRID);}catch(e){}if(hull2&&hull2.length>=3){let ep=null;try{ep=ExtWallParser._insetPolygon(hull2,-(_th+OVER));}catch(e){}if(ep&&ep.length>=3)this._gableEavePoly=ep;}}
    } else {
      // Deck drag: snap verts to eavePoly
      const isSynthetic=this._origMesh&&this._origMesh.userData&&this._origMesh.userData.isSyntheticRoof;
      if(isSynthetic){
        // Synthetic flat2: pair each roof vert with its CLOSEST deck vert (no double-assignment)
        const used=new Array(eavePoly.length).fill(false);
        // Sort verts by isEaveVert: eave first (they go to anchor side of deck which is closer)
        const order=[];
        for(let i=0;i<wv.length;i++) order.push(i);
        // Snap each vert to nearest unused deck vertex
        order.forEach(i=>{
          let bJ=-1,bD=Infinity;
          for(let j=0;j<eavePoly.length;j++){
            if(used[j])continue;
            const d=(wv[i].x-eavePoly[j].x)**2+(wv[i].z-eavePoly[j].z)**2;
            if(d<bD){bD=d;bJ=j;}
          }
          if(bJ>=0){
            wv[i].x=eavePoly[bJ].x;
            wv[i].z=eavePoly[bJ].z;
            used[bJ]=true;
          }
        });
      } else {
        // Classic gable: eave snap to nearest, ridge propagation
        for(let i=0;i<wv.length;i++){
          if(!isEaveVert(i))continue;
          let bJ=0,bD=Infinity;
          for(let j=0;j<eavePoly.length;j++){
            const d=(wv[i].x-eavePoly[j].x)**2+(wv[i].z-eavePoly[j].z)**2;
            if(d<bD){bD=d;bJ=j;}
          }
          wv[i].x=eavePoly[bJ].x;wv[i].z=eavePoly[bJ].z;
        }
        for(let i=0;i<wv.length;i++){
          if(isEaveVert(i))continue;
          const pr=ridgeParents[i];
          if(pr){wv[i].x=(wv[pr[0]].x+wv[pr[1]].x)/2;wv[i].z=(wv[pr[0]].z+wv[pr[1]].z)/2;}
        }
      }
    }
    if(!this._faceGroups?.length)return;
    const mat=SceneMaterials._make('roof');
    const THICK=this.THICK,allV=[],allUV=[];
    const push3=(a,b,c,ua,ub,uc)=>{allV.push(...a.toArray(),...b.toArray(),...c.toArray());allUV.push(ua?ua[0]:a.x,ua?ua[1]:a.z,ub?ub[0]:b.x,ub?ub[1]:b.z,uc?uc[0]:c.x,uc?uc[1]:c.z);};
    this._faceGroups.forEach(fg=>{
      const triCount2=idx?idx.count/3:vCount/3,ptSet=new Set(fg.ptIdxs),groupTris=[];
      for(let t=0;t<triCount2;t++){const ia=idx?idx.getX(t*3):t*3,ib=idx?idx.getX(t*3+1):t*3+1,ic=idx?idx.getX(t*3+2):t*3+2;if(ptSet.has(ia)&&ptSet.has(ib)&&ptSet.has(ic))groupTris.push([ia,ib,ic]);}
      if(!groupTris.length)return;
      groupTris.forEach(([ia,ib,ic])=>{const A=wv[ia],B=wv[ib],C=wv[ic];push3(A,B,C,[A.x,A.z],[B.x,B.z],[C.x,C.z]);});
      groupTris.forEach(([ia,ib,ic])=>{const A=wv[ia],B=wv[ib],C=wv[ic];const A2=new THREE.Vector3(A.x,A.y+THICK,A.z),B2=new THREE.Vector3(B.x,B.y+THICK,B.z),C2=new THREE.Vector3(C.x,C.y+THICK,C.z);push3(A2,C2,B2,[A.x,A.z],[C.x,C.z],[B.x,B.z]);});
      const edgeCount=new Map(),edgeKey=(a,b)=>a<b?`${a}_${b}`:`${b}_${a}`;
      groupTris.forEach(([ia,ib,ic])=>{[[ia,ib],[ib,ic],[ic,ia]].forEach(([a,b])=>{const k=edgeKey(a,b);edgeCount.set(k,(edgeCount.get(k)||0)+1);});});
      groupTris.forEach(([ia,ib,ic])=>{[[ia,ib],[ib,ic],[ic,ia]].forEach(([a,b])=>{if(edgeCount.get(edgeKey(a,b))!==1)return;const A=wv[a],B=wv[b],A2=new THREE.Vector3(A.x,A.y+THICK,A.z),B2=new THREE.Vector3(B.x,B.y+THICK,B.z);push3(A,B,B2,[A.x,A.z],[B.x,B.z],[B.x,B.z]);push3(A,B2,A2,[A.x,A.z],[B.x,B.z],[A.x,A.z]);});});
    });
    const geo=new THREE.BufferGeometry();
    geo.setAttribute('position',new THREE.BufferAttribute(new Float32Array(allV),3));
    geo.setAttribute('uv',new THREE.BufferAttribute(new Float32Array(allUV),2));
    geo.computeVertexNormals();
    const mesh=new THREE.Mesh(geo,mat);
    mesh.castShadow=mesh.receiveShadow=true;mesh.userData.isRoofFace=true;mesh.visible=(STATE.view!=='2d-top');
    Engine.scene.add(mesh);this._meshes.push(mesh);
    this._roofClipPlanes=this._faceGroups.map(fg=>{
      const pts=fg.ptIdxs.map(i=>wv[i]);if(pts.length<3)return new THREE.Plane(new THREE.Vector3(0,1,0),0);
      const n=new THREE.Vector3().crossVectors(new THREE.Vector3().subVectors(pts[1],pts[0]),new THREE.Vector3().subVectors(pts[2],pts[0])).normalize();
      if(n.y<0)n.negate();const d=n.dot(pts[0]);return new THREE.Plane(n.clone().negate(),d+n.y*this.THICK);
    });
    // Underside clip planes for INT walls — clip exactly at top surface of roof
    this._roofUndersideClipPlanes=this._faceGroups.map(fg=>{
      const pts=fg.ptIdxs.map(i=>wv[i]);if(pts.length<3)return new THREE.Plane(new THREE.Vector3(0,1,0),0);
      const n=new THREE.Vector3().crossVectors(new THREE.Vector3().subVectors(pts[1],pts[0]),new THREE.Vector3().subVectors(pts[2],pts[0])).normalize();
      if(n.y<0)n.negate();const d=n.dot(pts[0]);return new THREE.Plane(n.clone().negate(),d);
    });
    {const allY=wv.map(v=>v.y),minY=Math.min(...allY),maxY=Math.max(...allY),ridgeThresh=minY+(maxY-minY)*0.8;this._ridgeVerts=wv.filter(v=>v.y>=ridgeThresh).map(v=>({x:v.x,z:v.z,y:v.y}));
    const fgV=new Set();(this._faceGroups||[]).forEach(fg=>fg.ptIdxs.forEach(i=>fgV.add(i)));
    const eaveYs2=wv.filter((_,i)=>fgV.has(i)&&isEaveVert(i)).map(v=>v.y);
    this._currentEaveY=eaveYs2.length?eaveYs2.reduce((a,b)=>a+b,0)/eaveYs2.length:minY;}
    this._facePolygons=this._faceGroups.map(fg=>{const seen=new Map();fg.ptIdxs.forEach(i=>{const v=wv[i],k=`${Math.round(v.x*100)}_${Math.round(v.z*100)}`;if(!seen.has(k))seen.set(k,{x:v.x,z:v.z});});return[...seen.values()];});
    if(ExtWallParser._origMeshes){const floors2=Object.keys(ExtWallParser._origMeshes).map(Number),topFl=floors2.length?Math.max(...floors2):null;if(topFl!==null)ExtWallParser.rebuildFloor(topFl);}
  },
  _flatRoofYatXZ(px,pz){const p=this._flatParams;if(!p)return null;const coord=p.slopeAlongZ?pz:px;const t=p.span>0?Math.max(0,Math.min(1,Math.abs(coord-p.fixedCoord)/p.span)):0;return p.minY+t*p.rise;},
  _roofYatXZ(px,pz,eaveY){
    if(this._roofType==='flat'){const h=this._flatRoofYatXZ(px,pz);return h!==null?h:eaveY;}
    const polys=this._facePolygons||[],planes=this._roofClipPlanes||[];
    if(!polys.length||polys.length!==planes.length){
      window._yatLog=window._yatLog||[];
      if(window._yatLog.length<20) window._yatLog.push('NO-FG('+px.toFixed(2)+','+pz.toFixed(2)+') →'+eaveY.toFixed(2));
      return eaveY;
    }
    const planeY=pl=>{const fn=pl.normal;if(Math.abs(fn.y)<0.01)return eaveY;return(-fn.x*px-fn.z*pz-pl.constant)/fn.y;};
    let minH=Infinity;
    for(let i=0;i<planes.length;i++){const h=planeY(planes[i]);if(h>eaveY&&h<minH)minH=h;}
    if(!isFinite(minH)){
      window._yatLog=window._yatLog||[];
      if(window._yatLog.length<20) window._yatLog.push('INF('+px.toFixed(2)+','+pz.toFixed(2)+') →'+eaveY.toFixed(2));
      return eaveY;
    }
    const ridgeVerts=this._ridgeVerts||[],maxRidgeY=ridgeVerts.length?Math.max(...ridgeVerts.map(v=>v.y)):Infinity;
    const result=Math.min(minH,maxRidgeY)-this.THICK;
    window._yatLog=window._yatLog||[];
    if(window._yatLog.length<20) window._yatLog.push('('+px.toFixed(2)+','+pz.toFixed(2)+') eY='+eaveY.toFixed(2)+' minH='+minH.toFixed(2)+' mR='+maxRidgeY.toFixed(2)+' →'+result.toFixed(2));
    return result;
  },
  applyFinish(img,col) {
    const tl=new THREE.TextureLoader();
    this._meshes.forEach(m=>{if(!m.material)return;if(img){tl.load(img,tex=>{tex.colorSpace=THREE.SRGBColorSpace;tex.wrapS=tex.wrapT=THREE.RepeatWrapping;tex.repeat.set(CONFIG.finishes.scales.roofs,CONFIG.finishes.scales.roofs);m.material.map=tex;m.material.color.set(0xffffff);m.material.needsUpdate=true;});}else{m.material.map=null;m.material.color.set(col);m.material.needsUpdate=true;}});
  },
  _dumpYatLog(){
    const _d=document.getElementById('cv5-rb-debug');
    if(!_d) return;
    const log=window._yatLog||[];
    _d.textContent+='[YAT-LOG] '+log.length+' calls\n';
    log.forEach(l=>{_d.textContent+='  '+l+'\n';});
    window._yatLog=[];
  },
  rebuildForWalls() { if(!this._origMesh)return;if(this._roofType==='flat'){this._buildGLBSolid();ColumnManager.run();if(window.DeckManager)window.DeckManager.run();return;}if(this._roofType==='flat2'){this._buildFlatSolid(this._pitchDeg||this._defaultPitch||10);ColumnManager.run();if(window.DeckManager)window.DeckManager.run();return;}const _ep=window.DeckManager&&window.DeckManager._currentPoly||null;this._pitchDeg!==null?this.setPitch(this._pitchDeg):this._buildSolid(null,_ep);ColumnManager.run();if(window.DeckManager)window.DeckManager.run(); },
  getMeshes() { return this._meshes; },
  _clear()    { this._meshes.forEach(m=>Engine.scene.remove(m));this._meshes=[];if(this._planMesh){Engine.scene.remove(this._planMesh);this._planMesh=null;} }
};
window.RoofBuilder = RoofBuilder;
// ─── DeckManager ─────────────────────────────────────────────────────────────
// Generates a terrace/deck solid at ground level with same footprint as roof.
// Edges are draggable in 2D to change overhang. Roof solid follows deck polygon.
const DeckManager = {
  MIN_OH:0.000, MAX_OH:5.000, THICK:0.150,
  _offsets:[], _meshes:[], _drag:null, _bound:false, _label:null,
  _basePoly:null, _origMeshRef:null,

  _getExtInner(){
    var S=window.STATE;
    var fls=Object.keys(S.extCorners||{}).map(Number);
    if(!fls.length) return null;
    return S.extCorners[Math.max.apply(null,fls)];
  },
  

  run(){
    this._clear();
    var RB=window.RoofBuilder;
    if(!RB||!RB._origMesh) return;
    if(RB._roofType!=='flat2'&&RB._roofType!=='gable'&&RB._roofType!=='hip') return;

    var extInner=this._getExtInner();
    if(!extInner||extInner.length<3) return;
    var thick=(window.ExtWallParser&&window.ExtWallParser._thickW)||0.15;
    var n=extInner.length;

    // Reset offsets only on TRUE model change (not synthetic refresh from setPitch)
    if(this._origMeshRef!==RB._origMesh){
      var _wasSynth=this._origMeshRef&&this._origMeshRef.userData&&this._origMeshRef.userData.isSyntheticRoof;
      var _isSynth=RB._origMesh&&RB._origMesh.userData&&RB._origMesh.userData.isSyntheticRoof;
      this._origMeshRef=RB._origMesh;
      // Synthetic re-creation (pitch change) must NOT reset offsets
      if(!(_wasSynth&&_isSynth)){
        this._offsets=[];
      }
    }

    // Init per-edge offsets from GLB polygon on first run (equidistance from GLB shape)
    if(!this._initialized){
      this._initialized=true;
      if(n===4){
        var glbPoly=(RB._roofType==='flat2')?RB._flat2ExpandPoly:RB._gableEavePoly;
        var extOuter0=this._applyOffsets(extInner,thick,new Array(n).fill(0));
        this._offsets=this._computeInitOffsets(extOuter0,glbPoly,n);
      } else {
        this._offsets=new Array(n).fill(0);
      }
    }

    // basePoly ALWAYS = extOuter (tracks EXT drag equidistantly)
    var basePoly=this._applyOffsets(extInner,thick,new Array(n).fill(0));
    if(!basePoly||basePoly.length<3) return;

    if(this._offsets.length!==n) this._offsets=new Array(n).fill(0);
    for(var k=0;k<n;k++) if(this._offsets[k]<0) this._offsets[k]=0;

    // exp = extOuter + per-edge offsets (min 200mm total from EXT outer face)
    var exp=this._applyOffsets(basePoly,0.200,this._offsets);
    if(!exp||exp.length<3) return;
    this._basePoly=basePoly;
    this._baseExpand=0.200;
    this._buildDeck(exp);
    this._syncRoof(exp, RB, false);  // false = initial, don't rebuild roof
    if(window.ColumnManager) window.ColumnManager.run();
    if(window.Flat3DeckManager) window.Flat3DeckManager.run();
  },

  _buildDeck(poly){
    var S=window.STATE;
    var baseY=S.modelMinY||0, top=baseY, bot=baseY-this.THICK;
    var n=poly.length;
    var allV=[],allUV=[];
    function push(x,y,z){allV.push(x,y,z);allUV.push(x,z);}
    var pts2d=poly.map(function(p){return new THREE.Vector2(p.x,p.z);});
    var tris=null;
    try{tris=THREE.ShapeUtils.triangulateShape(pts2d,[]);}catch(e){tris=null;}
    if(tris&&tris.length){
      tris.forEach(function(t){
        var A=poly[t[0]],B=poly[t[1]],C=poly[t[2]];
        push(A.x,top,A.z); push(B.x,top,B.z); push(C.x,top,C.z);
        push(A.x,bot,A.z); push(C.x,bot,C.z); push(B.x,bot,B.z);
      });
    } else {
      var cx=poly.reduce(function(s,p){return s+p.x;},0)/n;
      var cz=poly.reduce(function(s,p){return s+p.z;},0)/n;
      for(var i=0;i<n;i++){
        var A=poly[i],B=poly[(i+1)%n];
        push(cx,top,cz);push(A.x,top,A.z);push(B.x,top,B.z);
        push(cx,bot,cz);push(B.x,bot,B.z);push(A.x,bot,A.z);
      }
    }
    for(var i=0;i<n;i++){
      var A=poly[i],B=poly[(i+1)%n];
      push(A.x,top,A.z);push(B.x,top,B.z);push(B.x,bot,B.z);
      push(A.x,top,A.z);push(B.x,bot,B.z);push(A.x,bot,A.z);
    }
    var geo=new THREE.BufferGeometry();
    geo.setAttribute('position',new THREE.BufferAttribute(new Float32Array(allV),3));
    geo.setAttribute('uv',new THREE.BufferAttribute(new Float32Array(allUV),2));
    geo.computeVertexNormals();
    var mat=new THREE.MeshStandardMaterial({color:0xd8d0c8,roughness:0.9,metalness:0,side:THREE.DoubleSide});
    var mesh=new THREE.Mesh(geo,mat);
    mesh.castShadow=true;
    mesh.receiveShadow=true;
    mesh.userData={isDeckTerrace:true,isExtSource:true};
    window.Engine.scene.add(mesh);
    this._meshes.push(mesh);
    this._currentPoly=poly;
  },

  _syncRoof(exp, RB, fromDrag){
    if(RB._roofType!=='flat2'){
      RB._flat2ExpandPoly=exp;
      // Rebuild roof mesh first (calls _clear which removes old planMesh)
      if(!RB._inSyncRoof){
        RB._inSyncRoof=true;
        RB._buildSolid(null, exp);
        RB._inSyncRoof=false;
      }
      // Set plan line AFTER _buildSolid so _clear() doesn't delete it
      if(RB._planMesh){window.Engine.scene.remove(RB._planMesh);RB._planMesh=null;}
      var _allY2=(RB._origVerts||[]).map(function(v){return v.y;}),_minY2=_allY2.length?Math.min.apply(null,_allY2):0;
      var planY2=_minY2+(RB._yOffset||0)+0.012;
      var pts2=[];exp.forEach(function(p){pts2.push(p.x,planY2,p.z);});pts2.push(exp[0].x,planY2,exp[0].z);
      var lg2=new THREE.BufferGeometry();lg2.setAttribute('position',new THREE.Float32BufferAttribute(pts2,3));
      var line2=new THREE.Line(lg2,new THREE.LineDashedMaterial({color:0x333333,dashSize:0.12,gapSize:0.06,depthTest:false}));
      line2.computeLineDistances();line2.renderOrder=20;
      line2.userData={isRoofPlan:true,isExtSource:true};line2.visible=(window.STATE.view==='2d-top');
      window.Engine.scene.add(line2);RB._planMesh=line2;
      return;
    }
    // flat2: rebuild roof slab at exp polygon
    if(!RB._flatParams) return;
    var baseY=RB._flatParams.minY;
    RB._meshes.forEach(function(m){window.Engine.scene.remove(m);}); RB._meshes=[];
    if(RB._planMesh){window.Engine.scene.remove(RB._planMesh);RB._planMesh=null;}
    var SLAB=0.05,top=baseY+SLAB,bot=baseY-0.001;
    var n=exp.length;
    var allV=[],allUV=[];
    function push(x,y,z){allV.push(x,y,z);allUV.push(x,z);}
    var pts2d=exp.map(function(p){return new THREE.Vector2(p.x,p.z);});
    var tris=null;
    try{tris=THREE.ShapeUtils.triangulateShape(pts2d,[]);}catch(e){tris=null;}
    if(tris&&tris.length){
      tris.forEach(function(t){
        var A=exp[t[0]],B=exp[t[1]],C=exp[t[2]];
        push(A.x,top,A.z); push(B.x,top,B.z); push(C.x,top,C.z);
        push(A.x,bot,A.z); push(C.x,bot,C.z); push(B.x,bot,B.z);
      });
    } else {
      var cx=exp.reduce(function(s,p){return s+p.x;},0)/n;
      var cz=exp.reduce(function(s,p){return s+p.z;},0)/n;
      for(var i=0;i<n;i++){
        var A=exp[i],B=exp[(i+1)%n];
        push(cx,top,cz);push(A.x,top,A.z);push(B.x,top,B.z);
        push(cx,bot,cz);push(B.x,bot,B.z);push(A.x,bot,A.z);
      }
    }
    for(var i=0;i<n;i++){
      var A=exp[i],B=exp[(i+1)%n];
      push(A.x,top,A.z);push(B.x,top,B.z);push(B.x,bot,B.z);
      push(A.x,top,A.z);push(B.x,bot,B.z);push(A.x,bot,A.z);
    }
    var geo=new THREE.BufferGeometry();
    geo.setAttribute('position',new THREE.BufferAttribute(new Float32Array(allV),3));
    geo.setAttribute('uv',new THREE.BufferAttribute(new Float32Array(allUV),2));
    geo.computeVertexNormals();
    var mesh=new THREE.Mesh(geo,window.SceneMaterials._make('roof'));
    mesh.castShadow=mesh.receiveShadow=true;
    mesh.userData={isRoofFace:true,isRoofFlat2:true};
    mesh.visible=(window.STATE.view!=='2d-top');
    window.Engine.scene.add(mesh); RB._meshes.push(mesh);
    RB._flat2ExpandPoly=exp;
    var planY=baseY+0.012,pts=[];
    exp.forEach(function(p){pts.push(p.x,planY,p.z);}); pts.push(exp[0].x,planY,exp[0].z);
    var lg=new THREE.BufferGeometry();
    lg.setAttribute('position',new THREE.Float32BufferAttribute(pts,3));
    var line=new THREE.Line(lg,new THREE.LineDashedMaterial({color:0x333333,dashSize:0.12,gapSize:0.06,depthTest:false}));
    line.computeLineDistances();line.renderOrder=20;
    line.userData={isRoofPlan:true,isExtSource:true};
    line.visible=(window.STATE.view==='2d-top');
    window.Engine.scene.add(line);RB._planMesh=line;
  },

  bindDrag(){
    if(this._bound) return; this._bound=true;
    var self=this, cv=document.getElementById('cv5-canvas');
    if(!cv) return;
    var HIT=22;
    if(!this._label){
      var lbl=document.createElement('div');
      lbl.style.cssText='position:absolute;background:#333d;color:#fff;font:700 11px monospace;padding:3px 8px;border-radius:6px;pointer-events:none;display:none;z-index:500;transform:translate(-50%,-130%);';
      (document.getElementById('cv5-root')||document.body).appendChild(lbl);
      this._label=lbl;
    }
    function planY(){return (window.STATE.modelMinY||0)+self.THICK+0.01;}
    function getEdges(){
      var poly=self._currentPoly; if(!poly||!window.Engine) return [];
      var n=poly.length;
      var area=0;
      for(var k=0;k<n;k++){var j2=(k+1)%n; area+=poly[k].x*poly[j2].z-poly[j2].x*poly[k].z;}
      var sign=area>0?-1:1;
      var out=[];
      for(var i=0;i<n;i++){
        var A=poly[i],B=poly[(i+1)%n];
        var sA=window.Engine.toScreen(new THREE.Vector3(A.x,planY(),A.z));
        var sB=window.Engine.toScreen(new THREE.Vector3(B.x,planY(),B.z));
        var dx=B.x-A.x,dz=B.z-A.z,len=Math.sqrt(dx*dx+dz*dz)||1;
        var nx=-dz/len*sign, nz=dx/len*sign;
        out.push({idx:i,sA:sA,sB:sB,mx:(sA.x+sB.x)/2,my:(sA.y+sB.y)/2,nx:nx,nz:nz});
      }
      return out;
    }
    function ptSegDist(px,py,ax,ay,bx,by){
      var dx=bx-ax,dy=by-ay,len2=dx*dx+dy*dy;
      if(len2<0.001) return Math.sqrt((px-ax)*(px-ax)+(py-ay)*(py-ay));
      var t=Math.max(0,Math.min(1,((px-ax)*dx+(py-ay)*dy)/len2));
      return Math.sqrt((px-(ax+t*dx))*(px-(ax+t*dx))+(py-(ay+t*dy))*(py-(ay+t*dy)));
    }
    function findEdge(ex,ey,edges){
      var best=null,bestD=HIT;
      for(var i=0;i<edges.length;i++){
        var e=edges[i];
        var d=ptSegDist(ex,ey,e.sA.x,e.sA.y,e.sB.x,e.sB.y);
        if(d<bestD){bestD=d;best=e;}
      } return best;
    }
    function evPt(e){var r=cv.getBoundingClientRect();return{x:e.clientX-r.left,y:e.clientY-r.top};}
    function worldAt(e){
      var r=cv.getBoundingClientRect();
      var nx2=((e.clientX-r.left)/r.width)*2-1,ny2=-((e.clientY-r.top)/r.height)*2+1;
      var v=new THREE.Vector3(nx2,ny2,0.5).unproject(window.Engine.orthoCamera);
      return{x:v.x,z:v.z};
    }
    cv.addEventListener('pointermove',function(e){
      if(window.STATE.view!=='2d-top'||self._drag) return;
      var pt=evPt(e),hit=findEdge(pt.x,pt.y,getEdges());
      cv.style.cursor=hit?'ns-resize':'';
    },true);
    cv.addEventListener('pointerdown',function(e){
      if(window.STATE.view!=='2d-top'||window.STATE.isDragging) return;
      var pt=evPt(e),edges=getEdges(),hit=findEdge(pt.x,pt.y,edges);
      if(!hit) return;
      e.stopPropagation();
      var w=worldAt(e);
      var _oidx=(hit.idx+1)%self._offsets.length;
      self._drag={idx:hit.idx,oidx:_oidx,nx:hit.nx,nz:hit.nz,startW:w,startOff:self._offsets[_oidx]||0,mx:hit.mx,my:hit.my};
      window.Engine.orthoControls.enabled=false;
      try{cv.setPointerCapture(e.pointerId);}catch(ex){}
    },true);
    cv.addEventListener('pointermove',function(e){
      if(!self._drag) return;
      e.stopPropagation();
      var d=self._drag,w=worldAt(e);
      var delta=(w.x-d.startW.x)*d.nx+(w.z-d.startW.z)*d.nz;
      var _isMetric=window.STATE?window.STATE.isMetric!==false:true;
      var _snapMm=_isMetric?(window.CONFIG&&window.CONFIG.overhangStepMm?window.CONFIG.overhangStepMm:50):(window.CONFIG&&window.CONFIG.overhangStepInch?window.CONFIG.overhangStepInch*25.4:50.8);
      var _snapM=_snapMm/1000;
      var rawOff=d.startOff+delta;
      var snappedOff=Math.round(rawOff/_snapM)*_snapM;
      var newOff=Math.max(0,Math.min(self.MAX_OH,snappedOff));
      self._offsets[d.oidx]=newOff;
      self._rebuild();
      if(self._label){
        self._label.textContent=_isMetric?Math.round(newOff*1000)+' mm':(newOff*39.3701).toFixed(1)+' in';
        self._label.style.display='block';
        self._label.style.left=d.mx+'px';
        self._label.style.top=d.my+'px';
      }
    },true);
    cv.addEventListener('pointerup',function(e){
      if(!self._drag) return;
      self._drag=null;
      window.Engine.orthoControls.enabled=true;
      cv.style.cursor='';
      if(self._label) self._label.style.display='none';
      if(window.ColumnManager) window.ColumnManager.run();
    },true);
  },

  _rebuild(){
    if(!this._basePoly||this._basePoly.length<3) return;
    var n=this._basePoly.length;
    if(this._offsets.length!==n) this._offsets=new Array(n).fill(0);
    for(var k=0;k<n;k++) if(this._offsets[k]<0) this._offsets[k]=0;
    var exp=this._applyOffsets(this._basePoly,this._baseExpand||0,this._offsets);
    if(!exp||exp.length<3) return;
    var _d=document.getElementById('cv5-rb-debug');
    if(_d){_d.textContent+='[DRAG] offs=['+this._offsets.map(function(o){return o.toFixed(2);}).join(',')+'] expN='+exp.length+'\n';}
    this._meshes.forEach(function(m){window.Engine.scene.remove(m);}); this._meshes=[];
    var RB=window.RoofBuilder;
    this._buildDeck(exp);
    if(_d){_d.textContent+='[DRAG] after _buildDeck deckMeshes='+this._meshes.length+'\n';}
    if(RB) this._syncRoof(exp, RB, true);  // true = from drag, rebuild roof
    if(_d){_d.textContent+='[DRAG] after _syncRoof deckMeshes='+this._meshes.length+' roofMeshes='+(RB?RB._meshes.length:'?')+'\n';}
    // Re-render pergola deck (preserves its offsets)
    if(window.Flat3DeckManager) window.Flat3DeckManager._rebuild();
  },

  // Compute initial per-edge offsets so deck matches GLB polygon at startup
  _computeInitOffsets(extOuter, glbPoly, n){
    var offs=new Array(n).fill(0);
    if(!glbPoly||glbPoly.length<3) return offs;
    var area=0;
    for(var k=0;k<n;k++){var j2=(k+1)%n; area+=extOuter[k].x*extOuter[j2].z-extOuter[j2].x*extOuter[k].z;}
    var sign=area>0?-1:1;
    for(var i=0;i<n;i++){
      var A=extOuter[i],B=extOuter[(i+1)%n];
      var dx=B.x-A.x,dz=B.z-A.z,len=Math.sqrt(dx*dx+dz*dz)||1;
      var nx=-dz/len*sign, nz=dx/len*sign;
      var midX=(A.x+B.x)/2,midZ=(A.z+B.z)/2;
      var maxD=0;
      for(var j=0;j<glbPoly.length;j++){
        var d=(glbPoly[j].x-midX)*nx+(glbPoly[j].z-midZ)*nz;
        if(d>maxD) maxD=d;
      }
      offs[i]=Math.max(0,maxD-0.200);
    }
    return offs;
  },

  _applyOffsets(poly,base,extras){
    var n=poly.length,edges=[];
    var area=0;
    for(var k=0;k<n;k++){var j2=(k+1)%n; area+=poly[k].x*poly[j2].z-poly[j2].x*poly[k].z;}
    var sign=area>0?-1:1;
    for(var i=0;i<n;i++){
      var A=poly[i],B=poly[(i+1)%n],dx=B.x-A.x,dz=B.z-A.z,len=Math.sqrt(dx*dx+dz*dz)||1;
      var nx=-dz/len*sign, nz=dx/len*sign;
      var d=base+(extras[i]||0);
      edges.push({ax:A.x+nx*d,az:A.z+nz*d,bx:B.x+nx*d,bz:B.z+nz*d});
    }
    var out=[];
    for(var i=0;i<n;i++){
      var e1=edges[i],e2=edges[(i+1)%n];
      var rx=e1.bx-e1.ax,rz=e1.bz-e1.az,sx=e2.bx-e2.ax,sz=e2.bz-e2.az;
      var den=rx*sz-rz*sx;
      if(Math.abs(den)<1e-9){out.push({x:e1.bx,z:e1.bz});continue;}
      var t=((e2.ax-e1.ax)*sz-(e2.az-e1.az)*sx)/den;
      out.push({x:e1.ax+t*rx,z:e1.az+t*rz});
    }
    return out;
  },

  onExtChanged(){this.run();},
  _clear(){this._meshes.forEach(function(m){if(window.Engine)window.Engine.scene.remove(m);}); this._meshes=[];}
};
// ─── Flat3DeckManager (Pergola) ─────────────────────────────────────────────
// Standalone deck under FLAT3 (pergola). Anchor edge (touching EXT) is fixed,
// other 3 edges have 200mm overhang (draggable in step 2).
const Flat3DeckManager = {
  THICK: 0.150,
  OVERHANG: 0.200,
  MIN_OH: 0.000,
  MAX_OH: 5.000,
  _meshes: [],
  _basePoly: null,
  _currentPoly: null,
  _anchorIdx: -1,
  _offsets: [],
  _origMeshRef: null,
  _bound: false,
  _drag: null,
  _label: null,

  run(){
    this._clear();
    var RB = window.RoofBuilder;
    if(!RB || !RB._origMesh) return;
    var inst = (RB._flat3Instances || [])[0];
    if(!inst || !inst.polygon || inst.polygon.length < 4) return;

    // Reset offsets only on TRUE model change (not synthetic refresh from setPitch / EXT drag)
    if(this._origMeshRef !== RB._origMesh){
      var _wasSynth = this._origMeshRef && this._origMeshRef.userData && this._origMeshRef.userData.isSyntheticRoof;
      var _isSynth = RB._origMesh && RB._origMesh.userData && RB._origMesh.userData.isSyntheticRoof;
      this._origMeshRef = RB._origMesh;
      if(!(_wasSynth && _isSynth)){
        this._offsets = [];
      }
    }

    // Reconstruct CLEAN rectangle from anchorA, anchorB, depth
    // (inst.polygon from gift-wrap may have spurious vertices)
    var aA = inst.anchorA, aB = inst.anchorB;
    var dx = aB.x - aA.x, dz = aB.z - aA.z;
    var len = Math.sqrt(dx*dx + dz*dz) || 1;
    var ux = dx/len, uz = dz/len;
    // Perpendicular direction (away from EXT, toward pergola interior)
    // Determine sign by checking instance polygon centroid
    var nx = -uz, nz = ux;
    if(inst.polygon && inst.polygon.length){
      var cx0 = 0, cz0 = 0;
      inst.polygon.forEach(function(p){cx0 += p.x; cz0 += p.z;});
      cx0 /= inst.polygon.length; cz0 /= inst.polygon.length;
      var aMidX = (aA.x+aB.x)/2, aMidZ = (aA.z+aB.z)/2;
      if(nx*(cx0-aMidX) + nz*(cz0-aMidZ) < 0){nx = -nx; nz = -nz;}
    }
    // Save pergola roof params from GLB for synthetic roof rendering with slope
    this._roofBaseY = inst.baseY;
    this._roofPitchDeg = inst.pitchDeg || 0;
    this._roofAnchorAx = aA.x; this._roofAnchorAz = aA.z;
    this._roofAnchorNx = nx;   this._roofAnchorNz = nz;
    var depth = inst.depth || 2.0;
    var farA = {x: aA.x + nx*depth, z: aA.z + nz*depth};
    var farB = {x: aB.x + nx*depth, z: aB.z + nz*depth};
    // CCW order: anchor edge first (idx 0), then sides, then far edge
    this._basePoly = [
      {x: aA.x, z: aA.z},     // 0: anchor start
      {x: aB.x, z: aB.z},     // 1: anchor end (= anchor edge between idx 0-1)
      {x: farB.x, z: farB.z}, // 2: far end
      {x: farA.x, z: farA.z}  // 3: far start (= edge between 3-0)
    ];
    var n = this._basePoly.length;
    // Anchor edge is always idx 0 (between basePoly[0] and basePoly[1])
    this._anchorIdx = 0;

    // Init offsets array (0 = base OVERHANG only, no extra)
    if(this._offsets.length !== n) this._offsets = new Array(n).fill(0);

    // exp = pergola polygon expanded by OVERHANG on non-anchor edges
    var exp = this._applyOffsets(this._basePoly, this._offsets);
    if(!exp || exp.length < 3) return;

    this._currentPoly = exp;
    this._buildDeck(exp);

    // Debug log
    var _d = document.getElementById('cv5-rb-debug');
    if(_d){
      _d.textContent += '[F3-DECK] anchorIdx=' + this._anchorIdx + ' polyN=' + n;
      _d.textContent += ' aA=(' + aA.x.toFixed(2) + ',' + aA.z.toFixed(2) + ')';
      _d.textContent += ' aB=(' + aB.x.toFixed(2) + ',' + aB.z.toFixed(2) + ')\n';
    }
  },

  _applyOffsets(poly, extras){
    var n = poly.length, edges = [];
    var cx = 0, cz = 0;
    for(var k = 0; k < n; k++){cx += poly[k].x; cz += poly[k].z;}
    cx /= n; cz /= n;
    for(var i = 0; i < n; i++){
      var A = poly[i], B = poly[(i+1)%n];
      var dx = B.x - A.x, dz = B.z - A.z, len = Math.sqrt(dx*dx + dz*dz) || 1;
      var nx = -dz/len, nz = dx/len;
      var midX = (A.x+B.x)/2, midZ = (A.z+B.z)/2;
      if(nx*(midX-cx) + nz*(midZ-cz) < 0){nx = -nx; nz = -nz;}
      // Anchor edge: 0 offset (fixed at EXT outer face)
      // Other edges: OVERHANG + extras[i]
      var d = (i === this._anchorIdx) ? 0 : (this.OVERHANG + (extras[i] || 0));
      edges.push({ax: A.x + nx*d, az: A.z + nz*d, bx: B.x + nx*d, bz: B.z + nz*d});
    }
    var out = [];
    for(var i = 0; i < n; i++){
      var e1 = edges[i], e2 = edges[(i+1)%n];
      var rx = e1.bx-e1.ax, rz = e1.bz-e1.az, sx = e2.bx-e2.ax, sz = e2.bz-e2.az;
      var den = rx*sz - rz*sx;
      if(Math.abs(den) < 1e-9){out.push({x: e1.bx, z: e1.bz}); continue;}
      var t = ((e2.ax-e1.ax)*sz - (e2.az-e1.az)*sx) / den;
      out.push({x: e1.ax + t*rx, z: e1.az + t*rz});
    }
    return out;
  },

  _buildDeck(poly){
    var S = window.STATE;
    var baseY = S.modelMinY || 0, top = baseY, bot = baseY - this.THICK;
    var n = poly.length;
    var cx = poly.reduce(function(s,p){return s+p.x;}, 0) / n;
    var cz = poly.reduce(function(s,p){return s+p.z;}, 0) / n;
    var allV = [], allUV = [];
    function push(x,y,z){allV.push(x,y,z); allUV.push(x,z);}
    for(var i = 0; i < n; i++){
      var A = poly[i], B = poly[(i+1)%n];
      push(cx,top,cz); push(A.x,top,A.z); push(B.x,top,B.z);
      push(cx,bot,cz); push(B.x,bot,B.z); push(A.x,bot,A.z);
      push(A.x,top,A.z); push(B.x,top,B.z); push(B.x,bot,B.z);
      push(A.x,top,A.z); push(B.x,bot,B.z); push(A.x,bot,A.z);
    }
    var geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(allV), 3));
    geo.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(allUV), 2));
    geo.computeVertexNormals();
    var mat = new THREE.MeshStandardMaterial({color: 0xd8d0c8, roughness: 0.9, metalness: 0, side: THREE.DoubleSide});
    var mesh = new THREE.Mesh(geo, mat);
    mesh.castShadow = true;
    mesh.receiveShadow = true;
    mesh.userData = {isPergolaDeck: true, isExtSource: true};
    window.Engine.scene.add(mesh);
    this._meshes.push(mesh);

    // Dashed line outline (visible in 2D top view) — same look as FLAT2 deck
    var planY = baseY + 0.012;
    var pts = [];
    poly.forEach(function(p){pts.push(p.x, planY, p.z);});
    pts.push(poly[0].x, planY, poly[0].z);
    var lg = new THREE.BufferGeometry();
    lg.setAttribute('position', new THREE.Float32BufferAttribute(pts, 3));
    var line = new THREE.Line(lg, new THREE.LineDashedMaterial({color: 0x2a8d4a, dashSize: 0.12, gapSize: 0.06, depthTest: false}));
    line.computeLineDistances();
    line.renderOrder = 20;
    line.userData = {isPergolaPlan: true};
    line.visible = (window.STATE.view === '2d-top');
    window.Engine.scene.add(line);
    this._meshes.push(line);

    // Build synthetic pergola roof slab (follows deck poly)
    this._buildRoof(poly);
    // Generate pergola columns where overhang from anchor edge > 1.6m
    this._buildColumns(poly);
  },
_roofYatXZ(x, z){
    var px = x - this._roofAnchorAx, pz = z - this._roofAnchorAz;
    var perpDist = px * this._roofAnchorNx + pz * this._roofAnchorNz;
    if(perpDist < 0) perpDist = 0;
    return this._roofBaseY - perpDist * Math.tan((this._roofPitchDeg || 0) * Math.PI / 180);
  },

  _buildColumns(poly){
    if(this._roofBaseY === undefined) return;
    if(!this._basePoly || this._basePoly.length < 4) return;
    var COL_SPACING = (window.STATE && window.STATE.colSpacing) ? window.STATE.colSpacing : 3.000;
    var COL_SIZE = 0.200, OVERHANG_MIN = 1.600, SIDE_LONG = COL_SPACING, INSET = 0.200;
    // DEBUG: log edge lengths
    console.log('[F3-COL] polyN='+poly.length+' anchorIdx='+this._anchorIdx+' SIDE_LONG='+SIDE_LONG+' SPACING='+COL_SPACING);
    for(var di = 0; di < poly.length; di++){
      var dA = poly[di], dB = poly[(di+1)%poly.length];
      var ddx = dB.x-dA.x, ddz = dB.z-dA.z;
      var dlen = Math.sqrt(ddx*ddx+ddz*ddz);
      console.log('  edge['+di+'] len='+dlen.toFixed(2)+' from('+dA.x.toFixed(2)+','+dA.z.toFixed(2)+') to('+dB.x.toFixed(2)+','+dB.z.toFixed(2)+')');
    }
    var aA = {x: this._roofAnchorAx, z: this._roofAnchorAz};
    var aB = this._basePoly[1];  // anchor end
    var n = poly.length;
    var visualAnchorIdx = (this._anchorIdx - 1 + n) % n;
    // Centroid for inward normal direction
    var cx = 0, cz = 0;
    for(var k = 0; k < n; k++){cx += poly[k].x; cz += poly[k].z;}
    cx /= n; cz /= n;
    // distToSegment helper
    function distToSeg(pt, A, B){
      var dx = B.x - A.x, dz = B.z - A.z, len2 = dx*dx + dz*dz;
      if(len2 < 1e-6){
        var ddx = pt.x - A.x, ddz = pt.z - A.z;
        return Math.sqrt(ddx*ddx + ddz*ddz);
      }
      var t = Math.max(0, Math.min(1, ((pt.x-A.x)*dx + (pt.z-A.z)*dz) / len2));
      var pxx = A.x + t*dx, pzz = A.z + t*dz;
      return Math.sqrt((pt.x-pxx)*(pt.x-pxx) + (pt.z-pzz)*(pt.z-pzz));
    }
    // edge overhang = perpendicular distance from edge midpoint to anchor segment
    var edgeOH = [];
    for(var i = 0; i < n; i++){
      if(i === visualAnchorIdx){edgeOH.push(0); continue;}
      var A = poly[i], B = poly[(i+1)%n];
      var mid = {x: (A.x+B.x)/2, z: (A.z+B.z)/2};
      edgeOH.push(distToSeg(mid, aA, aB));
    }
    var positions = [], added = {};
    function addCol(x, z){
      var k = x.toFixed(4) + ',' + z.toFixed(4);
      if(!added[k]){added[k] = true; positions.push({x:x, z:z});}
    }
    // Corners: where BOTH adjacent edges are non-anchor AND at least one has overhang > min
    for(var i = 0; i < n; i++){
      var prevEdge = (i - 1 + n) % n;
      // Skip corners adjacent to anchor edge (those are held by the EXT wall)
      if(prevEdge === visualAnchorIdx || i === visualAnchorIdx) continue;
      if(edgeOH[prevEdge] > OVERHANG_MIN || edgeOH[i] > OVERHANG_MIN){
        // Inset corner toward centroid
        var P = poly[i];
        var dirX = cx - P.x, dirZ = cz - P.z;
        var dirL = Math.sqrt(dirX*dirX + dirZ*dirZ) || 1;
        addCol(P.x + (dirX/dirL)*INSET*Math.SQRT2, P.z + (dirZ/dirL)*INSET*Math.SQRT2);
      }
    }
    // Middle: long edges (non-anchor) get spaced columns regardless of edge overhang
    for(var i = 0; i < n; i++){
      if(i === visualAnchorIdx) continue;
      var A = poly[i], B = poly[(i+1)%n];
      var dx = B.x - A.x, dz = B.z - A.z, len = Math.sqrt(dx*dx + dz*dz);
      if(len <= SIDE_LONG) continue;
      var nx = -dz/len, nzv = dx/len;
      var midX = (A.x+B.x)/2, midZ = (A.z+B.z)/2;
      if(nx*(cx-midX) + nzv*(cz-midZ) < 0){nx = -nx; nzv = -nzv;}
      var num = Math.ceil(len / COL_SPACING);
      for(var kk = 1; kk < num; kk++){
        var t = kk / num;
        addCol(A.x + dx*t + nx*INSET, A.z + dz*t + nzv*INSET);
      }
    }
    if(!positions.length) return;
    // Build column meshes (sloped top following pergola roof)
    if(!Flat3DeckManager._colTex && window.THREE){
      try {
        var _t = new THREE.TextureLoader().load('https://cdn.shopify.com/s/files/1/0803/9815/6119/files/75016.jpg?v=1778397390');
        _t.colorSpace = THREE.SRGBColorSpace;
        _t.wrapS = _t.wrapT = THREE.RepeatWrapping;
        _t.repeat.set(1, 4);
        Flat3DeckManager._colTex = _t;
      } catch(e){ console.warn('[Flat3DeckManager] column texture load failed', e); }
    }
    var _colTex = Flat3DeckManager._colTex;
    var mat = new THREE.MeshStandardMaterial({
      color: _colTex ? 0xffffff : 0xfaf9f7,
      map: _colTex || null,
      roughness: 0.85, metalness: 0
    });
    var baseY = window.STATE.modelMinY || 0;
    var S2 = COL_SIZE / 2;
    var self = this;
    positions.forEach(function(pos){
      var corners = [[-S2,-S2], [S2,-S2], [S2,S2], [-S2,S2]];
      var topYs = corners.map(function(c){return self._roofYatXZ(pos.x + c[0], pos.z + c[1]);});
      var v = [];
      var uv = [];
      v.push(pos.x+corners[0][0], topYs[0], pos.z+corners[0][1], pos.x+corners[1][0], topYs[1], pos.z+corners[1][1], pos.x+corners[2][0], topYs[2], pos.z+corners[2][1]);
      uv.push(0,0, 1,0, 1,1);
      v.push(pos.x+corners[0][0], topYs[0], pos.z+corners[0][1], pos.x+corners[2][0], topYs[2], pos.z+corners[2][1], pos.x+corners[3][0], topYs[3], pos.z+corners[3][1]);
      uv.push(0,0, 1,1, 0,1);
      v.push(pos.x+corners[0][0], baseY, pos.z+corners[0][1], pos.x+corners[2][0], baseY, pos.z+corners[2][1], pos.x+corners[1][0], baseY, pos.z+corners[1][1]);
      uv.push(0,0, 1,1, 1,0);
      v.push(pos.x+corners[0][0], baseY, pos.z+corners[0][1], pos.x+corners[3][0], baseY, pos.z+corners[3][1], pos.x+corners[2][0], baseY, pos.z+corners[2][1]);
      uv.push(0,0, 0,1, 1,1);
      for(var s = 0; s < 4; s++){
        var c1 = corners[s], c2 = corners[(s+1)%4];
        var t1 = topYs[s], t2 = topYs[(s+1)%4];
        v.push(pos.x+c1[0], baseY, pos.z+c1[1], pos.x+c2[0], baseY, pos.z+c2[1], pos.x+c2[0], t2, pos.z+c2[1]);
        var avgTop = (t1+t2)/2, h = Math.max(0.001, avgTop - baseY);
        uv.push(0,0, 1,0, 1,(t2-baseY)/h);
        v.push(pos.x+c1[0], baseY, pos.z+c1[1], pos.x+c2[0], t2, pos.z+c2[1], pos.x+c1[0], t1, pos.z+c1[1]);
        uv.push(0,0, 1,(t2-baseY)/h, 0,(t1-baseY)/h);
      }
      var geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(v), 3));
      geo.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uv), 2));
      // Face groups: 0-5 top, 6-11 bottom (both gray), 12-35 sides (textured)
      geo.addGroup(0,6,0);
      geo.addGroup(6,6,0);
      geo.addGroup(12,24,1);
      geo.computeVertexNormals();
      var _grayCol = (window.CONFIG && window.CONFIG.meshColors && window.CONFIG.meshColors.ext) || '#a8a8a8';
      var _grayMat = new THREE.MeshStandardMaterial({color:new THREE.Color(_grayCol),roughness:0.85,metalness:0,polygonOffset:true,polygonOffsetFactor:-4,polygonOffsetUnits:-4});
      var mesh = new THREE.Mesh(geo, [_grayMat, mat]);
      mesh.castShadow = mesh.receiveShadow = true;
      mesh.userData = {isPergolaColumn: true};
      window.Engine.scene.add(mesh);
      self._meshes.push(mesh);
    });
  },
  _buildRoof(poly){
    if(this._roofBaseY === undefined || this._roofBaseY === null) return;
    var self = this;
    var tanP = Math.tan((this._roofPitchDeg || 0) * Math.PI / 180);
    // Y at each XZ point: anchor edge = baseY (highest), drops perpendicular by tan(pitch)
    function yAt(x, z){
      var px = x - self._roofAnchorAx, pz = z - self._roofAnchorAz;
      var perpDist = px * self._roofAnchorNx + pz * self._roofAnchorNz;
      if(perpDist < 0) perpDist = 0;
      return self._roofBaseY - perpDist * tanP;
    }
    var n = poly.length;
    var cx = poly.reduce(function(s,p){return s+p.x;}, 0) / n;
    var cz = poly.reduce(function(s,p){return s+p.z;}, 0) / n;
    var cyTop = yAt(cx, cz);
    var THICK = this.THICK;
    var allV = [], allUV = [];
    function pushV(x,y,z){allV.push(x,y,z); allUV.push(x,z);}
    for(var i = 0; i < n; i++){
      var A = poly[i], B = poly[(i+1)%n];
      var yAtop = yAt(A.x, A.z), yBtop = yAt(B.x, B.z);
      var yAbot = yAtop - THICK, yBbot = yBtop - THICK, cyBot = cyTop - THICK;
      // Top face (sloped)
      pushV(cx, cyTop, cz); pushV(A.x, yAtop, A.z); pushV(B.x, yBtop, B.z);
      // Bottom face (sloped, parallel to top)
      pushV(cx, cyBot, cz); pushV(B.x, yBbot, B.z); pushV(A.x, yAbot, A.z);
      // Side quad (2 triangles)
      pushV(A.x, yAtop, A.z); pushV(B.x, yBtop, B.z); pushV(B.x, yBbot, B.z);
      pushV(A.x, yAtop, A.z); pushV(B.x, yBbot, B.z); pushV(A.x, yAbot, A.z);
    }
    var geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(allV), 3));
    geo.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(allUV), 2));
    geo.computeVertexNormals();
    var mat = (window.SceneMaterials && window.SceneMaterials._make) ? window.SceneMaterials._make('roof') : new THREE.MeshStandardMaterial({color: 0xf5f5f0, roughness: 0.85, metalness: 0});
    var mesh = new THREE.Mesh(geo, mat);
    mesh.castShadow = mesh.receiveShadow = true;
    mesh.userData = {isPergolaRoof: true, isRoofFace: true};
    mesh.visible = (window.STATE.view !== '2d-top');
    window.Engine.scene.add(mesh);
    this._meshes.push(mesh);
  },
bindDrag(){
    var _d = document.getElementById('cv5-rb-debug');
    if(_d) _d.textContent += '[F3-DRAG] bindDrag called bound='+this._bound+'\n';
    if(this._bound) return;
    this._bound = true;
    var self = this, cv = document.getElementById('cv5-canvas');
    if(!cv){if(_d)_d.textContent+='[F3-DRAG] NO CANVAS!\n'; return;}
    var HIT = 22;
    if(_d) _d.textContent += '[F3-DRAG] init OK, canvas found\n';
    if(!this._label){
      var lbl = document.createElement('div');
      lbl.style.cssText = 'position:absolute;background:#3a8d4d;color:#fff;font:700 11px monospace;padding:3px 8px;border-radius:6px;pointer-events:none;display:none;z-index:500;transform:translate(-50%,-130%);';
      (document.getElementById('cv5-root') || document.body).appendChild(lbl);
      this._label = lbl;
    }
    function planY(){return (window.STATE.modelMinY||0) + self.THICK + 0.012;}
    function getEdges(){
      var poly = self._currentPoly;
      var _dd = document.getElementById('cv5-rb-debug');
      if(!poly){if(_dd)_dd.textContent+='[F3-DRAG] getEdges: NO POLY\n'; return [];}
      if(!window.Engine){if(_dd)_dd.textContent+='[F3-DRAG] getEdges: NO ENGINE\n'; return [];}
      var cx = 0, cz = 0;
      for(var k = 0; k < poly.length; k++){cx += poly[k].x; cz += poly[k].z;}
      cx /= poly.length; cz /= poly.length;
      var out = [];
      // Visual anchor edge in exp poly is at index (anchorIdx-1+n)%n due to _applyOffsets vertex rotation
      var visualAnchorIdx = (self._anchorIdx - 1 + poly.length) % poly.length;
      for(var i = 0; i < poly.length; i++){
        // Skip the visually-anchor edge - not draggable (fixed at EXT outer face)
        if(i === visualAnchorIdx) continue;
        var A = poly[i], B = poly[(i+1)%poly.length];
        var sA = window.Engine.toScreen(new THREE.Vector3(A.x, planY(), A.z));
        var sB = window.Engine.toScreen(new THREE.Vector3(B.x, planY(), B.z));
        var dx = B.x - A.x, dz = B.z - A.z, len = Math.sqrt(dx*dx + dz*dz) || 1;
        var nx = -dz/len, nz = dx/len;
        var midX = (A.x+B.x)/2, midZ = (A.z+B.z)/2;
        if(nx*(midX-cx) + nz*(midZ-cz) < 0){nx = -nx; nz = -nz;}
        out.push({idx:i, sA:sA, sB:sB, mx:(sA.x+sB.x)/2, my:(sA.y+sB.y)/2, nx:nx, nz:nz});
      }
      if(_dd && Math.random()<0.05) _dd.textContent+='[F3-DRAG] getEdges: '+out.length+' edges (anchorIdx='+self._anchorIdx+', polyN='+poly.length+')\n';
      return out;
    }
    function ptSegDist(px, py, ax, ay, bx, by){
      var dx = bx-ax, dy = by-ay, len2 = dx*dx + dy*dy;
      if(len2 < 0.001) return Math.sqrt((px-ax)*(px-ax) + (py-ay)*(py-ay));
      var t = Math.max(0, Math.min(1, ((px-ax)*dx + (py-ay)*dy)/len2));
      return Math.sqrt((px-(ax+t*dx))*(px-(ax+t*dx)) + (py-(ay+t*dy))*(py-(ay+t*dy)));
    }
    function findEdge(ex, ey, edges){
      var best = null, bestD = HIT;
      var allDists = [];
      for(var i = 0; i < edges.length; i++){
        var e = edges[i];
        var d = ptSegDist(ex, ey, e.sA.x, e.sA.y, e.sB.x, e.sB.y);
        allDists.push('e'+e.idx+':'+d.toFixed(0));
        if(d < bestD){bestD = d; best = e;}
      }
      var _dde = document.getElementById('cv5-rb-debug');
      if(_dde && Math.random()<0.02){
        _dde.textContent += '[F3-DRAG] findEdge pt=('+ex.toFixed(0)+','+ey.toFixed(0)+') best='+(best?'e'+best.idx+'@'+bestD.toFixed(0):'NONE')+' all=['+allDists.join(',')+']\n';
      }
      return best;
    }
    function evPt(e){var r = cv.getBoundingClientRect(); return {x:e.clientX-r.left, y:e.clientY-r.top};}
    function worldAt(e){
      var r = cv.getBoundingClientRect();
      var nx2 = ((e.clientX-r.left)/r.width)*2-1, ny2 = -((e.clientY-r.top)/r.height)*2+1;
      var v = new THREE.Vector3(nx2, ny2, 0.5).unproject(window.Engine.orthoCamera);
      return {x:v.x, z:v.z};
    }
    cv.addEventListener('pointermove', function(e){
      if(window.STATE.view !== '2d-top' || self._drag) return;
      var pt = evPt(e), hit = findEdge(pt.x, pt.y, getEdges());
      if(hit) cv.style.cursor = 'ns-resize';
    }, true);
    cv.addEventListener('pointerdown', function(e){
      if(window.STATE.view !== '2d-top' || window.STATE.isDragging) return;
      var pt = evPt(e), edges = getEdges(), hit = findEdge(pt.x, pt.y, edges);
      if(!hit) return;
      e.stopPropagation();
      var w = worldAt(e);
      var _oidx = (hit.idx+1) % self._offsets.length;
      self._drag = {idx:hit.idx, oidx:_oidx, nx:hit.nx, nz:hit.nz, startW:w, startOff:self._offsets[_oidx] || 0, mx:hit.mx, my:hit.my};
      window.Engine.orthoControls.enabled = false;
      try{cv.setPointerCapture(e.pointerId);}catch(ex){}
    }, true);
    cv.addEventListener('pointermove', function(e){
      if(!self._drag) return;
      e.stopPropagation();
      var d = self._drag, w = worldAt(e);
      var delta = (w.x-d.startW.x)*d.nx + (w.z-d.startW.z)*d.nz;
      var _isMetric=window.STATE?window.STATE.isMetric!==false:true;
      var _snapMm=_isMetric?(window.CONFIG&&window.CONFIG.overhangStepMm?window.CONFIG.overhangStepMm:50):(window.CONFIG&&window.CONFIG.overhangStepInch?window.CONFIG.overhangStepInch*25.4:50.8);
      var _snapM=_snapMm/1000;
      var rawOff=d.startOff+delta;
      var snappedOff=Math.round(rawOff/_snapM)*_snapM;
      var newOff = Math.max(-self.MAX_OH, Math.min(self.MAX_OH, snappedOff));
      self._offsets[d.oidx] = newOff;
      self._rebuild();
      if(self._label){
        var _totalM=self.OVERHANG+newOff;
        self._label.textContent = _isMetric?Math.round(_totalM*1000)+' mm':(_totalM*39.3701).toFixed(1)+' in';
        self._label.style.display = 'block';
        self._label.style.left = d.mx + 'px';
        self._label.style.top = d.my + 'px';
      }
    }, true);
    cv.addEventListener('pointerup', function(e){
      if(!self._drag) return;
      self._drag = null;
      window.Engine.orthoControls.enabled = true;
      cv.style.cursor = '';
      if(self._label) self._label.style.display = 'none';
    }, true);
  },

  _rebuild(){
    if(!this._basePoly || this._basePoly.length < 3) return;
    var n = this._basePoly.length;
    if(this._offsets.length !== n) this._offsets = new Array(n).fill(0);
    for(var k = 0; k < n; k++){
      if(this._offsets[k] < -this.MAX_OH) this._offsets[k] = -this.MAX_OH;
      if(this._offsets[k] > this.MAX_OH) this._offsets[k] = this.MAX_OH;
    }
    var exp = this._applyOffsets(this._basePoly, this._offsets);
    if(!exp || exp.length < 3) return;
    this._meshes.forEach(function(m){window.Engine.scene.remove(m);});
    this._meshes = [];
    this._currentPoly = exp;
    this._buildDeck(exp);
  },
  onExtChanged(){this.run();},

  _clear(){
    this._meshes.forEach(function(m){if(window.Engine) window.Engine.scene.remove(m);});
    this._meshes = [];
  }
};
window.Flat3DeckManager = Flat3DeckManager;
window.DeckManager = DeckManager;
window.SaunaManager = {
  _meshes: [], _heaterMeshes: [], _btnEl: null, _layoutIdxMap: {},
  PLANK_W:0.050, GAP:0.020, BENCH_H_LO:0.450, BENCH_H_HI:0.900, HEATER_W:0.400,
  LAYOUTS:['straight-single','straight-double','L-single','L-double','U-single','U-double','II-single','II-half','II-double'],

  run(opts) {
    const _forceRebuild = opts && opts.forceRebuild;
    this._clearBenches();
    if(_forceRebuild){
      // Layout change / rotation — full rebuild including heater + person
      this._heaterMeshes.forEach(m=>window.Engine.scene.remove(m));
      if(window.FitoutManager&&window.FitoutManager._items){
        window.FitoutManager._items=window.FitoutManager._items.filter(it=>!it.obj?.userData?.isSaunaHeater);
      }
      this._heaterMeshes=[];
      this._personPending={};
      this._lastCentroid={};
    }
    // Use FloorParser._meshes (live room floor meshes) — updated on every drag
    let handled=false;
    if(typeof FloorParser!=='undefined'&&FloorParser._meshes?.length){
      const _seenFl=new Set();
        const sm=FloorParser._meshes.filter(m=>{
          const rn=(m.userData.roomName||'').toUpperCase();
          if(rn!=='SAUNA') return false;
          const fl=m.userData.floorNum||1;
          if(_seenFl.has(fl)) return false;
          _seenFl.add(fl);
          return true;
        });
      if(sm.length){
        sm.forEach(m=>{
          const fl=m.userData.floorNum||1;
          if(this._layoutIdxMap[fl]===undefined)this._layoutIdxMap[fl]=0;
          m.updateMatrixWorld(true);
          const bb=new THREE.Box3().setFromObject(m);
          if(!bb.isEmpty()&&bb.max.x-bb.min.x>0.1&&bb.max.z-bb.min.z>0.1){
            const _rot2=(this._rotationMap||{})[fl]||0;
            const _cnt2=this._meshes.length;
            // For rotations 90°/270° (odd steps) swap X and Z extents around centre
            // so _buildLayout receives the post-rotation room dimensions.
            const _cx2=(bb.min.x+bb.max.x)/2, _cz2=(bb.min.z+bb.max.z)/2;
            const _hx2=(bb.max.x-bb.min.x)/2,  _hz2=(bb.max.z-bb.min.z)/2;
            const _odd2=_rot2%2===1;
            const _bx1=_cx2-(_odd2?_hz2:_hx2), _bx2=_cx2+(_odd2?_hz2:_hx2);
            const _bz1=_cz2-(_odd2?_hx2:_hz2), _bz2=_cz2+(_odd2?_hx2:_hz2);
            this._buildLayout(_bx1,_bx2,_bz1,_bz2,bb.min.y,fl,this._layoutIdxMap[fl]);
            if(_rot2>0){
              const _cos2=Math.cos(_rot2*Math.PI/2), _sin2=Math.sin(_rot2*Math.PI/2);
              this._meshes.slice(_cnt2).forEach(m=>{
                const dx=m.position.x-_cx2, dz=m.position.z-_cz2;
                m.position.x=_cx2+dx*_cos2-dz*_sin2;
                m.position.z=_cz2+dx*_sin2+dz*_cos2;
                m.rotation.y=_rot2*Math.PI/2;
              });
            }
          }
        });
        handled=true;
      }
    }
    if(!handled)(window.STATE.elements.floors||[]).filter(f=>f.name.toUpperCase().includes('SAUNA')).forEach(f=>{
      const fl=floorNum(f.name); if(this._layoutIdxMap[fl]===undefined)this._layoutIdxMap[fl]=0;
      f.updateMatrixWorld(true); const bb=new THREE.Box3().setFromObject(f);
      const _rot=(this._rotationMap||{})[fl]||0;
      const _cntBefore=this._meshes.length;
      // For rotations 90°/270° (odd steps) swap X and Z extents around centre
      const _cx=(bb.min.x+bb.max.x)/2, _cz=(bb.min.z+bb.max.z)/2;
      const _hx=(bb.max.x-bb.min.x)/2,  _hz=(bb.max.z-bb.min.z)/2;
      const _odd=_rot%2===1;
      const _bx1=_cx-(_odd?_hz:_hx), _bx2=_cx+(_odd?_hz:_hx);
      const _bz1=_cz-(_odd?_hx:_hz), _bz2=_cz+(_odd?_hx:_hz);
      this._buildLayout(_bx1,_bx2,_bz1,_bz2,bb.min.y,fl,this._layoutIdxMap[fl]);
      if(_rot>0){
        const _cos=Math.cos(_rot*Math.PI/2), _sin=Math.sin(_rot*Math.PI/2);
        this._meshes.slice(_cntBefore).forEach(m=>{
          const dx=m.position.x-_cx, dz=m.position.z-_cz;
          m.position.x=_cx+dx*_cos-dz*_sin;
          m.position.z=_cz+dx*_sin+dz*_cos;
          m.rotation.y=_rot*Math.PI/2;
        });
      }
    });
    this._showBtn();
  },
  
  _clearBenches() { this._meshes.forEach(m=>window.Engine.scene.remove(m)); this._meshes=[]; },
  clearAll() { this._clearBenches(); this._heaterMeshes.forEach(m=>window.Engine.scene.remove(m)); this._heaterMeshes=[]; },

  _addMesh(geo,mat,x,y,z){ const m=new THREE.Mesh(geo,mat); m.position.set(x,y,z); m.castShadow=true; m.receiveShadow=true; m.userData={isSaunaFurniture:true}; window.Engine.scene.add(m); this._meshes.push(m); return m; },

  _buildForRoom(room, li) {
    if(!room.mesh) return;
    // Use world-space bbox — works for both EXT and INT drag
    room.mesh.updateMatrixWorld(true);
    const bb = new THREE.Box3().setFromObject(room.mesh);
    if(bb.isEmpty()) return;
    const x1=bb.min.x, x2=bb.max.x, z1=bb.min.z, z2=bb.max.z, baseY=bb.min.y;
    if(x2-x1<0.1||z2-z1<0.1)return;
    this._buildLayout(x1,x2,z1,z2,baseY,room.fl,li);
  },

  _buildLayout(x1,x2,z1,z2,baseY,fl,li) {
    const cx=(x1+x2)/2, cz=(z1+z2)/2;
    const WG=0.05, D=0.55, PW=this.PLANK_W, G=this.GAP;
    const PH=this.BENCH_H_HI, PL=this.BENCH_H_LO;
    const layout=this.LAYOUTS[li%this.LAYOUTS.length];

    // Detect door side from virtualOpenings
    const vos=window.STATE.virtualOpenings||[];
    const dv=vos.find(v=>(v.type==='idr'||v.type==='edr')&&v.fl===fl);
    const wv=vos.find(v=>v.type==='win'&&v.fl===fl);

    const closestSide=(mx,mz)=>{
      const d={minX:Math.abs(mx-x1),maxX:Math.abs(mx-x2),minZ:Math.abs(mz-z1),maxZ:Math.abs(mz-z2)};
      return Object.keys(d).reduce((a,b)=>d[a]<d[b]?a:b);
    };
    const opp={minZ:'maxZ',maxZ:'minZ',minX:'maxX',maxX:'minX'};
    const sides=['minZ','minX','maxZ','maxX'];

    let doorSide='minZ';
    if(dv){ const A=dv.A||{x:cx,z:z1},B=dv.B||{x:cx,z:z1}; doorSide=closestSide((A.x+B.x)/2,(A.z+B.z)/2); }

    let benchSide=opp[doorSide];
    if(wv){ const A=wv.A||{x:cx,z:z1},B=wv.B||{x:cx,z:z1}; benchSide=opp[closestSide((A.x+B.x)/2,(A.z+B.z)/2)]; }

    // rot handled by mesh rotation in run() — benchSide stays at rot=0

    // benchSide = wall where main bench goes
    // isZbench = bench wall is minZ or maxZ (bench runs along X)
    const isZbench = benchSide==='minZ'||benchSide==='maxZ';

    // Far wall coordinate (where bench is attached)
    const farW = benchSide==='minZ'?z1 : benchSide==='maxZ'?z2 : benchSide==='minX'?x1 : x2;
    // Direction from far wall inward
    const inDir = (benchSide==='maxZ'||benchSide==='maxX') ? -1 : 1;

    // Door wall coordinate
    const doorW = doorSide==='minZ'?z1 : doorSide==='maxZ'?z2 : doorSide==='minX'?x1 : x2;
    const doorInDir = -inDir;

    // Main bench: runs along far wall
    // If isZbench: along X from x1+WG to x2-WG, perp coord Z near farW
    const mRa = isZbench ? x1+WG : z1+WG;
    const mRb = isZbench ? x2-WG : z2-WG;
    const hiZ = farW + inDir*(WG+D/2);        // upper bench center (at wall)
    const loZ = farW + inDir*(WG+D+WG+D/2);   // lower bench center (in front)

    // Short side benches (L/U): run perpendicular from door wall to just before main bench
    // Along the axis perpendicular to main bench
    const sRa = isZbench ? z1+WG : x1+WG;
    const sRb_hi = isZbench ? (farW+inDir*WG) : (farW+inDir*WG);  // stop at main bench
    const sRb_lo = isZbench ? (farW+inDir*(WG+D+WG)) : (farW+inDir*(WG+D+WG));
    const sRa_real = Math.min(sRa, isZbench?(doorW+Math.sign(inDir)*(-1)*WG):(doorW+Math.sign(inDir)*(-1)*WG));
    // Simple: short bench from door wall to main bench
    // oppBenchSide = wall opposite to bench wall = where short benches end
    const oppBenchSide = {minZ:'maxZ',maxZ:'minZ',minX:'maxX',maxX:'minX'}[benchSide];
    // doorWperp = coord of opposite wall (in same axis as farW)
    const doorWperp = isZbench
      ? (oppBenchSide==='minZ'?z1 : z2)
      : (oppBenchSide==='minX'?x1 : x2);
    const doorInward = isZbench
      ? (oppBenchSide==='minZ'?1 : -1)
      : (oppBenchSide==='minX'?1 : -1);
    // Short bench: from door wall to just before main bench (in perpendicular axis)
    // doorWperp is the coord of door wall in same axis as farW
    const shortStart = doorWperp + doorInward*WG;
    const shortEnd_hi = farW + inDir*(WG+D);       // edge of upper main bench
    const shortEnd_lo = farW + inDir*(WG+D+WG+D);  // edge of lower main bench
    const sA=Math.min(shortStart,shortEnd_hi), sB=Math.max(shortStart,shortEnd_hi);
    // Lower short bench: same range as upper short bench (sA..sB)
    // Lower main bench covers the rest — no overlap needed
    const sA2=sA, sB2=sB;

    // Perp coords for side walls (for L/U short sides)
    const sideLoX = isZbench ? x1+WG+D/2 : z1+WG+D/2;
    const sideHiX = isZbench ? x2-WG-D/2 : z2-WG-D/2;

    const mkMain=(perpZ,h,t)=>{
      if(isZbench) this._planks(mRa,mRb,baseY,perpZ,D,h,'x',t);
      else         this._planks(mRa,mRb,baseY,perpZ,D,h,'z',t);
    };
    const mkShort=(perpX,h,t,rA,rB)=>{
      const ra=Math.min(rA,rB), rb=Math.max(rA,rB);
      if(rb-ra<0.1)return;
      if(isZbench) this._planks(ra,rb,baseY,perpX,D,h,'z',t);
      else         this._planks(ra,rb,baseY,perpX,D,h,'x',t);
    };

    // II benches: opposite wall (door wall side)
    const mkDoorBench=(perpZ,h,t)=>{
      if(isZbench) this._planks(mRa,mRb,baseY,perpZ,D,h,'x',t);
      else         this._planks(mRa,mRb,baseY,perpZ,D,h,'z',t);
    };
    // doorInDir must point INWARD from door wall (opposite of door wall's outward normal)
    // For II benches: door bench is on the wall OPPOSITE to bench wall
    // opp[benchSide] = doorSide effectively, so use opp[benchSide] coords
    const dHi=doorWperp+doorInward*(WG+D/2);
    const dLo=doorWperp+doorInward*(WG+D+WG+D/2);

    // Range for lower short bench (stops before lower main bench)
    // Lower short stops before lower main AND before upper main
    // Lower short ends at near edge of lower main (toward door)
    const loShortEnd = inDir<0 ? Math.min(sB, loZ-D/2-WG) : Math.max(sA, loZ+D/2+WG);
    switch(layout){
      case 'straight-single': mkMain(hiZ,PH,1); break;
      case 'straight-double': mkMain(hiZ,PH,1); mkMain(loZ,PL,0); break;
      case 'L-single':
        mkMain(hiZ,PH,1);
        mkShort(sideLoX,PH,1,sA,sB); break;
      case 'L-double':{
        mkMain(hiZ,PH,1);
        // Short side: isZbench→sideLoX, !isZbench→sideHiX (toward center)
        const _lSide = isZbench ? sideLoX : sideHiX;
        const _lStep = isZbench ? (D+WG) : -(D+WG);
        // Lower main clipped by upper short bench (clip from _lSide direction)
        const _loMainA2 = _lStep>0 ? (_lSide+D/2+WG) : mRa;
        const _loMainB2 = _lStep>0 ? mRb : (_lSide-D/2-WG);
        if(isZbench&&_loMainB2-_loMainA2>0.05) this._planks(_loMainA2,_loMainB2,baseY,loZ,D,PL,'x',0);
        else if(!isZbench&&_loMainB2-_loMainA2>0.05) this._planks(_loMainA2,_loMainB2,baseY,loZ,D,PL,'z',0);
        mkShort(_lSide, PH,1,sA,sB);
        const _loRA=inDir<0?sA:loShortEnd, _loRB=inDir<0?loShortEnd:sB;
        mkShort(_lSide+_lStep, PL,0,Math.min(_loRA,_loRB),Math.max(_loRA,_loRB));
        break;}
      case 'U-single':
        mkMain(hiZ,PH,1);
        mkShort(sideLoX,PH,1,sA,sB); mkShort(sideHiX,PH,1,sA,sB); break;
      case 'U-double':{
        mkMain(hiZ,PH,1);
        // Lower main clipped by upper short benches
        const loMainA2=sideLoX+D/2+WG, loMainB2=sideHiX-D/2-WG;
        if(isZbench) this._planks(loMainA2,loMainB2,baseY,loZ,D,PL,'x',0);
        else         this._planks(loMainA2,loMainB2,baseY,loZ,D,PL,'z',0);
        mkShort(sideLoX,       PH,1,sA,sB);
        mkShort(sideHiX,       PH,1,sA,sB);
        const _uRA=inDir<0?sA:loShortEnd, _uRB=inDir<0?loShortEnd:sB;
        mkShort(sideLoX+(D+WG),PL,0,Math.min(_uRA,_uRB),Math.max(_uRA,_uRB));
        mkShort(sideHiX-(D+WG),PL,0,Math.min(_uRA,_uRB),Math.max(_uRA,_uRB));
        break;}
      case 'II-single':
        mkMain(hiZ,PH,1); mkDoorBench(dHi,PH,1); break;
      case 'II-half':
        mkMain(hiZ,PH,1); mkMain(loZ,PL,0); mkDoorBench(dHi,PH,1); break;
      case 'II-double':
        mkMain(hiZ,PH,1); mkMain(loZ,PL,0); mkDoorBench(dHi,PH,1); mkDoorBench(dLo,PL,0); break;
    }

    // Heater: build once, then track room centroid delta (preserve user-placed position)
    this._lastCentroid=this._lastCentroid||{};
    const _last=this._lastCentroid[fl];
    const _existHeater=this._heaterMeshes.find(m=>m.userData.saunaFl===fl&&!m.userData.saunaPerson);
    if(!_existHeater){
      this._buildHeater(cx,baseY,cz,fl);
    } else if(_last){
      const _dx=cx-_last.cx, _dz=cz-_last.cz;
      if(Math.abs(_dx)>0.0001||Math.abs(_dz)>0.0001){
        _existHeater.position.x+=_dx;
        _existHeater.position.z+=_dz;
      }
    }

    // Lying person on upper bench for scale reference (preserve user position too)
    const _existPerson=this._heaterMeshes.find(m=>m.userData.saunaPerson&&m.userData.saunaFl===fl);
    if(_existPerson&&_last){
      const _dx2=cx-_last.cx, _dz2=cz-_last.cz;
      if(Math.abs(_dx2)>0.0001||Math.abs(_dz2)>0.0001){
        _existPerson.position.x+=_dx2;
        _existPerson.position.z+=_dz2;
      }
    }
    this._lastCentroid[fl]={cx,cz};
    if(!_existPerson){
      const _benchTopY=baseY+this.BENCH_H_HI;
      const _farW=benchSide==='minZ'?z1:benchSide==='maxZ'?z2:benchSide==='minX'?x1:x2;
      const _inDir2=(benchSide==='maxZ'||benchSide==='maxX')?-1:1;
      const _isZb=benchSide==='minZ'||benchSide==='maxZ';
      const _D=0.55;
      const _personPerp=_farW+_inDir2*(0.05+_D/2);
      const _benchAlongCenter=_isZb?(x1+x2)/2:(z1+z2)/2;
      this._buildPerson(_isZb?_benchAlongCenter:_personPerp, _benchTopY, _isZb?_personPerp:_benchAlongCenter, _isZb, fl);
    }

    // Button position: inside room, away from corner
    this._btnPos = { x:x1+(x2-x1)*0.2, y:baseY+0.01, z:z1+(z2-z1)*0.2, fl };
  },

  _planks(rA,rB,baseY,centerPerp,depth,benchH,axis,tier){
    const PW=this.PLANK_W,G=this.GAP;
    const mat=new THREE.MeshStandardMaterial({color:tier?0x4a2c1a:0x7a4a2a,roughness:0.85,metalness:0});
    const len=Math.abs(rB-rA); if(len<0.05)return;
    const n=Math.max(1,Math.floor(depth/(PW+G)));
    const start=centerPerp-n*(PW+G)/2+G/2;
    for(let i=0;i<n;i++){
      const p=start+i*(PW+G)+PW/2;
      if(axis==='x') this._addMesh(new THREE.BoxGeometry(len,PW,PW),mat,(rA+rB)/2,baseY+benchH-PW/2,p);
      else           this._addMesh(new THREE.BoxGeometry(PW,PW,len),mat,p,baseY+benchH-PW/2,(rA+rB)/2);
    }
  },

  _buildHeater(hx,baseY,hz,fl){
    const sm=new THREE.MeshStandardMaterial({color:0x777777,roughness:0.95,metalness:0});
    const hm=new THREE.MeshStandardMaterial({color:0x1a1a1a,roughness:0.6,metalness:0.5});
    const HW=this.HEATER_W;
    const g=new THREE.Group(); g.userData={isFitout:true,isSaunaHeater:true,saunaFl:fl,fitoutName:'Sauna Heater'};
    const add=(geo,mat,x,y,z)=>{ const m=new THREE.Mesh(geo,mat); m.position.set(x,y,z); m.castShadow=true; m.receiveShadow=true; m.userData={isFitout:true,isSaunaHeater:true,saunaFl:fl}; g.add(m); };
    add(new THREE.BoxGeometry(HW,0.20,HW),sm,0,baseY+0.10,0);
    add(new THREE.BoxGeometry(HW-0.04,0.50,HW-0.04),hm,0,baseY+0.45,0);
    for(let si=-1;si<=1;si++)for(let sj=-1;sj<=1;sj++) add(new THREE.BoxGeometry(0.07,0.05,0.07),sm,si*0.10,baseY+0.72,sj*0.10);
    g.position.set(hx,0,hz); window.Engine.scene.add(g); this._heaterMeshes.push(g);
    if(window.FitoutManager) window.FitoutManager._items.push({obj:g,item:{name:'Sauna Heater',id:'sauna_heater_'+fl,widthM:HW,depthM:HW}});
  },

  _personTexCache: null,
  _ensurePersonTexture(cb){
    if(this._personTexCache){cb(this._personTexCache);return;}
    const url='https://cdn.shopify.com/s/files/1/0803/9815/6119/files/standing-human-body-silhouette-svgrepo-com.svg?v=1778222740';
    const img=new Image(); img.crossOrigin='anonymous';
    img.onload=()=>{
      const W=256, ratio=img.naturalWidth/img.naturalHeight||0.31;
      const H=Math.round(W/ratio);
      const cv=document.createElement('canvas'); cv.width=W; cv.height=H;
      const ctx=cv.getContext('2d');
      // Draw silhouette
      ctx.drawImage(img,0,0,W,H);
      // Invert luminance: dark silhouette → white, transparent stays transparent
      const id=ctx.getImageData(0,0,W,H), d=id.data;
      for(let i=0;i<d.length;i+=4){
        if(d[i+3]>10){ d[i]=255; d[i+1]=255; d[i+2]=255; }
      }
      ctx.putImageData(id,0,0);
      const tex=new THREE.CanvasTexture(cv);
      tex.colorSpace=THREE.SRGBColorSpace;
      tex.minFilter=THREE.LinearFilter;
      tex.magFilter=THREE.LinearFilter;
      this._personTexCache={tex,ratio};
      cb(this._personTexCache);
    };
    img.onerror=(e)=>{ console.warn('[SaunaManager] person SVG load failed',e); };
    img.src=url;
  },
  _personPending: {},
  _buildPerson(px,topY,pz,alongX,fl){
    if(this._personPending[fl]) return;
    if(this._heaterMeshes.find(m=>m.userData.saunaPerson&&m.userData.saunaFl===fl)) return;
    this._personPending[fl]=true;
    this._ensurePersonTexture(({tex,ratio})=>{
      this._personPending[fl]=false;
      // re-check after async — clear could have run while waiting
      if(this._heaterMeshes.find(m=>m.userData.saunaPerson&&m.userData.saunaFl===fl)) return;
      // Lying person: long side = 2.1 m (height)
      const longM=1.8;
      const shortM=longM*ratio;  // ~0.65 m wide
      const geo=new THREE.PlaneGeometry(shortM,longM);
      geo.rotateX(-Math.PI/2);   // lay flat on bench top
      const mat=new THREE.MeshBasicMaterial({map:tex,transparent:true,alphaTest:0.05,depthWrite:false,side:THREE.DoubleSide});
      const m=new THREE.Mesh(geo,mat);
      m.position.set(px,topY+0.005,pz);
      m.renderOrder=6;
      if(alongX) m.rotation.y=Math.PI/2;
      const _isMetric=window.STATE?window.STATE.isMetric!==false:true;
      const _label=_isMetric?'Person (1.8 m)':'Person ('+Math.floor(longM*39.3701/12)+'\''+Math.round(longM*39.3701%12)+'")';
      m.userData={isFitout:true,isSaunaHeater:true,saunaPerson:true,saunaFl:fl,fitoutName:_label};
      window.Engine.scene.add(m);
      this._heaterMeshes.push(m);
      if(window.FitoutManager) window.FitoutManager._items.push({obj:m,item:{name:_label,id:'sauna_person_'+fl,widthM:shortM,depthM:longM}});
    });
  },

  _rotationMap: {}, // fl -> 0,1,2,3 (×90°)

  _showBtn(){
    if(!this._btnPos) return;
    if(!this._btnEl){
      const root=document.getElementById('cv5-root'); if(!root)return;
      const wrap=document.createElement('div');
      wrap.id='cv5-sauna-btns';
      wrap.style.cssText='position:absolute;pointer-events:none;z-index:500;width:92px;height:40px;';

      // Rotate button (red bg, white icon)
      const rot=document.createElement('div');
      rot.style.cssText='position:absolute;left:0;top:0;pointer-events:auto;cursor:pointer;background:#D3212D;border-radius:50%;width:40px;height:40px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.5);user-select:none;';
      rot.innerHTML='<img src="https://cdn.shopify.com/s/files/1/0803/9815/6119/files/rotate.png?v=1772400640" width="22" height="22" style="filter:brightness(0) invert(1)">';
      rot.title='Rotate layout 90°';
      rot.addEventListener('pointerdown',e=>{
        e.stopPropagation();
        const fl=this._btnPos?.fl||1;
        this._rotationMap[fl]=((this._rotationMap[fl]||0)+1)%4;
        this.run();
      });

      // Plus button (white bg, red plus)
      const plus=document.createElement('div');
      plus.style.cssText='position:absolute;left:46px;top:0;pointer-events:auto;cursor:pointer;background:#fff;border-radius:50%;width:40px;height:40px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.5);user-select:none;';
      plus.innerHTML='<svg width="20" height="20" viewBox="0 0 20 20"><line x1="10" y1="3" x2="10" y2="17" stroke="#D3212D" stroke-width="2.5" stroke-linecap="round"/><line x1="3" y1="10" x2="17" y2="10" stroke="#D3212D" stroke-width="2.5" stroke-linecap="round"/></svg>';
      plus.title='Next bench layout';
      plus.addEventListener('pointerdown',e=>{
        e.stopPropagation();
        const fl=this._btnPos?.fl||1;
        this._layoutIdxMap[fl]=((this._layoutIdxMap[fl]||0)+1)%this.LAYOUTS.length;
        this.run();
      });

      // Layout label
      const lbl=document.createElement('div');
      lbl.id='cv5-sauna-lbl';
      lbl.style.cssText='position:absolute;left:96px;top:50%;transform:translateY(-50%);background:rgba(0,0,0,0.7);color:#fff;font:bold 11px/1 sans-serif;border-radius:8px;padding:4px 8px;pointer-events:none;white-space:nowrap;';
      wrap.appendChild(rot);
      wrap.appendChild(plus);
      wrap.appendChild(lbl);
      root.appendChild(wrap);
      this._btnEl=wrap;
    }
    this._repositionBtn();
  },

  _repositionBtn(){
    if(!this._btnEl||!this._btnPos) return;
    const {x,y,z}=this._btnPos;
    if(window.STATE.view!=='2d-top'){this._btnEl.style.display='none';return;}
    const sp=window.Engine.toScreen(new THREE.Vector3(x,y,z));
    this._btnEl.style.left=(Math.round(sp.x)-0)+'px';
    this._btnEl.style.top=(Math.round(sp.y)-20)+'px';
    this._btnEl.style.display='flex';
    const _lbl=document.getElementById('cv5-sauna-lbl');
    if(_lbl){const fl=this._btnPos?.fl||1;const li=(this._layoutIdxMap[fl]||0)%this.LAYOUTS.length;const names=['Straight','Straight 2','L','L 2','U','U 2','II 2','II 3','II 4'];_lbl.textContent=names[li]||'';}
  },

  initDrag(){}
};

// ── SceneMaterials moved from cfg.liquid (size budget) ──
window.SceneMaterials = {
  // Cached texture loader — load each texture once, reuse across all meshes
  _texCache: {},
  _getTex(url, scale) {
    if (!url || !window.THREE) return null;
    // Normalize protocol-relative URLs (//cdn.shopify.com/...) to https://
    if (url.startsWith('//')) url = 'https:' + url;
    const key = url + '|' + (scale || 1);
    if (this._texCache[key]) return this._texCache[key];
    try {
      const tex = new THREE.TextureLoader().load(url);
      tex.colorSpace = THREE.SRGBColorSpace;
      tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
      tex.repeat.set(scale || 1, scale || 1);
      this._texCache[key] = tex;
      return tex;
    } catch (e) {
      console.warn('[SceneMaterials] texture load failed', url, e);
      return null;
    }
  },
  // Same as _getTex but rotates the texture 90° around its center.
  // Used for corner blocks where the texture orientation on side faces is rotated.
  _getTexRotated(url, scale) {
    if (!url || !window.THREE) return null;
    if (url.startsWith('//')) url = 'https:' + url;
    const key = url + '|' + (scale || 1) + '|rot90';
    if (this._texCache[key]) return this._texCache[key];
    try {
      const tex = new THREE.TextureLoader().load(url);
      tex.colorSpace = THREE.SRGBColorSpace;
      tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
      tex.repeat.set(scale || 1, scale || 1);
      tex.center.set(0.5, 0.5);
      tex.rotation = Math.PI / 2;
      this._texCache[key] = tex;
      return tex;
    } catch (e) {
      console.warn('[SceneMaterials] rotated texture load failed', url, e);
      return null;
    }
  },
_make(type) {
    switch(type) {
      case 'ext': {
        const _texUrl = CONFIG.defaultTextures && CONFIG.defaultTextures.ext;
        const _tex = _texUrl ? this._getTex(_texUrl, (CONFIG.finishes?.scales?.ext) || 1) : null;
        return new THREE.MeshStandardMaterial({
          color: _tex ? new THREE.Color(0xffffff) : new THREE.Color(CONFIG.meshColors.ext),
          map: _tex || null,
          roughness: 0.85, metalness: 0,
          envMapIntensity: 0.4
        });
      }
      case 'ext-corner': {
        // Same as 'ext' but with texture rotated 90° — for corner blocks where the side faces
        // would otherwise show the texture rotated incorrectly.
        const _texUrl = CONFIG.defaultTextures && CONFIG.defaultTextures.ext;
        const _tex = _texUrl ? this._getTexRotated(_texUrl, (CONFIG.finishes?.scales?.ext) || 1) : null;
        return new THREE.MeshStandardMaterial({
          color: _tex ? new THREE.Color(0xffffff) : new THREE.Color(CONFIG.meshColors.ext),
          map: _tex || null,
          roughness: 0.85, metalness: 0,
          envMapIntensity: 0.4
        });
      }
      case 'roof': {
        const _texUrl = CONFIG.defaultTextures && CONFIG.defaultTextures.roof;
        const _tex = _texUrl ? this._getTex(_texUrl, (CONFIG.finishes?.scales?.roofs) || 1) : null;
        return new THREE.MeshStandardMaterial({
          color: _tex ? new THREE.Color(0xffffff) : new THREE.Color(CONFIG.meshColors.roof),
          map: _tex || null,
          roughness: 0.92, metalness: 0.02,
          envMapIntensity: 0.2,
          side: THREE.DoubleSide
        });
      }
      case 'floor':
        return new THREE.MeshStandardMaterial({
          color: new THREE.Color(CONFIG.meshColors.floor),
          roughness: 0.72, metalness: 0,
          envMapIntensity: 0.3
        });
      case 'int':
        return new THREE.MeshStandardMaterial({
          color: new THREE.Color('#ffffff'),
          roughness: 0.92, metalness: 0,
          envMapIntensity: 0.1
        });
      case 'win':
        return new THREE.MeshPhysicalMaterial({
          color: new THREE.Color('#ddeeff'),
          roughness: 0.05, metalness: 0.1,
          transmission: 0.88, thickness: 0.08,
          ior: 1.5, transparent: true,
          envMapIntensity: 1.2,
          side: THREE.DoubleSide
        });
      case 'idr':
        return new THREE.MeshStandardMaterial({
          color: new THREE.Color(CONFIG.meshColors.idr),
          roughness: 0.80, metalness: 0.05,
          envMapIntensity: 0.3
        });
      default:
        return new THREE.MeshStandardMaterial({
          color: 0xeeeeee, roughness: 0.85, metalness: 0
        });
    }
  },
  applyToGLB(root) {
    root.traverse(obj => {
      if (!obj.isMesh) return;
      const n = obj.name;
      let type = 'default';
      if      (pfxMatch(n, CONFIG.prefix.ext))       type = 'ext';
      else if (pfxMatch(n, CONFIG.prefix.roof))      type = 'roof';
      else if (pfxMatch(n, CONFIG.prefix.floor))     type = 'floor';
      else if (pfxMatch(n, CONFIG.prefix.win))       type = 'win';
      else if (pfxMatch(n, CONFIG.prefix.intDoor))   type = 'idr';
      else if (pfxMatch(n, CONFIG.prefix.partition)) type = 'int';
      if (obj.material) {
        if (Array.isArray(obj.material)) obj.material.forEach(m => m.dispose());
        else obj.material.dispose();
      }
      obj.material = this._make(type);
      obj.castShadow = true;
      obj.receiveShadow = true;
    });
  },
  setColor(meshes, hexColor) {
    meshes.forEach(m => {
      if (!m.material) return;
      m.material.map = null;
      m.material.color.set(hexColor);
      m.material.needsUpdate = true;
    });
  },
  setTexture(meshes, texUrl, scale) {
    const tl = new THREE.TextureLoader();
    tl.load(texUrl, tex => {
      tex.colorSpace = THREE.SRGBColorSpace;
      tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
      tex.repeat.set(scale, scale);
      meshes.forEach(m => {
        if (!m.material) return;
        m.material.map = tex;
        m.material.color.set(0xffffff);
        m.material.needsUpdate = true;
      });
    });
  }
};

// ── _rebuildIntPartsForRoof moved from cfg.liquid (size budget) ──
window._rebuildIntPartsForRoof = function(){
    const origH = (typeof ExtWallParser !== 'undefined' && ExtWallParser._origH) || {};
    function _computeNewH(p_mesh, fl, defaultH){
      let newH = STATE.floorHeights[fl]!=null ? STATE.floorHeights[fl]/1000 : defaultH;
      if(!newH) return null;
      const _intBaseY = (typeof ExtWallParser !== 'undefined' && ExtWallParser._targetBaseY) ? (ExtWallParser._targetBaseY[fl]??0) : 0;
      if(RoofBuilder._roofType==='flat'){
        const r=(STATE.extFloorRanges||{})[fl]||{};
        if(r.max!==undefined){
          const atikaH=RoofBuilder._hasAtika?0.300:0;
          newH=Math.min(newH,Math.max(0.1,r.max-_intBaseY-atikaH));
        }
      } else if(RoofBuilder._roofType==='flat2'){
        const _allRY=(RoofBuilder._origVerts||[]).map(v=>v.y+(RoofBuilder._yOffset||0));
        const _ridgeY=_allRY.length?Math.max(..._allRY):(_intBaseY+newH);
        newH=Math.max(newH,Math.max(0.05,_ridgeY-_intBaseY));
      } else if(RoofBuilder._roofType==='gable'||RoofBuilder._roofType==='hip'){
        const _cx=p_mesh.position.x, _cz=p_mesh.position.z;
        const _nearGew=(STATE.virtualOpenings||[]).some(vo=>{
          if(!vo._isGew||vo.wallType!=='ext') return false;
          const _corners=(STATE.extCorners||{})[vo.fl]||[];
          const _cA=_corners[vo.wallIdx],_cB=_corners[(vo.wallIdx+1)%_corners.length];
          if(!_cA||!_cB) return false;
          const _wdx=_cB.x-_cA.x,_wdz=_cB.z-_cA.z,_wlen=Math.sqrt(_wdx*_wdx+_wdz*_wdz)||1;
          const _nx=-_wdz/_wlen,_nz=_wdx/_wlen;
          const _dist=Math.abs((_cx-_cA.x)*_nx+(_cz-_cA.z)*_nz);
          return _dist<0.5;
        });
        const _allRY=(RoofBuilder._origVerts||[]).map(v=>v.y+(RoofBuilder._yOffset||0));
        const _ridgeY=_allRY.length?Math.max(..._allRY):(_intBaseY+newH);
        newH=Math.max(newH,Math.max(0.05,_ridgeY-_intBaseY));
      }
      return {newH:newH, _intBaseY:_intBaseY};
    }
    function _applyToWall(p, defaultH){
      if(!p.mesh) return;
      const fl=p.mesh.userData.floorNum??1;
      const r = _computeNewH(p.mesh, fl, defaultH);
      if(!r) return;
      const ud=p.mesh.userData;
      ud.wallH=r.newH;
      p.heightM=r.newH;
      // Only rebuild geometry if it was already BoxGeometry. BufferGeometry (from _cutIdrHoles) is preserved — _rebuildHolesForPart runs after.
      if(p.mesh.geometry?.parameters?.height !== undefined){
        const _w = ud.w || p.mesh.geometry.parameters?.width || 0.1;
        const _d = ud.d || p.mesh.geometry.parameters?.depth || 0.1;
        p.mesh.geometry.dispose();
        p.mesh.geometry=new THREE.BoxGeometry(_w, r.newH, _d);
        p.mesh.position.y=r._intBaseY+r.newH/2;
      }
      const _intClip=(RoofBuilder._roofType==='gable'||RoofBuilder._roofType==='hip'||(RoofBuilder._roofType==='flat2'&&(RoofBuilder._facePolygons||[]).length))?(RoofBuilder._roofUndersideClipPlanes||RoofBuilder._roofClipPlanes||[]):[];
      if(_intClip.length){p.mesh.material.clippingPlanes=_intClip;p.mesh.material.clipShadows=false;p.mesh.material.needsUpdate=true;p.mesh.castShadow=false;}
      else{p.mesh.material.clippingPlanes=[];p.mesh.material.needsUpdate=true;p.mesh.castShadow=true;}
    }
    if(typeof IntWallParser !== 'undefined' && IntWallParser._parts){
      IntWallParser._parts.forEach(p=>{
        _applyToWall(p, origH[p.mesh?.userData?.floorNum??1]||1);
        if(window.IntWallParser?._rebuildHolesForPart) window.IntWallParser._rebuildHolesForPart(p);
      });
    }
    if(typeof IntPartitionParser !== 'undefined' && IntPartitionParser._partitions){
      IntPartitionParser._partitions.forEach(p=>{
        _applyToWall(p, p.heightM||1);
      });
    }
    if(window.OpeningMeshBuilder) window.OpeningMeshBuilder.rebuildIwOpenings?.();
  };